export class DictionaryPersonName {
    russian: string;
    latin: string | null;
    sex: number;
}

export class PersonNameDictionary {
    public static firstNames: DictionaryPersonName[] = [
        { russian: 'АБАКУМ', latin: null, sex: 0 },
        { russian: 'АБДУЛЛА', latin: null, sex: 0 },
        { russian: 'АБДУЛЛАХ', latin: null, sex: 0 },
        { russian: 'АБДУРАХМАН', latin: null, sex: 0 },
        { russian: 'АБРАМ', latin: null, sex: 0 },
        { russian: 'АБРОСИМ', latin: null, sex: 0 },
        { russian: 'АБУБАКАР', latin: null, sex: 0 },
        { russian: 'АВВАКУМ', latin: null, sex: 0 },
        { russian: 'АВГУСТ', latin: null, sex: 0 },
        { russian: 'АВДЕЙ', latin: null, sex: 0 },
        { russian: 'АВДИЙ', latin: null, sex: 0 },
        { russian: 'АВЕЛЬ', latin: null, sex: 0 },
        { russian: 'АВЕНИР', latin: null, sex: 0 },
        { russian: 'АВЕРИЙ', latin: null, sex: 0 },
        { russian: 'АВЕРКИЙ', latin: null, sex: 0 },
        { russian: 'АВЕРЬЯН', latin: null, sex: 0 },
        { russian: 'АВКСЕНТИЙ', latin: null, sex: 0 },
        { russian: 'АВРААМ', latin: null, sex: 0 },
        { russian: 'АВРААМИЙ', latin: null, sex: 0 },
        { russian: 'АВРАМ', latin: null, sex: 0 },
        { russian: 'АВРАМИЙ', latin: null, sex: 0 },
        { russian: 'АВРЕЛИАН', latin: null, sex: 0 },
        { russian: 'АВТАНДИЛ', latin: null, sex: 0 },
        { russian: 'АВТОНОМ', latin: null, sex: 0 },
        { russian: 'АГАП', latin: null, sex: 0 },
        { russian: 'АГАПИЙ', latin: null, sex: 0 },
        { russian: 'АГАПИТ', latin: null, sex: 0 },
        { russian: 'АГАФОН', latin: 'AGAFON', sex: 0 },
        { russian: 'АГГЕЙ', latin: null, sex: 0 },
        { russian: 'АДАМ', latin: null, sex: 0 },
        { russian: 'АДЛАН', latin: null, sex: 0 },
        { russian: 'АДОЛЬФ', latin: null, sex: 0 },
        { russian: 'АДРИАН', latin: null, sex: 0 },
        { russian: 'АЗАМАТ', latin: null, sex: 0 },
        { russian: 'АЗАР', latin: null, sex: 0 },
        { russian: 'АЗАРИЙ', latin: null, sex: 0 },
        { russian: 'АЗАТ', latin: null, sex: 0 },
        { russian: 'АЗИЗ', latin: null, sex: 0 },
        { russian: 'АЙДАР', latin: null, sex: 0 },
        { russian: 'АЙК', latin: null, sex: 0 },
        { russian: 'АЙРАТ', latin: null, sex: 0 },
        { russian: 'АКАКИЙ', latin: null, sex: 0 },
        { russian: 'АКИМ', latin: 'AKIM', sex: 0 },
        { russian: 'АКИНДИН', latin: null, sex: 0 },
        { russian: 'АКИНФ', latin: null, sex: 0 },
        { russian: 'АКИНФИЙ', latin: null, sex: 0 },
        { russian: 'АКМАЛ', latin: null, sex: 0 },
        { russian: 'АКОП', latin: null, sex: 0 },
        { russian: 'АКРАМ', latin: null, sex: 0 },
        { russian: 'АКСЁН', latin: null, sex: 0 },
        { russian: 'АКСЕНТИЙ', latin: null, sex: 0 },
        { russian: 'АЛАН', latin: null, sex: 0 },
        { russian: 'АЛЕКС', latin: null, sex: 0 },
        { russian: 'АЛЕКСАНДЕР', latin: null, sex: 0 },
        { russian: 'АЛЕКСАНДР', latin: 'ALEXANDER', sex: 0 },
        { russian: 'АЛЕКСАНДРОС', latin: null, sex: 0 },
        { russian: 'АЛЕКСАНДЪР', latin: null, sex: 0 },
        { russian: 'АЛЕКСЕЙ', latin: 'ALEXEY', sex: 0 },
        { russian: 'АЛЕКСИЙ', latin: null, sex: 0 },
        { russian: 'АЛЕН', latin: null, sex: 0 },
        { russian: 'АЛИ', latin: null, sex: 0 },
        { russian: 'АЛИК', latin: null, sex: 0 },
        { russian: 'АЛИМ', latin: null, sex: 0 },
        { russian: 'АЛИХАН', latin: null, sex: 0 },
        { russian: 'АЛИШЕР', latin: null, sex: 0 },
        { russian: 'АЛЬБЕРТ', latin: null, sex: 0 },
        { russian: 'АЛЬФРЕД', latin: null, sex: 0 },
        { russian: 'АМВРОСИЙ', latin: null, sex: 0 },
        { russian: 'АМИН', latin: null, sex: 0 },
        { russian: 'АМИР', latin: null, sex: 0 },
        { russian: 'АМОС', latin: null, sex: 0 },
        { russian: 'АМФИЛОХИЙ', latin: null, sex: 0 },
        { russian: 'АНАНИЙ', latin: null, sex: 0 },
        { russian: 'АНАСТАС', latin: null, sex: 0 },
        { russian: 'АНАСТАСИЙ', latin: null, sex: 0 },
        { russian: 'АНАТОЛИЙ', latin: 'ANATOLY', sex: 0 },
        { russian: 'АНВАР', latin: null, sex: 0 },
        { russian: 'АНДРАНИК', latin: null, sex: 0 },
        { russian: 'АНДРЕ', latin: null, sex: 0 },
        { russian: 'АНДРЕАС', latin: null, sex: 0 },
        { russian: 'АНДРЕЙ', latin: 'ANDREY', sex: 0 },
        { russian: 'АНДРИАН', latin: null, sex: 0 },
        { russian: 'АНДРОН', latin: null, sex: 0 },
        { russian: 'АНДРОНИЙ', latin: null, sex: 0 },
        { russian: 'АНДРОНИК', latin: null, sex: 0 },
        { russian: 'АНЗОР', latin: null, sex: 0 },
        { russian: 'АНИКЕЙ', latin: null, sex: 0 },
        { russian: 'АНИКИЙ', latin: null, sex: 0 },
        { russian: 'АНИКИТА', latin: null, sex: 0 },
        { russian: 'АНИСИЙ', latin: 'ANISY', sex: 0 },
        { russian: 'АНИСИМ', latin: null, sex: 0 },
        { russian: 'АНТИОХ', latin: null, sex: 0 },
        { russian: 'АНТИП', latin: null, sex: 0 },
        { russian: 'АНТИПА', latin: null, sex: 0 },
        { russian: 'АНТИПИЙ', latin: null, sex: 0 },
        { russian: 'АНТОН', latin: 'ANTON', sex: 0 },
        { russian: 'АНТОНИН', latin: null, sex: 0 },
        { russian: 'АНТРОП', latin: null, sex: 0 },
        { russian: 'АНТРОПИЙ', latin: null, sex: 0 },
        { russian: 'АНУФРИЙ', latin: null, sex: 0 },
        { russian: 'АПОЛЛИНАРИЙ', latin: null, sex: 0 },
        { russian: 'АПОЛЛОН', latin: null, sex: 0 },
        { russian: 'АПОЛЛОС', latin: null, sex: 0 },
        { russian: 'АПТИ', latin: null, sex: 0 },
        { russian: 'АРА', latin: null, sex: 0 },
        { russian: 'АРАИК', latin: null, sex: 0 },
        { russian: 'АРАМ', latin: null, sex: 0 },
        { russian: 'АРАРАТ', latin: null, sex: 0 },
        { russian: 'АРБИ', latin: null, sex: 0 },
        { russian: 'АРДАЛИОН', latin: null, sex: 0 },
        { russian: 'АРДАЛЬОН', latin: null, sex: 0 },
        { russian: 'АРЕФ', latin: null, sex: 0 },
        { russian: 'АРЕФИЙ', latin: null, sex: 0 },
        { russian: 'АРИЙ', latin: null, sex: 0 },
        { russian: 'АРИСТАРХ', latin: null, sex: 0 },
        { russian: 'АРИСТИД', latin: null, sex: 0 },
        { russian: 'АРИФ', latin: null, sex: 0 },
        { russian: 'АРКАДИЙ', latin: null, sex: 0 },
        { russian: 'АРМАН', latin: null, sex: 0 },
        { russian: 'АРМЕН', latin: null, sex: 0 },
        { russian: 'АРНОЛЬД', latin: null, sex: 0 },
        { russian: 'АРОН', latin: null, sex: 0 },
        { russian: 'АРСЕН', latin: null, sex: 0 },
        { russian: 'АРСЕНИЙ', latin: null, sex: 0 },
        { russian: 'АРСЕНТИЙ', latin: 'ARSENTY', sex: 0 },
        { russian: 'АРСЛАН', latin: null, sex: 0 },
        { russian: 'АРТАК', latin: null, sex: 0 },
        { russian: 'АРТАМОН', latin: null, sex: 0 },
        { russian: 'АРТАШЕС', latin: null, sex: 0 },
        { russian: 'АРТЕМ', latin: null, sex: 0 },
        { russian: 'АРТЁМ', latin: null, sex: 0 },
        { russian: 'АРТЕМИЙ', latin: null, sex: 0 },
        { russian: 'АРТУР', latin: null, sex: 0 },
        { russian: 'АРУТЮН', latin: null, sex: 0 },
        { russian: 'АРХИП', latin: 'ARKHIP', sex: 0 },
        { russian: 'АРШАК', latin: null, sex: 0 },
        { russian: 'АСАФ', latin: null, sex: 0 },
        { russian: 'АСАФИЙ', latin: null, sex: 0 },
        { russian: 'АСКАР', latin: null, sex: 0 },
        { russian: 'АСКОЛЬД', latin: null, sex: 0 },
        { russian: 'АСЛАМБЕК', latin: null, sex: 0 },
        { russian: 'АСЛАН', latin: null, sex: 0 },
        { russian: 'АСЛАНБЕК', latin: null, sex: 0 },
        { russian: 'АСХАБ', latin: null, sex: 0 },
        { russian: 'АФАНАСИЙ', latin: 'AFANASY', sex: 0 },
        { russian: 'АФИНОГЕН', latin: null, sex: 0 },
        { russian: 'АФРИКАН', latin: null, sex: 0 },
        { russian: 'АХМАД', latin: null, sex: 0 },
        { russian: 'АХМЕД', latin: null, sex: 0 },
        { russian: 'АХМЕТ', latin: null, sex: 0 },
        { russian: 'АШОТ', latin: null, sex: 0 },
        { russian: 'АЮБ', latin: null, sex: 0 },
        { russian: 'БАГРАТ', latin: null, sex: 0 },
        { russian: 'БАЙРАМ', latin: null, sex: 0 },
        { russian: 'БАТЫР', latin: null, sex: 0 },
        { russian: 'БАХОДУР', latin: null, sex: 0 },
        { russian: 'БАХТИЁР', latin: null, sex: 0 },
        { russian: 'БАХТИЯР', latin: null, sex: 0 },
        { russian: 'БЕКХАН', latin: null, sex: 0 },
        { russian: 'БЕНЕДИКТ', latin: null, sex: 0 },
        { russian: 'БЕСЛАН', latin: null, sex: 0 },
        { russian: 'БЕХРУЗ', latin: null, sex: 0 },
        { russian: 'БИЛАЛ', latin: null, sex: 0 },
        { russian: 'БИСЛАН', latin: null, sex: 0 },
        { russian: 'БОГДАН', latin: null, sex: 0 },
        { russian: 'БОЛЕСЛАВ', latin: null, sex: 0 },
        { russian: 'БОНИФАТ', latin: null, sex: 0 },
        { russian: 'БОНИФАТИЙ', latin: null, sex: 0 },
        { russian: 'БОРИС', latin: 'BORIS', sex: 0 },
        { russian: 'БОРИСЛАВ', latin: null, sex: 0 },
        { russian: 'БРОНИСЛАВ', latin: null, sex: 0 },
        { russian: 'БУЛАТ', latin: null, sex: 0 },
        { russian: 'ВААГН', latin: null, sex: 0 },
        { russian: 'ВАВИЛА', latin: null, sex: 0 },
        { russian: 'ВАГАН', latin: null, sex: 0 },
        { russian: 'ВАГЕ', latin: null, sex: 0 },
        { russian: 'ВАГИФ', latin: null, sex: 0 },
        { russian: 'ВАДИМ', latin: null, sex: 0 },
        { russian: 'ВАЗГЕН', latin: null, sex: 0 },
        { russian: 'ВАЛЕНТИН', latin: 'VALENTIN', sex: 0 },
        { russian: 'ВАЛЕРИАН', latin: 'VALERIAN', sex: 0 },
        { russian: 'ВАЛЕРИЙ', latin: null, sex: 0 },
        { russian: 'ВАЛЕРЬЯН', latin: null, sex: 0 },
        { russian: 'ВАЛИД', latin: null, sex: 0 },
        { russian: 'ВАЛЬДЕМАР', latin: null, sex: 0 },
        { russian: 'ВАЛЬТЕР', latin: null, sex: 0 },
        { russian: 'ВАРД', latin: null, sex: 0 },
        { russian: 'ВАРДАН', latin: null, sex: 0 },
        { russian: 'ВАРЛАМ', latin: null, sex: 0 },
        { russian: 'ВАРЛАМИЙ', latin: null, sex: 0 },
        { russian: 'ВАРНАВА', latin: null, sex: 0 },
        { russian: 'ВАРСОНОФ', latin: null, sex: 0 },
        { russian: 'ВАРСОНОФИЙ', latin: null, sex: 0 },
        { russian: 'ВАРТАН', latin: null, sex: 0 },
        { russian: 'ВАРФОЛОМЕЙ', latin: null, sex: 0 },
        { russian: 'ВАСИЛИЙ', latin: 'VASILY', sex: 0 },
        { russian: 'ВАССИАН', latin: null, sex: 0 },
        { russian: 'ВАХА', latin: null, sex: 0 },
        { russian: 'ВАХИД', latin: null, sex: 0 },
        { russian: 'ВАХТАНГ', latin: null, sex: 0 },
        { russian: 'ВЕЛИЗАР', latin: null, sex: 0 },
        { russian: 'ВЕЛИМИР', latin: null, sex: 0 },
        { russian: 'ВЕНЕДИКТ', latin: null, sex: 0 },
        { russian: 'ВЕНИАМИН', latin: null, sex: 0 },
        { russian: 'ВЕНЦЕСЛАВ', latin: null, sex: 0 },
        { russian: 'ВЕНЬЯМИН', latin: null, sex: 0 },
        { russian: 'ВИКЕНТИЙ', latin: null, sex: 0 },
        { russian: 'ВИКТОР', latin: 'VICTOR', sex: 0 },
        { russian: 'ВИКТОРИЙ', latin: null, sex: 0 },
        { russian: 'ВИКУЛ', latin: null, sex: 0 },
        { russian: 'ВИКУЛА', latin: null, sex: 0 },
        { russian: 'ВИЛЕН', latin: null, sex: 0 },
        { russian: 'ВИЛЛИ', latin: null, sex: 0 },
        { russian: 'ВИЛЬГЕЛЬМ', latin: null, sex: 0 },
        { russian: 'ВИССАРИОН', latin: null, sex: 0 },
        { russian: 'ВИТАЛИ', latin: null, sex: 0 },
        { russian: 'ВИТАЛИЙ', latin: 'VITALY', sex: 0 },
        { russian: 'ВИТОЛЬД', latin: null, sex: 0 },
        { russian: 'ВЛАДИЛЕН', latin: null, sex: 0 },
        { russian: 'ВЛАДИМИР', latin: 'VLADIMIR', sex: 0 },
        { russian: 'ВЛАДИСЛАВ', latin: null, sex: 0 },
        { russian: 'ВЛАДЛЕН', latin: null, sex: 0 },
        { russian: 'ВЛАС', latin: 'VLAS', sex: 0 },
        { russian: 'ВЛАСИЙ', latin: null, sex: 0 },
        { russian: 'ВОЛЬДЕМАР', latin: null, sex: 0 },
        { russian: 'ВОНИФАТ', latin: null, sex: 0 },
        { russian: 'ВОНИФАТИЙ', latin: null, sex: 0 },
        { russian: 'ВСЕВОЛОД', latin: null, sex: 0 },
        { russian: 'ВСЕСЛАВ', latin: null, sex: 0 },
        { russian: 'ВУКОЛ', latin: null, sex: 0 },
        { russian: 'ВЫШЕСЛАВ', latin: null, sex: 0 },
        { russian: 'ВЯЧЕСЛАВ', latin: 'VIACHESLAV', sex: 0 },
        { russian: 'ГАВРИИЛ', latin: 'GAVRIIL', sex: 0 },
        { russian: 'ГАВРИЛА', latin: null, sex: 0 },
        { russian: 'ГАГИК', latin: null, sex: 0 },
        { russian: 'ГАЙК', latin: null, sex: 0 },
        { russian: 'ГАЛАКТИОН', latin: null, sex: 0 },
        { russian: 'ГАМЛЕТ', latin: null, sex: 0 },
        { russian: 'ГАРИК', latin: null, sex: 0 },
        { russian: 'ГАРРИ', latin: null, sex: 0 },
        { russian: 'ГЕВОРГ', latin: null, sex: 0 },
        { russian: 'ГЕВОРК', latin: null, sex: 0 },
        { russian: 'ГЕДЕОН', latin: null, sex: 0 },
        { russian: 'ГЕЛАСИЙ', latin: null, sex: 0 },
        { russian: 'ГЕЛИЙ', latin: null, sex: 0 },
        { russian: 'ГЕНАДИЙ', latin: null, sex: 0 },
        { russian: 'ГЕННАДИЙ', latin: 'GENNADY', sex: 0 },
        { russian: 'ГЕНРИХ', latin: null, sex: 0 },
        { russian: 'ГЕОРГ', latin: null, sex: 0 },
        { russian: 'ГЕОРГИ', latin: null, sex: 0 },
        { russian: 'ГЕОРГИЙ', latin: 'GEORGY', sex: 0 },
        { russian: 'ГЕОРГИОС', latin: null, sex: 0 },
        { russian: 'ГЕРАСИМ', latin: 'GERASIM', sex: 0 },
        { russian: 'ГЕРМАН', latin: null, sex: 0 },
        { russian: 'ГЕРМОГЕН', latin: null, sex: 0 },
        { russian: 'ГЕРОНТИЙ', latin: null, sex: 0 },
        { russian: 'ГИАЦИНТ', latin: null, sex: 0 },
        { russian: 'ГИВИ', latin: null, sex: 0 },
        { russian: 'ГЛЕБ', latin: 'GLEB', sex: 0 },
        { russian: 'ГОР', latin: null, sex: 0 },
        { russian: 'ГОРАЦИЙ', latin: null, sex: 0 },
        { russian: 'ГОРГОНИЙ', latin: null, sex: 0 },
        { russian: 'ГОРДЕЙ', latin: null, sex: 0 },
        { russian: 'ГРАНТ', latin: null, sex: 0 },
        { russian: 'ГРИГОР', latin: null, sex: 0 },
        { russian: 'ГРИГОРИЙ', latin: 'GRIGORY', sex: 0 },
        { russian: 'ГУРГЕН', latin: null, sex: 0 },
        { russian: 'ГУРИЙ', latin: null, sex: 0 },
        { russian: 'ГУРЬЯН', latin: null, sex: 0 },
        { russian: 'ГУСТАВ', latin: null, sex: 0 },
        { russian: 'ДАВИД', latin: null, sex: 0 },
        { russian: 'ДАВИТ', latin: null, sex: 0 },
        { russian: 'ДАВЫД', latin: null, sex: 0 },
        { russian: 'ДАЛЕР', latin: null, sex: 0 },
        { russian: 'ДАЛМАТ', latin: null, sex: 0 },
        { russian: 'ДАМИР', latin: null, sex: 0 },
        { russian: 'ДАНИЕЛ', latin: null, sex: 0 },
        { russian: 'ДАНИЕЛЬ', latin: null, sex: 0 },
        { russian: 'ДАНИИЛ', latin: 'DANIIL', sex: 0 },
        { russian: 'ДАНИЛ', latin: null, sex: 0 },
        { russian: 'ДАНИЛА', latin: null, sex: 0 },
        { russian: 'ДАНИЭЛ', latin: null, sex: 0 },
        { russian: 'ДЕМЕНТИЙ', latin: null, sex: 0 },
        { russian: 'ДЕМИД', latin: null, sex: 0 },
        { russian: 'ДЕМЬЯН', latin: null, sex: 0 },
        { russian: 'ДЕНИ', latin: null, sex: 0 },
        { russian: 'ДЕНИС', latin: 'DENIS', sex: 0 },
        { russian: 'ДЕНИСИЙ', latin: null, sex: 0 },
        { russian: 'ДЕННИС', latin: null, sex: 0 },
        { russian: 'ДЖАБРАИЛ', latin: null, sex: 0 },
        { russian: 'ДЖАМБУЛАТ', latin: null, sex: 0 },
        { russian: 'ДЖАМШЕД', latin: null, sex: 0 },
        { russian: 'ДЖОРДЖ', latin: null, sex: 0 },
        { russian: 'ДИЛШОД', latin: null, sex: 0 },
        { russian: 'ДИМИТРИ', latin: null, sex: 0 },
        { russian: 'ДИМИТРИЙ', latin: 'DIMITRY', sex: 0 },
        { russian: 'ДИМИТРИОС', latin: null, sex: 0 },
        { russian: 'ДИМИТЪР', latin: null, sex: 0 },
        { russian: 'ДИОМИД', latin: null, sex: 0 },
        { russian: 'ДИОНИС', latin: null, sex: 0 },
        { russian: 'ДИОНИСИЙ', latin: null, sex: 0 },
        { russian: 'ДМИТРИЙ', latin: 'DMITRY', sex: 0 },
        { russian: 'ДОБРОМЫСЛ', latin: null, sex: 0 },
        { russian: 'ДОБРЫНЯ', latin: null, sex: 0 },
        { russian: 'ДОМИНИК', latin: null, sex: 0 },
        { russian: 'ДОНАТ', latin: null, sex: 0 },
        { russian: 'ДОРИМЕДОНТ', latin: null, sex: 0 },
        { russian: 'ДОРМЕДОНТ', latin: null, sex: 0 },
        { russian: 'ДОРМИДОНТ', latin: null, sex: 0 },
        { russian: 'ДОРОФЕЙ', latin: null, sex: 0 },
        { russian: 'ДОСИФЕЙ', latin: null, sex: 0 },
        { russian: 'ДЭВИД', latin: null, sex: 0 },
        { russian: 'ЕВГЕНИЙ', latin: 'EVGENY', sex: 0 },
        { russian: 'ЕВГРАФ', latin: null, sex: 0 },
        { russian: 'ЕВГРАФИЙ', latin: null, sex: 0 },
        { russian: 'ЕВДОКИМ', latin: 'EVDOKIM', sex: 0 },
        { russian: 'ЕВЛАМПИЙ', latin: null, sex: 0 },
        { russian: 'ЕВЛОГИЙ', latin: null, sex: 0 },
        { russian: 'ЕВМЕН', latin: null, sex: 0 },
        { russian: 'ЕВМЕНИЙ', latin: null, sex: 0 },
        { russian: 'ЕВСЕЙ', latin: null, sex: 0 },
        { russian: 'ЕВСТАФИЙ', latin: null, sex: 0 },
        { russian: 'ЕВСТАХИЙ', latin: null, sex: 0 },
        { russian: 'ЕВСТИГНЕЙ', latin: null, sex: 0 },
        { russian: 'ЕВСТРАТ', latin: null, sex: 0 },
        { russian: 'ЕВСТРАТИЙ', latin: null, sex: 0 },
        { russian: 'ЕВТИХИЙ', latin: null, sex: 0 },
        { russian: 'ЕВФИМИЙ', latin: null, sex: 0 },
        { russian: 'ЕГОР', latin: null, sex: 0 },
        { russian: 'ЕГОРИЙ', latin: null, sex: 0 },
        { russian: 'ЕЛИЗАР', latin: null, sex: 0 },
        { russian: 'ЕЛИСЕЙ', latin: null, sex: 0 },
        { russian: 'ЕЛИСТРАТ', latin: null, sex: 0 },
        { russian: 'ЕЛПИДИФОР', latin: null, sex: 0 },
        { russian: 'ЕМЕЛЬЯН', latin: 'EMELIAN', sex: 0 },
        { russian: 'ЕПИФАН', latin: null, sex: 0 },
        { russian: 'ЕПИФАНИЙ', latin: null, sex: 0 },
        { russian: 'ЕРЕМЕЙ', latin: null, sex: 0 },
        { russian: 'ЕРМИЙ', latin: null, sex: 0 },
        { russian: 'ЕРМИЛ', latin: null, sex: 0 },
        { russian: 'ЕРМИЛА', latin: null, sex: 0 },
        { russian: 'ЕРМИЛИЙ', latin: null, sex: 0 },
        { russian: 'ЕРМОЛАЙ', latin: 'ERMOLAY', sex: 0 },
        { russian: 'ЕРОФЕЙ', latin: null, sex: 0 },
        { russian: 'ЕФИМ', latin: 'EFIM', sex: 0 },
        { russian: 'ЕФИМИЙ', latin: null, sex: 0 },
        { russian: 'ЕФРЕМ', latin: 'EFREM', sex: 0 },
        { russian: 'ЕФРЕМИЙ', latin: null, sex: 0 },
        { russian: 'ЗАУР', latin: null, sex: 0 },
        { russian: 'ЗАУРБЕК', latin: null, sex: 0 },
        { russian: 'ЗАФАР', latin: null, sex: 0 },
        { russian: 'ЗАХАР', latin: 'ZAKHAR', sex: 0 },
        { russian: 'ЗАХАРИЙ', latin: null, sex: 0 },
        { russian: 'ЗЕЛИМХАН', latin: null, sex: 0 },
        { russian: 'ЗЕНОН', latin: null, sex: 0 },
        { russian: 'ЗИНОВИЙ', latin: 'ZINOVY', sex: 0 },
        { russian: 'ЗОСИМ', latin: null, sex: 0 },
        { russian: 'ЗОСИМА', latin: null, sex: 0 },
        { russian: 'ЗУРАБ', latin: null, sex: 0 },
        { russian: 'ИАКИМ', latin: null, sex: 0 },
        { russian: 'ИАКИНФ', latin: null, sex: 0 },
        { russian: 'ИБРАГИМ', latin: null, sex: 0 },
        { russian: 'ИБРАХИМ', latin: null, sex: 0 },
        { russian: 'ИВАН', latin: 'IVAN', sex: 0 },
        { russian: 'ИГНАТ', latin: 'IGNAT', sex: 0 },
        { russian: 'ИГНАТИЙ', latin: null, sex: 0 },
        { russian: 'ИГОРЬ', latin: 'IGOR', sex: 0 },
        { russian: 'ИДРИС', latin: null, sex: 0 },
        { russian: 'ИЕРОНИМ', latin: null, sex: 0 },
        { russian: 'ИЗМАИЛ', latin: null, sex: 0 },
        { russian: 'ИЗОСИМ', latin: null, sex: 0 },
        { russian: 'ИЗОТ', latin: null, sex: 0 },
        { russian: 'ИЗЯСЛАВ', latin: null, sex: 0 },
        { russian: 'ИЛАРИОН', latin: null, sex: 0 },
        { russian: 'ИЛИОДОР', latin: null, sex: 0 },
        { russian: 'ИЛЛАРИОН', latin: null, sex: 0 },
        { russian: 'ИЛХОМ', latin: null, sex: 0 },
        { russian: 'ИЛЬДАР', latin: null, sex: 0 },
        { russian: 'ИЛЬЯ', latin: 'ILYA', sex: 0 },
        { russian: 'ИЛЬЯС', latin: null, sex: 0 },
        { russian: 'ИМРАН', latin: null, sex: 0 },
        { russian: 'ИНАЛ', latin: null, sex: 0 },
        { russian: 'ИННОКЕНТИЙ', latin: null, sex: 0 },
        { russian: 'ИОАНН', latin: null, sex: 0 },
        { russian: 'ИОАННИС', latin: null, sex: 0 },
        { russian: 'ИОВ', latin: null, sex: 0 },
        { russian: 'ИОНА', latin: null, sex: 0 },
        { russian: 'ИОСАФАТ', latin: null, sex: 0 },
        { russian: 'ИОСИФ', latin: 'IOSIF', sex: 0 },
        { russian: 'ИПАТ', latin: null, sex: 0 },
        { russian: 'ИПАТИЙ', latin: null, sex: 0 },
        { russian: 'ИППОЛИТ', latin: null, sex: 0 },
        { russian: 'ИРАКЛИЙ', latin: null, sex: 0 },
        { russian: 'ИРИНАРХ', latin: null, sex: 0 },
        { russian: 'ИРИНЕЙ', latin: null, sex: 0 },
        { russian: 'ИСА', latin: null, sex: 0 },
        { russian: 'ИСААК', latin: null, sex: 0 },
        { russian: 'ИСААКИЙ', latin: null, sex: 0 },
        { russian: 'ИСАЙ', latin: null, sex: 0 },
        { russian: 'ИСАК', latin: null, sex: 0 },
        { russian: 'ИСАКИЙ', latin: null, sex: 0 },
        { russian: 'ИСИДОР', latin: null, sex: 0 },
        { russian: 'ИСКАНДАР', latin: null, sex: 0 },
        { russian: 'ИСКАНДЕР', latin: null, sex: 0 },
        { russian: 'ИСЛАМ', latin: null, sex: 0 },
        { russian: 'ИСМАИЛ', latin: null, sex: 0 },
        { russian: 'ИУСТИН', latin: null, sex: 0 },
        { russian: 'ЙОХАНН', latin: null, sex: 0 },
        { russian: 'ЙОХАННЕС', latin: null, sex: 0 },
        { russian: 'КАЗБЕК', latin: null, sex: 0 },
        { russian: 'КАЗИМИР', latin: null, sex: 0 },
        { russian: 'КАЛЛИНИК', latin: null, sex: 0 },
        { russian: 'КАЛЛИСТ', latin: null, sex: 0 },
        { russian: 'КАЛЛИСТРАТ', latin: null, sex: 0 },
        { russian: 'КАМИЛЬ', latin: null, sex: 0 },
        { russian: 'КАПИТОН', latin: null, sex: 0 },
        { russian: 'КАРАПЕТ', latin: null, sex: 0 },
        { russian: 'КАРЕН', latin: null, sex: 0 },
        { russian: 'КАРИМ', latin: null, sex: 0 },
        { russian: 'КАРИОН', latin: null, sex: 0 },
        { russian: 'КАРЛ', latin: null, sex: 0 },
        { russian: 'КАРП', latin: null, sex: 0 },
        { russian: 'КАСЬЯН', latin: null, sex: 0 },
        { russian: 'КЕВИН', latin: null, sex: 0 },
        { russian: 'КЕРИМ', latin: null, sex: 0 },
        { russian: 'КИМ', latin: null, sex: 0 },
        { russian: 'КИПРИАН', latin: null, sex: 0 },
        { russian: 'КИР', latin: null, sex: 0 },
        { russian: 'КИРИАК', latin: null, sex: 0 },
        { russian: 'КИРИК', latin: null, sex: 0 },
        { russian: 'КИРИЛЛ', latin: 'KIRILL', sex: 0 },
        { russian: 'КИРСАН', latin: null, sex: 0 },
        { russian: 'КИРЬЯК', latin: null, sex: 0 },
        { russian: 'КЛАВДИЙ', latin: null, sex: 0 },
        { russian: 'КЛЕМЕНТИЙ', latin: null, sex: 0 },
        { russian: 'КЛИМ', latin: null, sex: 0 },
        { russian: 'КЛИМЕНТ', latin: null, sex: 0 },
        { russian: 'КЛИМЕНТИЙ', latin: null, sex: 0 },
        { russian: 'КОНДРАТ', latin: null, sex: 0 },
        { russian: 'КОНДРАТИЙ', latin: null, sex: 0 },
        { russian: 'КОНОН', latin: null, sex: 0 },
        { russian: 'КОНРАД', latin: null, sex: 0 },
        { russian: 'КОНСТАНТИН', latin: 'KONSTANTIN', sex: 0 },
        { russian: 'КОНСТАНТИНОС', latin: null, sex: 0 },
        { russian: 'КОРНЕЙ', latin: null, sex: 0 },
        { russian: 'КОРНЕЛИЙ', latin: null, sex: 0 },
        { russian: 'КОРНИЛ', latin: null, sex: 0 },
        { russian: 'КОРНИЛИЙ', latin: null, sex: 0 },
        { russian: 'КРИСТИАН', latin: null, sex: 0 },
        { russian: 'КСЕНОФОНТ', latin: null, sex: 0 },
        { russian: 'КУЗЬМА', latin: 'KUZMA', sex: 0 },
        { russian: 'КУПРИЯН', latin: null, sex: 0 },
        { russian: 'ЛАВР', latin: null, sex: 0 },
        { russian: 'ЛАВРЕНТИЙ', latin: 'LAVRENTY', sex: 0 },
        { russian: 'ЛАЗАРЬ', latin: null, sex: 0 },
        { russian: 'ЛАРИОН', latin: 'LARION', sex: 0 },
        { russian: 'ЛЕВ', latin: 'LEV', sex: 0 },
        { russian: 'ЛЕВАН', latin: null, sex: 0 },
        { russian: 'ЛЕВОН', latin: null, sex: 0 },
        { russian: 'ЛЕО', latin: null, sex: 0 },
        { russian: 'ЛЕОН', latin: null, sex: 0 },
        { russian: 'ЛЕОНАРД', latin: null, sex: 0 },
        { russian: 'ЛЕОНИД', latin: null, sex: 0 },
        { russian: 'ЛЕОНТИЙ', latin: 'LEONTY', sex: 0 },
        { russian: 'ЛЕОПОЛЬД', latin: null, sex: 0 },
        { russian: 'ЛОГВИН', latin: null, sex: 0 },
        { russian: 'ЛОГГИН', latin: null, sex: 0 },
        { russian: 'ЛОНГИН', latin: null, sex: 0 },
        { russian: 'ЛУАРСАБ', latin: null, sex: 0 },
        { russian: 'ЛУКА', latin: 'LUKA', sex: 0 },
        { russian: 'ЛУКАС', latin: null, sex: 0 },
        { russian: 'ЛУКИАН', latin: null, sex: 0 },
        { russian: 'ЛУКЬЯН', latin: null, sex: 0 },
        { russian: 'ЛЮБИМ', latin: null, sex: 0 },
        { russian: 'ЛЮБОМИР', latin: null, sex: 0 },
        { russian: 'ЛЮЦИАН', latin: null, sex: 0 },
        { russian: 'МАВР', latin: null, sex: 0 },
        { russian: 'МАВРИКИЙ', latin: null, sex: 0 },
        { russian: 'МАВРОДИЙ', latin: null, sex: 0 },
        { russian: 'МАГОМЕД', latin: null, sex: 0 },
        { russian: 'МАЙКЛ', latin: null, sex: 0 },
        { russian: 'МАКАР', latin: 'MAKAR', sex: 0 },
        { russian: 'МАКАРИЙ', latin: null, sex: 0 },
        { russian: 'МАКС', latin: null, sex: 0 },
        { russian: 'МАКСИМ', latin: 'MAXIM', sex: 0 },
        { russian: 'МАКСИМИАН', latin: null, sex: 0 },
        { russian: 'МАКСИМИЛИАН', latin: null, sex: 0 },
        { russian: 'МАКСИМИЛЬЯН', latin: null, sex: 0 },
        { russian: 'МАЛИК', latin: null, sex: 0 },
        { russian: 'МАМЕД', latin: null, sex: 0 },
        { russian: 'МАНВЕЛ', latin: null, sex: 0 },
        { russian: 'МАНСУР', latin: null, sex: 0 },
        { russian: 'МАНУИЛ', latin: null, sex: 0 },
        { russian: 'МАНУЧЕХР', latin: null, sex: 0 },
        { russian: 'МАРАТ', latin: null, sex: 0 },
        { russian: 'МАРДАРИЙ', latin: null, sex: 0 },
        { russian: 'МАРИАН', latin: null, sex: 0 },
        { russian: 'МАРИН', latin: null, sex: 0 },
        { russian: 'МАРК', latin: null, sex: 0 },
        { russian: 'МАРКЕЛ', latin: null, sex: 0 },
        { russian: 'МАРКИАН', latin: null, sex: 0 },
        { russian: 'МАРКУС', latin: null, sex: 0 },
        { russian: 'МАРЛЕН', latin: null, sex: 0 },
        { russian: 'МАРСЕЛЬ', latin: null, sex: 0 },
        { russian: 'МАРТИМЬЯН', latin: null, sex: 0 },
        { russian: 'МАРТИН', latin: null, sex: 0 },
        { russian: 'МАРТИНИАН', latin: null, sex: 0 },
        { russian: 'МАРТИРИЙ', latin: null, sex: 0 },
        { russian: 'МАРТЫН', latin: null, sex: 0 },
        { russian: 'МАРТЬЯН', latin: null, sex: 0 },
        { russian: 'МАТВЕЙ', latin: 'MATVEY', sex: 0 },
        { russian: 'МАХМУД', latin: null, sex: 0 },
        { russian: 'МГЕР', latin: null, sex: 0 },
        { russian: 'МЕЛЕНТИЙ', latin: null, sex: 0 },
        { russian: 'МЕЛЕТИЙ', latin: null, sex: 0 },
        { russian: 'МЕРКУЛ', latin: null, sex: 0 },
        { russian: 'МЕРКУРИЙ', latin: null, sex: 0 },
        { russian: 'МЕФОДИЙ', latin: null, sex: 0 },
        { russian: 'МЕЧИСЛАВ', latin: null, sex: 0 },
        { russian: 'МИКАЕЛ', latin: null, sex: 0 },
        { russian: 'МИКАИЛ', latin: null, sex: 0 },
        { russian: 'МИЛИЙ', latin: null, sex: 0 },
        { russian: 'МИНАЙ', latin: null, sex: 0 },
        { russian: 'МИРОН', latin: null, sex: 0 },
        { russian: 'МИРОСЛАВ', latin: null, sex: 0 },
        { russian: 'МИСАИЛ', latin: null, sex: 0 },
        { russian: 'МИТРОФАН', latin: 'MITROFAN', sex: 0 },
        { russian: 'МИТРОФАНИЙ', latin: null, sex: 0 },
        { russian: 'МИХАЕЛЬ', latin: null, sex: 0 },
        { russian: 'МИХАИЛ', latin: 'MIKHAIL', sex: 0 },
        { russian: 'МИХАЭЛЬ', latin: null, sex: 0 },
        { russian: 'МИХЕЙ', latin: null, sex: 0 },
        { russian: 'МКРТИЧ', latin: null, sex: 0 },
        { russian: 'МОВСАР', latin: null, sex: 0 },
        { russian: 'МОДЕСТ', latin: null, sex: 0 },
        { russian: 'МОИСЕЙ', latin: null, sex: 0 },
        { russian: 'МОКЕЙ', latin: null, sex: 0 },
        { russian: 'МОКИЙ', latin: null, sex: 0 },
        { russian: 'МОХАМАД', latin: null, sex: 0 },
        { russian: 'МОХАМЕД', latin: null, sex: 0 },
        { russian: 'МСТИСЛАВ', latin: null, sex: 0 },
        { russian: 'МУЗАФФАР', latin: null, sex: 0 },
        { russian: 'МУРАД', latin: null, sex: 0 },
        { russian: 'МУРАТ', latin: null, sex: 0 },
        { russian: 'МУСА', latin: null, sex: 0 },
        { russian: 'МУСЛИМ', latin: null, sex: 0 },
        { russian: 'МУСТАФА', latin: null, sex: 0 },
        { russian: 'МУХАМЕД', latin: null, sex: 0 },
        { russian: 'МУХАММАД', latin: null, sex: 0 },
        { russian: 'МУХАММЕД', latin: null, sex: 0 },
        { russian: 'НАЗАР', latin: null, sex: 0 },
        { russian: 'НАЗАРИЙ', latin: null, sex: 0 },
        { russian: 'НАЗИМ', latin: null, sex: 0 },
        { russian: 'НАИЛЬ', latin: null, sex: 0 },
        { russian: 'НАРЕК', latin: null, sex: 0 },
        { russian: 'НАРИМАН', latin: null, sex: 0 },
        { russian: 'НАТАН', latin: null, sex: 0 },
        { russian: 'НАУМ', latin: null, sex: 0 },
        { russian: 'НЕСТЕР', latin: null, sex: 0 },
        { russian: 'НЕСТОР', latin: null, sex: 0 },
        { russian: 'НЕФЁД', latin: null, sex: 0 },
        { russian: 'НИК', latin: null, sex: 0 },
        { russian: 'НИКАНДР', latin: null, sex: 0 },
        { russian: 'НИКАНОР', latin: null, sex: 0 },
        { russian: 'НИКИТА', latin: 'NIKITA', sex: 0 },
        { russian: 'НИКИФОР', latin: 'NIKIFOR', sex: 0 },
        { russian: 'НИКОДИМ', latin: null, sex: 0 },
        { russian: 'НИКОЛАЙ', latin: 'NIKOLAY', sex: 0 },
        { russian: 'НИКОЛАОС', latin: null, sex: 0 },
        { russian: 'НИКОЛАС', latin: null, sex: 0 },
        { russian: 'НИКОН', latin: null, sex: 0 },
        { russian: 'НИЛ', latin: null, sex: 0 },
        { russian: 'НИФОНТ', latin: null, sex: 0 },
        { russian: 'НОДАРИ', latin: null, sex: 0 },
        { russian: 'НОРАЙР', latin: null, sex: 0 },
        { russian: 'ОГАНЕС', latin: null, sex: 0 },
        { russian: 'ОГАННЕС', latin: null, sex: 0 },
        { russian: 'ОЙГЕН', latin: null, sex: 0 },
        { russian: 'ОЛЕГ', latin: 'OLEG', sex: 0 },
        { russian: 'ОЛИВЕР', latin: null, sex: 0 },
        { russian: 'ОЛИМПИЙ', latin: null, sex: 0 },
        { russian: 'ОМАР', latin: null, sex: 0 },
        { russian: 'ОНИСИМ', latin: null, sex: 0 },
        { russian: 'ОНУФРИЙ', latin: null, sex: 0 },
        { russian: 'ОРЕСТ', latin: null, sex: 0 },
        { russian: 'ОСИП', latin: null, sex: 0 },
        { russian: 'ОСКАР', latin: null, sex: 0 },
        { russian: 'ОСМАН', latin: null, sex: 0 },
        { russian: 'ОСТАП', latin: null, sex: 0 },
        { russian: 'ОТТО', latin: null, sex: 0 },
        { russian: 'ПАВЕЛ', latin: 'PAVEL', sex: 0 },
        { russian: 'ПАВЛИН', latin: null, sex: 0 },
        { russian: 'ПАИСИЙ', latin: null, sex: 0 },
        { russian: 'ПАЛЛАДИЙ', latin: null, sex: 0 },
        { russian: 'ПАМФИЛ', latin: null, sex: 0 },
        { russian: 'ПАМФИЛИЙ', latin: null, sex: 0 },
        { russian: 'ПАНКРАТ', latin: null, sex: 0 },
        { russian: 'ПАНКРАТИЙ', latin: null, sex: 0 },
        { russian: 'ПАНТЕЛЕЙ', latin: null, sex: 0 },
        { russian: 'ПАНТЕЛЕЙМОН', latin: null, sex: 0 },
        { russian: 'ПАНФИЛ', latin: null, sex: 0 },
        { russian: 'ПАРАМОН', latin: null, sex: 0 },
        { russian: 'ПАРВИЗ', latin: null, sex: 0 },
        { russian: 'ПАРМЕН', latin: null, sex: 0 },
        { russian: 'ПАРМЁН', latin: null, sex: 0 },
        { russian: 'ПАРФЁН', latin: null, sex: 0 },
        { russian: 'ПАРФЕНИЙ', latin: null, sex: 0 },
        { russian: 'ПАРФЕНТИЙ', latin: null, sex: 0 },
        { russian: 'ПАТРИКЕЙ', latin: null, sex: 0 },
        { russian: 'ПАТРИКИЙ', latin: null, sex: 0 },
        { russian: 'ПАУЛЬ', latin: null, sex: 0 },
        { russian: 'ПАФНУТИЙ', latin: null, sex: 0 },
        { russian: 'ПАХОМ', latin: null, sex: 0 },
        { russian: 'ПАХОМИЙ', latin: null, sex: 0 },
        { russian: 'ПЕРФИЛИЙ', latin: null, sex: 0 },
        { russian: 'ПЕТЕР', latin: null, sex: 0 },
        { russian: 'ПЕТР', latin: null, sex: 0 },
        { russian: 'ПЁТР', latin: null, sex: 0 },
        { russian: 'ПЕТРОС', latin: null, sex: 0 },
        { russian: 'ПИМЕН', latin: null, sex: 0 },
        { russian: 'ПИТИРИМ', latin: null, sex: 0 },
        { russian: 'ПЛАТОН', latin: 'PLATON', sex: 0 },
        { russian: 'ПОЛИКАРП', latin: 'POLIKARP', sex: 0 },
        { russian: 'ПОЛИКАРПИЙ', latin: null, sex: 0 },
        { russian: 'ПОРФИР', latin: null, sex: 0 },
        { russian: 'ПОРФИРИЙ', latin: null, sex: 0 },
        { russian: 'ПОТАП', latin: null, sex: 0 },
        { russian: 'ПОТАПИЙ', latin: null, sex: 0 },
        { russian: 'ПРОВ', latin: null, sex: 0 },
        { russian: 'ПРОКЛ', latin: null, sex: 0 },
        { russian: 'ПРОКОП', latin: null, sex: 0 },
        { russian: 'ПРОКОПИЙ', latin: null, sex: 0 },
        { russian: 'ПРОКОФИЙ', latin: null, sex: 0 },
        { russian: 'ПРОТАС', latin: null, sex: 0 },
        { russian: 'ПРОТАСИЙ', latin: null, sex: 0 },
        { russian: 'ПРОХОР', latin: 'PROKHOR', sex: 0 },
        { russian: 'РАВИЛЬ', latin: null, sex: 0 },
        { russian: 'РАВШАН', latin: null, sex: 0 },
        { russian: 'РАДИЙ', latin: null, sex: 0 },
        { russian: 'РАДИК', latin: null, sex: 0 },
        { russian: 'РАДИОН', latin: null, sex: 0 },
        { russian: 'РАЗМИК', latin: null, sex: 0 },
        { russian: 'РАЙНГОЛЬД', latin: null, sex: 0 },
        { russian: 'РАМАЗАН', latin: null, sex: 0 },
        { russian: 'РАМЗАН', latin: null, sex: 0 },
        { russian: 'РАМИ', latin: null, sex: 0 },
        { russian: 'РАМИЗ', latin: null, sex: 0 },
        { russian: 'РАМИЛЬ', latin: null, sex: 0 },
        { russian: 'РАСИМ', latin: null, sex: 0 },
        { russian: 'РАСУЛ', latin: null, sex: 0 },
        { russian: 'РАТМИР', latin: null, sex: 0 },
        { russian: 'РАУФ', latin: null, sex: 0 },
        { russian: 'РАФАЕЛ', latin: null, sex: 0 },
        { russian: 'РАФАИЛ', latin: null, sex: 0 },
        { russian: 'РАФАЭЛЬ', latin: null, sex: 0 },
        { russian: 'РАФИК', latin: null, sex: 0 },
        { russian: 'РАХИМ', latin: null, sex: 0 },
        { russian: 'РАХМАН', latin: null, sex: 0 },
        { russian: 'РАШИД', latin: null, sex: 0 },
        { russian: 'РЕЙНГОЛЬД', latin: null, sex: 0 },
        { russian: 'РЕМ', latin: null, sex: 0 },
        { russian: 'РЕНАТ', latin: null, sex: 0 },
        { russian: 'РИЗВАН', latin: null, sex: 0 },
        { russian: 'РИНАТ', latin: null, sex: 0 },
        { russian: 'РИХАРД', latin: null, sex: 0 },
        { russian: 'РИЧАРД', latin: null, sex: 0 },
        { russian: 'РОБЕРТ', latin: null, sex: 0 },
        { russian: 'РОДИОН', latin: 'RODION', sex: 0 },
        { russian: 'РОЛАНД', latin: null, sex: 0 },
        { russian: 'РОМАН', latin: null, sex: 0 },
        { russian: 'РОМУАЛЬД', latin: null, sex: 0 },
        { russian: 'РОСТИСЛАВ', latin: null, sex: 0 },
        { russian: 'РУБЕН', latin: null, sex: 0 },
        { russian: 'РУВИМ', latin: null, sex: 0 },
        { russian: 'РУДОЛЬФ', latin: null, sex: 0 },
        { russian: 'РУСЛАН', latin: null, sex: 0 },
        { russian: 'РУСТАМ', latin: null, sex: 0 },
        { russian: 'РУСТЕМ', latin: null, sex: 0 },
        { russian: 'РЮРИК', latin: null, sex: 0 },
        { russian: 'САБИР', latin: null, sex: 0 },
        { russian: 'САВВА', latin: null, sex: 0 },
        { russian: 'САВВАТЕЙ', latin: null, sex: 0 },
        { russian: 'САВВАТИЙ', latin: null, sex: 0 },
        { russian: 'САВЁЛ', latin: null, sex: 0 },
        { russian: 'САВЕЛИЙ', latin: null, sex: 0 },
        { russian: 'САИД', latin: null, sex: 0 },
        { russian: 'САЛАВАТ', latin: null, sex: 0 },
        { russian: 'САЛИМ', latin: null, sex: 0 },
        { russian: 'САЛМАН', latin: null, sex: 0 },
        { russian: 'САМВЕЛ', latin: null, sex: 0 },
        { russian: 'САМИР', latin: null, sex: 0 },
        { russian: 'САМОЙЛА', latin: null, sex: 0 },
        { russian: 'САМСОН', latin: null, sex: 0 },
        { russian: 'САМСОНИЙ', latin: null, sex: 0 },
        { russian: 'САМУИЛ', latin: null, sex: 0 },
        { russian: 'САРГИС', latin: null, sex: 0 },
        { russian: 'САРКИС', latin: null, sex: 0 },
        { russian: 'СВИРИД', latin: null, sex: 0 },
        { russian: 'СВЯТОПОЛК', latin: null, sex: 0 },
        { russian: 'СВЯТОСЛАВ', latin: null, sex: 0 },
        { russian: 'СЕБАСТЬЯН', latin: null, sex: 0 },
        { russian: 'СЕВАСТЬЯН', latin: null, sex: 0 },
        { russian: 'СЕВЕРИН', latin: null, sex: 0 },
        { russian: 'СЕВЕРЬЯН', latin: null, sex: 0 },
        { russian: 'СЕЙРАН', latin: null, sex: 0 },
        { russian: 'СЕЛИВАН', latin: null, sex: 0 },
        { russian: 'СЕЛИВЁРСТ', latin: null, sex: 0 },
        { russian: 'СЕЛИФАН', latin: null, sex: 0 },
        { russian: 'СЕМЕН', latin: null, sex: 0 },
        { russian: 'СЕМЁН', latin: null, sex: 0 },
        { russian: 'СЕРАПИОН', latin: null, sex: 0 },
        { russian: 'СЕРАФИМ', latin: null, sex: 0 },
        { russian: 'СЕРГЕЙ', latin: 'SERGEY', sex: 0 },
        { russian: 'СЕРДАР', latin: null, sex: 0 },
        { russian: 'СИГИЗМУНД', latin: null, sex: 0 },
        { russian: 'СИДОР', latin: null, sex: 0 },
        { russian: 'СИЛА', latin: null, sex: 0 },
        { russian: 'СИЛАН', latin: null, sex: 0 },
        { russian: 'СИЛАНТИЙ', latin: null, sex: 0 },
        { russian: 'СИЛУЯН', latin: null, sex: 0 },
        { russian: 'СИЛЬВАН', latin: null, sex: 0 },
        { russian: 'СИЛЬВЕСТР', latin: null, sex: 0 },
        { russian: 'СИМЕОН', latin: null, sex: 0 },
        { russian: 'СИМОН', latin: null, sex: 0 },
        { russian: 'СОЗОН', latin: null, sex: 0 },
        { russian: 'СОЗОНТ', latin: null, sex: 0 },
        { russian: 'СОЗОНТИЙ', latin: null, sex: 0 },
        { russian: 'СОКРАТ', latin: null, sex: 0 },
        { russian: 'СОЛОМОН', latin: null, sex: 0 },
        { russian: 'СОСИПАТР', latin: null, sex: 0 },
        { russian: 'СОСЛАН', latin: null, sex: 0 },
        { russian: 'СОФОН', latin: null, sex: 0 },
        { russian: 'СОФОНИЙ', latin: null, sex: 0 },
        { russian: 'СОФРОН', latin: null, sex: 0 },
        { russian: 'СОФРОНИЙ', latin: null, sex: 0 },
        { russian: 'СПАРТАК', latin: null, sex: 0 },
        { russian: 'СПИРИДОН', latin: null, sex: 0 },
        { russian: 'СПИРИДОНИЙ', latin: null, sex: 0 },
        { russian: 'СТАНИСЛАВ', latin: null, sex: 0 },
        { russian: 'СТАХИЙ', latin: null, sex: 0 },
        { russian: 'СТЕПАН', latin: 'STEPAN', sex: 0 },
        { russian: 'СТЕФАН', latin: null, sex: 0 },
        { russian: 'СТРАТОНИК', latin: null, sex: 0 },
        { russian: 'СУЛЕЙМАН', latin: null, sex: 0 },
        { russian: 'СУЛТАН', latin: null, sex: 0 },
        { russian: 'СУРЕН', latin: null, sex: 0 },
        { russian: 'СУХРОБ', latin: null, sex: 0 },
        { russian: 'СЫСОЙ', latin: null, sex: 0 },
        { russian: 'ТАГИР', latin: null, sex: 0 },
        { russian: 'ТАМЕРЛАН', latin: null, sex: 0 },
        { russian: 'ТАРАС', latin: null, sex: 0 },
        { russian: 'ТАХИР', latin: null, sex: 0 },
        { russian: 'ТЕЙМУР', latin: null, sex: 0 },
        { russian: 'ТЕЙМУРАЗ', latin: null, sex: 0 },
        { russian: 'ТЕЛЬМАН', latin: null, sex: 0 },
        { russian: 'ТЕМУР', latin: null, sex: 0 },
        { russian: 'ТЕНГИЗ', latin: null, sex: 0 },
        { russian: 'ТЕОДОР', latin: null, sex: 0 },
        { russian: 'ТЕРЕНТИЙ', latin: null, sex: 0 },
        { russian: 'ТЕРТИЙ', latin: null, sex: 0 },
        { russian: 'ТИГРАН', latin: null, sex: 0 },
        { russian: 'ТИМОФЕЙ', latin: 'TIMOFEY', sex: 0 },
        { russian: 'ТИМУР', latin: null, sex: 0 },
        { russian: 'ТИТ', latin: null, sex: 0 },
        { russian: 'ТИХОН', latin: null, sex: 0 },
        { russian: 'ТОМАС', latin: null, sex: 0 },
        { russian: 'ТРИФОН', latin: 'TRIFON', sex: 0 },
        { russian: 'ТРОФИМ', latin: 'TROFIM', sex: 0 },
        { russian: 'ТУРПАЛ-АЛИ', latin: null, sex: 0 },
        { russian: 'УАР', latin: null, sex: 0 },
        { russian: 'УВАР', latin: null, sex: 0 },
        { russian: 'УЛУГБЕК', latin: null, sex: 0 },
        { russian: 'УЛЬЯН', latin: null, sex: 0 },
        { russian: 'УМАР', latin: null, sex: 0 },
        { russian: 'УСМАН', latin: null, sex: 0 },
        { russian: 'УСТИН', latin: null, sex: 0 },
        { russian: 'ФАБИАН', latin: null, sex: 0 },
        { russian: 'ФАДДЕЙ', latin: null, sex: 0 },
        { russian: 'ФАДЕЙ', latin: 'FADEY', sex: 0 },
        { russian: 'ФАЛАЛЕЙ', latin: null, sex: 0 },
        { russian: 'ФАРИД', latin: null, sex: 0 },
        { russian: 'ФАРРУХ', latin: null, sex: 0 },
        { russian: 'ФАРХАД', latin: null, sex: 0 },
        { russian: 'ФАРХОД', latin: null, sex: 0 },
        { russian: 'ФАТЬЯН', latin: null, sex: 0 },
        { russian: 'ФЕДОР', latin: null, sex: 0 },
        { russian: 'ФЁДОР', latin: null, sex: 0 },
        { russian: 'ФЕДОС', latin: null, sex: 0 },
        { russian: 'ФЕДОСЕЙ', latin: null, sex: 0 },
        { russian: 'ФЕДОСИЙ', latin: null, sex: 0 },
        { russian: 'ФЕДОТ', latin: 'FEDOT', sex: 0 },
        { russian: 'ФЕДОТИЙ', latin: null, sex: 0 },
        { russian: 'ФЕДУЛ', latin: null, sex: 0 },
        { russian: 'ФЕЛИКС', latin: null, sex: 0 },
        { russian: 'ФЕОГНОСТ', latin: null, sex: 0 },
        { russian: 'ФЕОКТИСТ', latin: null, sex: 0 },
        { russian: 'ФЕОФАН', latin: null, sex: 0 },
        { russian: 'ФЕОФИЛ', latin: null, sex: 0 },
        { russian: 'ФЕОФИЛАКТ', latin: null, sex: 0 },
        { russian: 'ФЕРАПОНТ', latin: null, sex: 0 },
        { russian: 'ФИЛАРЕТ', latin: null, sex: 0 },
        { russian: 'ФИЛАТ', latin: null, sex: 0 },
        { russian: 'ФИЛИМОН', latin: null, sex: 0 },
        { russian: 'ФИЛИП', latin: null, sex: 0 },
        { russian: 'ФИЛИПИЙ', latin: null, sex: 0 },
        { russian: 'ФИЛИПП', latin: 'PHILIPP', sex: 0 },
        { russian: 'ФИЛОФЕЙ', latin: null, sex: 0 },
        { russian: 'ФИРДАВС', latin: null, sex: 0 },
        { russian: 'ФИРС', latin: null, sex: 0 },
        { russian: 'ФИРУЗ', latin: null, sex: 0 },
        { russian: 'ФЛЕГОНТ', latin: null, sex: 0 },
        { russian: 'ФЛОРЕНТИЙ', latin: null, sex: 0 },
        { russian: 'ФЛОРЕНТИН', latin: null, sex: 0 },
        { russian: 'ФЛОРИАН', latin: null, sex: 0 },
        { russian: 'ФОКА', latin: null, sex: 0 },
        { russian: 'ФОМА', latin: 'FOMA', sex: 0 },
        { russian: 'ФОРТУНАТ', latin: null, sex: 0 },
        { russian: 'ФОТИЙ', latin: null, sex: 0 },
        { russian: 'ФРАНЦ', latin: null, sex: 0 },
        { russian: 'ФРИДРИХ', latin: null, sex: 0 },
        { russian: 'ФРОЛ', latin: 'FROL', sex: 0 },
        { russian: 'ХАЛИД', latin: null, sex: 0 },
        { russian: 'ХАМЗАТ', latin: null, sex: 0 },
        { russian: 'ХАМИД', latin: null, sex: 0 },
        { russian: 'ХАРИТОН', latin: 'KHARITON', sex: 0 },
        { russian: 'ХАРИТОНИЙ', latin: null, sex: 0 },
        { russian: 'ХАРЛАМ', latin: null, sex: 0 },
        { russian: 'ХАРЛАМП', latin: null, sex: 0 },
        { russian: 'ХАРЛАМПИЙ', latin: null, sex: 0 },
        { russian: 'ХАСАН', latin: null, sex: 0 },
        { russian: 'ХАЧАТУР', latin: null, sex: 0 },
        { russian: 'ХАЧИК', latin: null, sex: 0 },
        { russian: 'ХРИСАНФ', latin: null, sex: 0 },
        { russian: 'ХРИСТОС', latin: null, sex: 0 },
        { russian: 'ХРИСТОФОР', latin: null, sex: 0 },
        { russian: 'ХУРШЕД', latin: null, sex: 0 },
        { russian: 'ХУСЕЙН', latin: null, sex: 0 },
        { russian: 'ШАВКАТ', latin: null, sex: 0 },
        { russian: 'ШАМИЛЬ', latin: null, sex: 0 },
        { russian: 'ШАМХАН', latin: null, sex: 0 },
        { russian: 'ШЕРЗОД', latin: null, sex: 0 },
        { russian: 'ШОТА', latin: null, sex: 0 },
        { russian: 'ШТЕФАН', latin: null, sex: 0 },
        { russian: 'ШУХРАТ', latin: null, sex: 0 },
        { russian: 'ЭВАЛЬД', latin: null, sex: 0 },
        { russian: 'ЭДВАРД', latin: null, sex: 0 },
        { russian: 'ЭДВИН', latin: null, sex: 0 },
        { russian: 'ЭДГАР', latin: null, sex: 0 },
        { russian: 'ЭДИК', latin: null, sex: 0 },
        { russian: 'ЭДМУНД', latin: null, sex: 0 },
        { russian: 'ЭДУАРД', latin: null, sex: 0 },
        { russian: 'ЭЛЬДАР', latin: null, sex: 0 },
        { russian: 'ЭМАНУИЛ', latin: null, sex: 0 },
        { russian: 'ЭМИЛИЙ', latin: null, sex: 0 },
        { russian: 'ЭМИЛЬ', latin: null, sex: 0 },
        { russian: 'ЭМИН', latin: null, sex: 0 },
        { russian: 'ЭМИР', latin: null, sex: 0 },
        { russian: 'ЭММАНУИЛ', latin: null, sex: 0 },
        { russian: 'ЭРАЗМ', latin: null, sex: 0 },
        { russian: 'ЭРАСТ', latin: null, sex: 0 },
        { russian: 'ЭРВИН', latin: null, sex: 0 },
        { russian: 'ЭРИК', latin: null, sex: 0 },
        { russian: 'ЭРИХ', latin: null, sex: 0 },
        { russian: 'ЭРНЕСТ', latin: null, sex: 0 },
        { russian: 'ЭРНСТ', latin: null, sex: 0 },
        { russian: 'ЮВЕНАЛИЙ', latin: null, sex: 0 },
        { russian: 'ЮЛИАН', latin: null, sex: 0 },
        { russian: 'ЮЛИЙ', latin: null, sex: 0 },
        { russian: 'ЮНУС', latin: null, sex: 0 },
        { russian: 'ЮРГЕН', latin: null, sex: 0 },
        { russian: 'ЮРИЙ', latin: 'YURY', sex: 0 },
        { russian: 'ЮСЕФ', latin: null, sex: 0 },
        { russian: 'ЮСТИН', latin: null, sex: 0 },
        { russian: 'ЮСУП', latin: null, sex: 0 },
        { russian: 'ЮСУФ', latin: null, sex: 0 },
        { russian: 'ЯКИМ', latin: null, sex: 0 },
        { russian: 'ЯКОБ', latin: null, sex: 0 },
        { russian: 'ЯКОВ', latin: 'IAKOV', sex: 0 },
        { russian: 'ЯКУБ', latin: null, sex: 0 },
        { russian: 'ЯН', latin: null, sex: 0 },
        { russian: 'ЯНИС', latin: null, sex: 0 },
        { russian: 'ЯНУАРИЙ', latin: null, sex: 0 },
        { russian: 'ЯРОСЛАВ', latin: null, sex: 0 },
        { russian: 'ЯСИН', latin: null, sex: 0 },
        { russian: 'АВГУСТА', latin: null, sex: 1 },
        { russian: 'АВГУСТИНА', latin: null, sex: 1 },
        { russian: 'АВДОТЬЯ', latin: null, sex: 1 },
        { russian: 'АВРОРА', latin: null, sex: 1 },
        { russian: 'АГАТА', latin: null, sex: 1 },
        { russian: 'АГАФЬЯ', latin: 'AGAFIA', sex: 1 },
        { russian: 'АГЛАЯ', latin: null, sex: 1 },
        { russian: 'АГНЕССА', latin: null, sex: 1 },
        { russian: 'АГНИЯ', latin: null, sex: 1 },
        { russian: 'АГРАФЕНА', latin: null, sex: 1 },
        { russian: 'АГРИППИНА', latin: null, sex: 1 },
        { russian: 'АДА', latin: null, sex: 1 },
        { russian: 'АДЕЛАИДА', latin: null, sex: 1 },
        { russian: 'АДЕЛИНА', latin: null, sex: 1 },
        { russian: 'АДЕЛЯ', latin: null, sex: 1 },
        { russian: 'АДРИАНА', latin: null, sex: 1 },
        { russian: 'АЗА', latin: null, sex: 1 },
        { russian: 'АЗАЛИЯ', latin: null, sex: 1 },
        { russian: 'АЗИЗА', latin: null, sex: 1 },
        { russian: 'АИДА', latin: null, sex: 1 },
        { russian: 'АИША', latin: null, sex: 1 },
        { russian: 'АЙГУЛЬ', latin: null, sex: 1 },
        { russian: 'АЙНА', latin: null, sex: 1 },
        { russian: 'АЙНУРА', latin: null, sex: 1 },
        { russian: 'АЙША', latin: null, sex: 1 },
        { russian: 'АЙШАТ', latin: null, sex: 1 },
        { russian: 'АКСАНА', latin: null, sex: 1 },
        { russian: 'АКСИНЬЯ', latin: null, sex: 1 },
        { russian: 'АКУЛИНА', latin: 'AKOULINA', sex: 1 },
        { russian: 'АЛЕВТИНА', latin: null, sex: 1 },
        { russian: 'АЛЕКСАНДРА', latin: 'ALEXANDRA', sex: 1 },
        { russian: 'АЛЕКСАНДРИНА', latin: null, sex: 1 },
        { russian: 'АЛЕНА', latin: null, sex: 1 },
        { russian: 'АЛЁНА', latin: null, sex: 1 },
        { russian: 'АЛЕСЯ', latin: null, sex: 1 },
        { russian: 'АЛЕФТИНА', latin: null, sex: 1 },
        { russian: 'АЛИНА', latin: null, sex: 1 },
        { russian: 'АЛИСА', latin: null, sex: 1 },
        { russian: 'АЛИСИЯ', latin: null, sex: 1 },
        { russian: 'АЛИЯ', latin: null, sex: 1 },
        { russian: 'АЛЛА', latin: null, sex: 1 },
        { russian: 'АЛСУ', latin: null, sex: 1 },
        { russian: 'АЛЬБЕРТИНА', latin: null, sex: 1 },
        { russian: 'АЛЬБИНА', latin: null, sex: 1 },
        { russian: 'АЛЬВИНА', latin: null, sex: 1 },
        { russian: 'АЛЬМА', latin: null, sex: 1 },
        { russian: 'АЛЬМИРА', latin: null, sex: 1 },
        { russian: 'АЛЬФИЯ', latin: null, sex: 1 },
        { russian: 'АМАЛИЯ', latin: null, sex: 1 },
        { russian: 'АМАЛЯ', latin: null, sex: 1 },
        { russian: 'АМЕЛИЯ', latin: null, sex: 1 },
        { russian: 'АМИНА', latin: null, sex: 1 },
        { russian: 'АМИНАТ', latin: null, sex: 1 },
        { russian: 'АМИРА', latin: null, sex: 1 },
        { russian: 'АНАИДА', latin: null, sex: 1 },
        { russian: 'АНАИТ', latin: null, sex: 1 },
        { russian: 'АНАСТАСИЯ', latin: 'ANASTASIA', sex: 1 },
        { russian: 'АНГЕЛИКА', latin: null, sex: 1 },
        { russian: 'АНГЕЛИНА', latin: null, sex: 1 },
        { russian: 'АНЖЕЛА', latin: null, sex: 1 },
        { russian: 'АНЖЕЛИКА', latin: null, sex: 1 },
        { russian: 'АНЖЕЛИНА', latin: null, sex: 1 },
        { russian: 'АНЖЕЛЛА', latin: null, sex: 1 },
        { russian: 'АНИ', latin: null, sex: 1 },
        { russian: 'АНИСА', latin: null, sex: 1 },
        { russian: 'АНИСЬЯ', latin: null, sex: 1 },
        { russian: 'АНИТА', latin: null, sex: 1 },
        { russian: 'АННА', latin: 'ANNA', sex: 1 },
        { russian: 'АННА-МАРИЯ', latin: null, sex: 1 },
        { russian: 'АННА МАРИЯ', latin: null, sex: 1 },
        { russian: 'АНТОНИДА', latin: null, sex: 1 },
        { russian: 'АНТОНИНА', latin: 'ANTONINA', sex: 1 },
        { russian: 'АНУШ', latin: null, sex: 1 },
        { russian: 'АНФИСА', latin: null, sex: 1 },
        { russian: 'АНЯ', latin: null, sex: 1 },
        { russian: 'АПОЛЛИНАРИЯ', latin: null, sex: 1 },
        { russian: 'АПРАКСИЯ', latin: null, sex: 1 },
        { russian: 'АРЕВИК', latin: null, sex: 1 },
        { russian: 'АРИАДНА', latin: null, sex: 1 },
        { russian: 'АРИАНА', latin: null, sex: 1 },
        { russian: 'АРИНА', latin: null, sex: 1 },
        { russian: 'АРМЕНУИ', latin: null, sex: 1 },
        { russian: 'АРМИНЕ', latin: null, sex: 1 },
        { russian: 'АСЕЛЬ', latin: null, sex: 1 },
        { russian: 'АСЕТ', latin: null, sex: 1 },
        { russian: 'АСИЯ', latin: null, sex: 1 },
        { russian: 'АСИЯТ', latin: null, sex: 1 },
        { russian: 'АСМИК', latin: null, sex: 1 },
        { russian: 'АСТХИК', latin: null, sex: 1 },
        { russian: 'АСЯ', latin: null, sex: 1 },
        { russian: 'АФИНА', latin: null, sex: 1 },
        { russian: 'АЭЛИТА', latin: null, sex: 1 },
        { russian: 'БЕАТА', latin: null, sex: 1 },
        { russian: 'БЕАТРИСА', latin: null, sex: 1 },
        { russian: 'БЕЛЛА', latin: null, sex: 1 },
        { russian: 'БЕРТА', latin: null, sex: 1 },
        { russian: 'БОГДАНА', latin: null, sex: 1 },
        { russian: 'БОЖЕНА', latin: null, sex: 1 },
        { russian: 'БОЛЕСЛАВА', latin: null, sex: 1 },
        { russian: 'БОРИСЛАВА', latin: null, sex: 1 },
        { russian: 'БРОНИСЛАВА', latin: null, sex: 1 },
        { russian: 'БЭЛА', latin: null, sex: 1 },
        { russian: 'БЭЛЛА', latin: null, sex: 1 },
        { russian: 'ВАЛЕНТИНА', latin: null, sex: 1 },
        { russian: 'ВАЛЕРИЯ', latin: null, sex: 1 },
        { russian: 'ВАНДА', latin: null, sex: 1 },
        { russian: 'ВАНЕССА', latin: null, sex: 1 },
        { russian: 'ВАРВАРА', latin: 'VARVARA', sex: 1 },
        { russian: 'ВАРДУИ', latin: null, sex: 1 },
        { russian: 'ВАСИЛИНА', latin: null, sex: 1 },
        { russian: 'ВАСИЛИСА', latin: null, sex: 1 },
        { russian: 'ВАССА', latin: null, sex: 1 },
        { russian: 'ВЕЛИМИРА', latin: null, sex: 1 },
        { russian: 'ВЕЛИСЛАВА', latin: null, sex: 1 },
        { russian: 'ВЕНЕРА', latin: null, sex: 1 },
        { russian: 'ВЕРА', latin: 'VERA', sex: 1 },
        { russian: 'ВЕРЕНИКА', latin: null, sex: 1 },
        { russian: 'ВЕРОНИКА', latin: null, sex: 1 },
        { russian: 'ВИВИАНА', latin: null, sex: 1 },
        { russian: 'ВИКТОРИНА', latin: null, sex: 1 },
        { russian: 'ВИКТОРИЯ', latin: 'VICTORIA', sex: 1 },
        { russian: 'ВИЛЕНА', latin: null, sex: 1 },
        { russian: 'ВИЛЬГЕЛЬМИНА', latin: null, sex: 1 },
        { russian: 'ВИЛЬМА', latin: null, sex: 1 },
        { russian: 'ВИОЛА', latin: null, sex: 1 },
        { russian: 'ВИОЛЕТА', latin: null, sex: 1 },
        { russian: 'ВИОЛЕТТА', latin: null, sex: 1 },
        { russian: 'ВИРГИНИЯ', latin: null, sex: 1 },
        { russian: 'ВИРИНЕЯ', latin: null, sex: 1 },
        { russian: 'ВИТА', latin: null, sex: 1 },
        { russian: 'ВИТАЛИНА', latin: null, sex: 1 },
        { russian: 'ВИТАЛИЯ', latin: null, sex: 1 },
        { russian: 'ВЛАДА', latin: null, sex: 1 },
        { russian: 'ВЛАДИЛЕНА', latin: null, sex: 1 },
        { russian: 'ВЛАДИМИРА', latin: null, sex: 1 },
        { russian: 'ВЛАДИСЛАВА', latin: null, sex: 1 },
        { russian: 'ВЛАДЛЕНА', latin: null, sex: 1 },
        { russian: 'ВЛАСТА', latin: null, sex: 1 },
        { russian: 'ВСЕСЛАВА', latin: null, sex: 1 },
        { russian: 'ГАЛИНА', latin: null, sex: 1 },
        { russian: 'ГАЛИЯ', latin: null, sex: 1 },
        { russian: 'ГАЯНЕ', latin: null, sex: 1 },
        { russian: 'ГАЯНЭ', latin: null, sex: 1 },
        { russian: 'ГЕЛЕНА', latin: null, sex: 1 },
        { russian: 'ГЕНРИЕТТА', latin: null, sex: 1 },
        { russian: 'ГЕОРГИНА', latin: null, sex: 1 },
        { russian: 'ГЕРТА', latin: null, sex: 1 },
        { russian: 'ГЕРТРУДА', latin: null, sex: 1 },
        { russian: 'ГИЛЬДА', latin: null, sex: 1 },
        { russian: 'ГЛАФИРА', latin: null, sex: 1 },
        { russian: 'ГЛИКЕРИЯ', latin: null, sex: 1 },
        { russian: 'ГОАР', latin: null, sex: 1 },
        { russian: 'ГОРИСЛАВА', latin: null, sex: 1 },
        { russian: 'ГОРТЕНЗИЯ', latin: null, sex: 1 },
        { russian: 'ГРЕТА', latin: null, sex: 1 },
        { russian: 'ГУЗЕЛЬ', latin: null, sex: 1 },
        { russian: 'ГУЛНОРА', latin: null, sex: 1 },
        { russian: 'ГУЛЧЕХРА', latin: null, sex: 1 },
        { russian: 'ГУЛЬМИРА', latin: null, sex: 1 },
        { russian: 'ГУЛЬНАЗ', latin: null, sex: 1 },
        { russian: 'ГУЛЬНАРА', latin: null, sex: 1 },
        { russian: 'ГУЛЬНОРА', latin: null, sex: 1 },
        { russian: 'ГУЛЬШАТ', latin: null, sex: 1 },
        { russian: 'ГЮЗЕЛЬ', latin: null, sex: 1 },
        { russian: 'ГЮЛЬНАРА', latin: null, sex: 1 },
        { russian: 'ДАГМАРА', latin: null, sex: 1 },
        { russian: 'ДАНА', latin: null, sex: 1 },
        { russian: 'ДАНИЕЛА', latin: null, sex: 1 },
        { russian: 'ДАНИЭЛА', latin: null, sex: 1 },
        { russian: 'ДАНИЯ', latin: null, sex: 1 },
        { russian: 'ДАРИНА', latin: null, sex: 1 },
        { russian: 'ДАРИЯ', latin: null, sex: 1 },
        { russian: 'ДАРЬЯ', latin: 'DARIA', sex: 1 },
        { russian: 'ДАЯНА', latin: null, sex: 1 },
        { russian: 'ДЕБОРА', latin: null, sex: 1 },
        { russian: 'ДЕНИСИЯ', latin: null, sex: 1 },
        { russian: 'ДЖАМИЛЯ', latin: null, sex: 1 },
        { russian: 'ДЖЕННЕТ', latin: null, sex: 1 },
        { russian: 'ДЖЕННИФЕР', latin: null, sex: 1 },
        { russian: 'ДЖЕССИКА', latin: null, sex: 1 },
        { russian: 'ДЖУЛИЯ', latin: null, sex: 1 },
        { russian: 'ДЖУЛЬЕТТА', latin: null, sex: 1 },
        { russian: 'ДИАНА', latin: null, sex: 1 },
        { russian: 'ДИЛАРА', latin: null, sex: 1 },
        { russian: 'ДИЛАФРУЗ', latin: null, sex: 1 },
        { russian: 'ДИЛНОЗА', latin: null, sex: 1 },
        { russian: 'ДИЛОРОМ', latin: null, sex: 1 },
        { russian: 'ДИЛЬБАР', latin: null, sex: 1 },
        { russian: 'ДИЛЯРА', latin: null, sex: 1 },
        { russian: 'ДИНА', latin: null, sex: 1 },
        { russian: 'ДИНАРА', latin: null, sex: 1 },
        { russian: 'ДОМИНИКА', latin: null, sex: 1 },
        { russian: 'ДОМНА', latin: null, sex: 1 },
        { russian: 'ДОНАРА', latin: null, sex: 1 },
        { russian: 'ДОРА', latin: null, sex: 1 },
        { russian: 'ДОРОФЕЯ', latin: null, sex: 1 },
        { russian: 'ДОСИФЕЯ', latin: null, sex: 1 },
        { russian: 'ДРОСИДА', latin: null, sex: 1 },
        { russian: 'ЕВА', latin: null, sex: 1 },
        { russian: 'ЕВАНГЕЛИНА', latin: null, sex: 1 },
        { russian: 'ЕВГЕНИЯ', latin: null, sex: 1 },
        { russian: 'ЕВДОКИЯ', latin: 'EVDOKIA', sex: 1 },
        { russian: 'ЕВДОКСИЯ', latin: null, sex: 1 },
        { russian: 'ЕВЛАЛИЯ', latin: null, sex: 1 },
        { russian: 'ЕВЛАМПИЯ', latin: null, sex: 1 },
        { russian: 'ЕВПРАКСИЯ', latin: null, sex: 1 },
        { russian: 'ЕВСТОЛИЯ', latin: null, sex: 1 },
        { russian: 'ЕВФИМИЯ', latin: null, sex: 1 },
        { russian: 'ЕВФРОСИНИЯ', latin: null, sex: 1 },
        { russian: 'ЕКАТЕРИНА', latin: 'EKATERINA', sex: 1 },
        { russian: 'ЕЛЕНА', latin: 'ELENA', sex: 1 },
        { russian: 'ЕЛИЗАВЕТА', latin: 'ELIZAVETA', sex: 1 },
        { russian: 'ЕЛИКОНИДА', latin: null, sex: 1 },
        { russian: 'ЕПИСТИМИЯ', latin: null, sex: 1 },
        { russian: 'ЕФИМИЯ', latin: null, sex: 1 },
        { russian: 'ЕФРОСИНИЯ', latin: null, sex: 1 },
        { russian: 'ЕФРОСИНЬЯ', latin: 'EFROSINIA', sex: 1 },
        { russian: 'ЖАНЕТТА', latin: null, sex: 1 },
        { russian: 'ЖАННА', latin: null, sex: 1 },
        { russian: 'ЖАННЕТА', latin: null, sex: 1 },
        { russian: 'ЖЕНЯ', latin: null, sex: 1 },
        { russian: 'ЖОЗЕФИНА', latin: null, sex: 1 },
        { russian: 'ЗАИРА', latin: null, sex: 1 },
        { russian: 'ЗАЙНАБ', latin: null, sex: 1 },
        { russian: 'ЗАЙНАП', latin: null, sex: 1 },
        { russian: 'ЗАЛИНА', latin: null, sex: 1 },
        { russian: 'ЗАМИРА', latin: null, sex: 1 },
        { russian: 'ЗАРА', latin: null, sex: 1 },
        { russian: 'ЗАРЕМА', latin: null, sex: 1 },
        { russian: 'ЗАРЕТА', latin: null, sex: 1 },
        { russian: 'ЗАРИНА', latin: null, sex: 1 },
        { russian: 'ЗАРИФА', latin: null, sex: 1 },
        { russian: 'ЗАРРИНА', latin: null, sex: 1 },
        { russian: 'ЗЕЙНАБ', latin: null, sex: 1 },
        { russian: 'ЗЕМФИРА', latin: null, sex: 1 },
        { russian: 'ЗИЛЯ', latin: null, sex: 1 },
        { russian: 'ЗИНА', latin: null, sex: 1 },
        { russian: 'ЗИНАИДА', latin: 'ZINAIDA', sex: 1 },
        { russian: 'ЗИНОВИЯ', latin: null, sex: 1 },
        { russian: 'ЗЛАТА', latin: null, sex: 1 },
        { russian: 'ЗОЯ', latin: 'ZOYA', sex: 1 },
        { russian: 'ЗУЛИХАН', latin: null, sex: 1 },
        { russian: 'ЗУЛЬФИЯ', latin: null, sex: 1 },
        { russian: 'ЗУРА', latin: null, sex: 1 },
        { russian: 'ЗУХРА', latin: null, sex: 1 },
        { russian: 'ИВЕТТА', latin: null, sex: 1 },
        { russian: 'ИВОННА', latin: null, sex: 1 },
        { russian: 'ИДА', latin: null, sex: 1 },
        { russian: 'ИЗАБЕЛЛА', latin: null, sex: 1 },
        { russian: 'ИЗОЛЬДА', latin: null, sex: 1 },
        { russian: 'ИЛАНА', latin: null, sex: 1 },
        { russian: 'ИЛОНА', latin: null, sex: 1 },
        { russian: 'ИЛЬМИРА', latin: null, sex: 1 },
        { russian: 'ИНА', latin: null, sex: 1 },
        { russian: 'ИНАРА', latin: null, sex: 1 },
        { russian: 'ИНГА', latin: null, sex: 1 },
        { russian: 'ИНДИРА', latin: null, sex: 1 },
        { russian: 'ИНЕССА', latin: null, sex: 1 },
        { russian: 'ИННА', latin: null, sex: 1 },
        { russian: 'ИОАННА', latin: null, sex: 1 },
        { russian: 'ИОЛА', latin: null, sex: 1 },
        { russian: 'ИОЛАНТА', latin: null, sex: 1 },
        { russian: 'ИРА', latin: null, sex: 1 },
        { russian: 'ИРАДА', latin: null, sex: 1 },
        { russian: 'ИРАИДА', latin: null, sex: 1 },
        { russian: 'ИРЕНА', latin: null, sex: 1 },
        { russian: 'ИРЕНЕ', latin: null, sex: 1 },
        { russian: 'ИРИНА', latin: 'IRINA', sex: 1 },
        { russian: 'ИРМА', latin: null, sex: 1 },
        { russian: 'ИРЭНА', latin: null, sex: 1 },
        { russian: 'ИЯ', latin: 'IYA', sex: 1 },
        { russian: 'КАЛЕРИЯ', latin: null, sex: 1 },
        { russian: 'КАМИЛА', latin: null, sex: 1 },
        { russian: 'КАМИЛЛА', latin: null, sex: 1 },
        { russian: 'КАПИТОЛИНА', latin: null, sex: 1 },
        { russian: 'КАРИНА', latin: null, sex: 1 },
        { russian: 'КАРИНЕ', latin: null, sex: 1 },
        { russian: 'КАРИНЭ', latin: null, sex: 1 },
        { russian: 'КАРОЛИНА', latin: null, sex: 1 },
        { russian: 'КАТАРИНА', latin: null, sex: 1 },
        { russian: 'КАТЕРИНА', latin: null, sex: 1 },
        { russian: 'КАТРИН', latin: null, sex: 1 },
        { russian: 'КАТЯ', latin: null, sex: 1 },
        { russian: 'КЕТЕВАН', latin: null, sex: 1 },
        { russian: 'КИРА', latin: null, sex: 1 },
        { russian: 'КЛАВДИЯ', latin: null, sex: 1 },
        { russian: 'КЛАРА', latin: null, sex: 1 },
        { russian: 'КЛАРИСА', latin: null, sex: 1 },
        { russian: 'КЛЕМЕНТИНА', latin: null, sex: 1 },
        { russian: 'КЛЕОПАТРА', latin: null, sex: 1 },
        { russian: 'КНАРИК', latin: null, sex: 1 },
        { russian: 'КОНКОРДИЯ', latin: null, sex: 1 },
        { russian: 'КОНСТАНЦИЯ', latin: null, sex: 1 },
        { russian: 'КОРНЕЛИЯ', latin: null, sex: 1 },
        { russian: 'КРИСТИНА', latin: null, sex: 1 },
        { russian: 'КРИСТИНЕ', latin: null, sex: 1 },
        { russian: 'КСЕНИЯ', latin: 'KSENIA', sex: 1 },
        { russian: 'ЛАДА', latin: null, sex: 1 },
        { russian: 'ЛАЙЛА', latin: null, sex: 1 },
        { russian: 'ЛАЛА', latin: null, sex: 1 },
        { russian: 'ЛАЛИ', latin: null, sex: 1 },
        { russian: 'ЛАМАРА', latin: null, sex: 1 },
        { russian: 'ЛАНА', latin: null, sex: 1 },
        { russian: 'ЛАРА', latin: null, sex: 1 },
        { russian: 'ЛАРИСА', latin: 'LARISA', sex: 1 },
        { russian: 'ЛАРИССА', latin: null, sex: 1 },
        { russian: 'ЛАУРА', latin: null, sex: 1 },
        { russian: 'ЛЕЙЛА', latin: null, sex: 1 },
        { russian: 'ЛЕЙЛИ', latin: null, sex: 1 },
        { russian: 'ЛЕЙСАН', latin: null, sex: 1 },
        { russian: 'ЛЕНА', latin: null, sex: 1 },
        { russian: 'ЛЕНИНА', latin: null, sex: 1 },
        { russian: 'ЛЕОКАДИЯ', latin: null, sex: 1 },
        { russian: 'ЛЕОНИДА', latin: null, sex: 1 },
        { russian: 'ЛЕСЯ', latin: null, sex: 1 },
        { russian: 'ЛЕЯ', latin: null, sex: 1 },
        { russian: 'ЛИАНА', latin: null, sex: 1 },
        { russian: 'ЛИДА', latin: null, sex: 1 },
        { russian: 'ЛИДИЯ', latin: 'LIDIA', sex: 1 },
        { russian: 'ЛИЗА', latin: null, sex: 1 },
        { russian: 'ЛИЛИ', latin: null, sex: 1 },
        { russian: 'ЛИЛИАНА', latin: null, sex: 1 },
        { russian: 'ЛИЛИТ', latin: null, sex: 1 },
        { russian: 'ЛИЛИЯ', latin: null, sex: 1 },
        { russian: 'ЛИЛЛИ', latin: null, sex: 1 },
        { russian: 'ЛИЛЯ', latin: null, sex: 1 },
        { russian: 'ЛИНА', latin: null, sex: 1 },
        { russian: 'ЛИНДА', latin: null, sex: 1 },
        { russian: 'ЛИРА', latin: null, sex: 1 },
        { russian: 'ЛИЯ', latin: null, sex: 1 },
        { russian: 'ЛОЛА', latin: null, sex: 1 },
        { russian: 'ЛОЛИТА', latin: null, sex: 1 },
        { russian: 'ЛОРА', latin: null, sex: 1 },
        { russian: 'ЛУИЗА', latin: null, sex: 1 },
        { russian: 'ЛУКЕРЬЯ', latin: null, sex: 1 },
        { russian: 'ЛУКРЕЦИЯ', latin: null, sex: 1 },
        { russian: 'ЛУСИНЕ', latin: null, sex: 1 },
        { russian: 'ЛЮБА', latin: null, sex: 1 },
        { russian: 'ЛЮБАВА', latin: null, sex: 1 },
        { russian: 'ЛЮБОВЬ', latin: 'LIUBOV', sex: 1 },
        { russian: 'ЛЮБОМИРА', latin: null, sex: 1 },
        { russian: 'ЛЮДМИЛА', latin: 'LIUDMILA', sex: 1 },
        { russian: 'ЛЮСЯ', latin: null, sex: 1 },
        { russian: 'ЛЮЦИЯ', latin: null, sex: 1 },
        { russian: 'МАВРА', latin: null, sex: 1 },
        { russian: 'МАГДА', latin: null, sex: 1 },
        { russian: 'МАГДАЛИНА', latin: null, sex: 1 },
        { russian: 'МАДИНА', latin: null, sex: 1 },
        { russian: 'МАИНА', latin: null, sex: 1 },
        { russian: 'МАЙЯ', latin: 'MAYYA', sex: 1 },
        { russian: 'МАККА', latin: null, sex: 1 },
        { russian: 'МАЛАНИЯ', latin: null, sex: 1 },
        { russian: 'МАЛАНЬЯ', latin: null, sex: 1 },
        { russian: 'МАЛИКА', latin: null, sex: 1 },
        { russian: 'МАЛЬВИНА', latin: null, sex: 1 },
        { russian: 'МАНАНА', latin: null, sex: 1 },
        { russian: 'МАРАЛ', latin: null, sex: 1 },
        { russian: 'МАРГАРИТА', latin: 'MARGARITA', sex: 1 },
        { russian: 'МАРЕМ', latin: null, sex: 1 },
        { russian: 'МАРЕТ', latin: null, sex: 1 },
        { russian: 'МАРИ', latin: null, sex: 1 },
        { russian: 'МАРИАМ', latin: null, sex: 1 },
        { russian: 'МАРИАНА', latin: null, sex: 1 },
        { russian: 'МАРИАННА', latin: null, sex: 1 },
        { russian: 'МАРИЕТТА', latin: null, sex: 1 },
        { russian: 'МАРИНА', latin: null, sex: 1 },
        { russian: 'МАРИНЕ', latin: null, sex: 1 },
        { russian: 'МАРИЯ', latin: 'MARIA', sex: 1 },
        { russian: 'МАРИЯМ', latin: null, sex: 1 },
        { russian: 'МАРЛЕНА', latin: null, sex: 1 },
        { russian: 'МАРТА', latin: null, sex: 1 },
        { russian: 'МАРТИНА', latin: null, sex: 1 },
        { russian: 'МАРФА', latin: 'MARFA', sex: 1 },
        { russian: 'МАРХА', latin: null, sex: 1 },
        { russian: 'МАРЬЯ', latin: null, sex: 1 },
        { russian: 'МАРЬЯМ', latin: null, sex: 1 },
        { russian: 'МАРЬЯНА', latin: null, sex: 1 },
        { russian: 'МАТА', latin: null, sex: 1 },
        { russian: 'МАТИЛЬДА', latin: null, sex: 1 },
        { russian: 'МАТРЁНА', latin: null, sex: 1 },
        { russian: 'МАТРОНА', latin: null, sex: 1 },
        { russian: 'МАЯ', latin: null, sex: 1 },
        { russian: 'МЕДЕЯ', latin: null, sex: 1 },
        { russian: 'МЕДИНА', latin: null, sex: 1 },
        { russian: 'МЕЛАНИ', latin: null, sex: 1 },
        { russian: 'МЕЛАНИЯ', latin: null, sex: 1 },
        { russian: 'МЕЛИСА', latin: null, sex: 1 },
        { russian: 'МЕЛИССА', latin: null, sex: 1 },
        { russian: 'МЕЛИТИНА', latin: null, sex: 1 },
        { russian: 'МЕРИ', latin: null, sex: 1 },
        { russian: 'МИЛА', latin: null, sex: 1 },
        { russian: 'МИЛАНА', latin: null, sex: 1 },
        { russian: 'МИЛЕНА', latin: null, sex: 1 },
        { russian: 'МИЛИЦА', latin: null, sex: 1 },
        { russian: 'МИЛОСЛАВА', latin: null, sex: 1 },
        { russian: 'МИНА', latin: null, sex: 1 },
        { russian: 'МИННА', latin: null, sex: 1 },
        { russian: 'МИРА', latin: null, sex: 1 },
        { russian: 'МИРОСЛАВА', latin: null, sex: 1 },
        { russian: 'МИРРА', latin: null, sex: 1 },
        { russian: 'МОНИКА', latin: null, sex: 1 },
        { russian: 'МСТИСЛАВА', latin: null, sex: 1 },
        { russian: 'МУЗА', latin: null, sex: 1 },
        { russian: 'МУНИРА', latin: null, sex: 1 },
        { russian: 'МУХАББАТ', latin: null, sex: 1 },
        { russian: 'МЭРИ', latin: null, sex: 1 },
        { russian: 'НАДЕЖДА', latin: 'NADEZHDA', sex: 1 },
        { russian: 'НАДИЯ', latin: null, sex: 1 },
        { russian: 'НАДЯ', latin: null, sex: 1 },
        { russian: 'НАЗИРА', latin: null, sex: 1 },
        { russian: 'НАИДА', latin: null, sex: 1 },
        { russian: 'НАИЛЯ', latin: null, sex: 1 },
        { russian: 'НАИРА', latin: null, sex: 1 },
        { russian: 'НАЙЛЯ', latin: null, sex: 1 },
        { russian: 'НАНА', latin: null, sex: 1 },
        { russian: 'НАРГИЗ', latin: null, sex: 1 },
        { russian: 'НАРГИЗА', latin: null, sex: 1 },
        { russian: 'НАРГИС', latin: null, sex: 1 },
        { russian: 'НАРИНЕ', latin: null, sex: 1 },
        { russian: 'НАРИНЭ', latin: null, sex: 1 },
        { russian: 'НАСИБА', latin: null, sex: 1 },
        { russian: 'НАСТАСИЯ', latin: null, sex: 1 },
        { russian: 'НАСТАСЬЯ', latin: null, sex: 1 },
        { russian: 'НАТАЛИ', latin: null, sex: 1 },
        { russian: 'НАТАЛИЯ', latin: null, sex: 1 },
        { russian: 'НАТАЛЬЯ', latin: 'NATALIA', sex: 1 },
        { russian: 'НАТАША', latin: null, sex: 1 },
        { russian: 'НАТЕЛА', latin: null, sex: 1 },
        { russian: 'НАТЕЛЛА', latin: null, sex: 1 },
        { russian: 'НЕЛИ', latin: null, sex: 1 },
        { russian: 'НЕЛЛИ', latin: null, sex: 1 },
        { russian: 'НЕЛЛЯ', latin: null, sex: 1 },
        { russian: 'НЕЛЯ', latin: null, sex: 1 },
        { russian: 'НЕНИЛА', latin: null, sex: 1 },
        { russian: 'НЕОНИЛА', latin: null, sex: 1 },
        { russian: 'НИГИНА', latin: null, sex: 1 },
        { russian: 'НИГОРА', latin: null, sex: 1 },
        { russian: 'НИКОЛЬ', latin: null, sex: 1 },
        { russian: 'НИЛУФАР', latin: null, sex: 1 },
        { russian: 'НИНА', latin: null, sex: 1 },
        { russian: 'НИНЕЛЬ', latin: null, sex: 1 },
        { russian: 'НИНО', latin: null, sex: 1 },
        { russian: 'НОВЕЛЛА', latin: null, sex: 1 },
        { russian: 'НОДИРА', latin: null, sex: 1 },
        { russian: 'НОНА', latin: null, sex: 1 },
        { russian: 'НОННА', latin: null, sex: 1 },
        { russian: 'НОРА', latin: null, sex: 1 },
        { russian: 'НОЯБРИНА', latin: null, sex: 1 },
        { russian: 'НУНЕ', latin: null, sex: 1 },
        { russian: 'НУРИЯ', latin: null, sex: 1 },
        { russian: 'НЭЛЛИ', latin: null, sex: 1 },
        { russian: 'НЭЛЯ', latin: null, sex: 1 },
        { russian: 'ОЙГЕНИЯ', latin: null, sex: 1 },
        { russian: 'ОКСАНА', latin: 'OXANA', sex: 1 },
        { russian: 'ОКТЯБРИНА', latin: null, sex: 1 },
        { russian: 'ОЛЕСЯ', latin: null, sex: 1 },
        { russian: 'ОЛИВИЯ', latin: null, sex: 1 },
        { russian: 'ОЛИМПИАДА', latin: null, sex: 1 },
        { russian: 'ОЛИМПИЯ', latin: null, sex: 1 },
        { russian: 'ОЛЬГА', latin: 'OLGA', sex: 1 },
        { russian: 'ПАВЛА', latin: null, sex: 1 },
        { russian: 'ПАВЛИНА', latin: null, sex: 1 },
        { russian: 'ПАРАСКЕВА', latin: null, sex: 1 },
        { russian: 'ПАРВИНА', latin: null, sex: 1 },
        { russian: 'ПАТИМАТ', latin: null, sex: 1 },
        { russian: 'ПАУЛИНА', latin: null, sex: 1 },
        { russian: 'ПЕЛАГЕЯ', latin: 'PELAGEYA', sex: 1 },
        { russian: 'ПЕТИМАТ', latin: null, sex: 1 },
        { russian: 'ПЛАТОНИДА', latin: null, sex: 1 },
        { russian: 'ПОЛИКСЕНА', latin: null, sex: 1 },
        { russian: 'ПОЛИКСЕНИЯ', latin: null, sex: 1 },
        { russian: 'ПОЛИНА', latin: null, sex: 1 },
        { russian: 'ПРАСКОВЬЯ', latin: 'PRASKOVIA', sex: 1 },
        { russian: 'ПУЛЬХЕРИЯ', latin: null, sex: 1 },
        { russian: 'РАДА', latin: null, sex: 1 },
        { russian: 'РАДИМА', latin: null, sex: 1 },
        { russian: 'РАДМИЛА', latin: null, sex: 1 },
        { russian: 'РАИСА', latin: 'RAISA', sex: 1 },
        { russian: 'РАМЗИЯ', latin: null, sex: 1 },
        { russian: 'РАМИЛЯ', latin: null, sex: 1 },
        { russian: 'РАНО', latin: null, sex: 1 },
        { russian: 'РАХИЛЬ', latin: null, sex: 1 },
        { russian: 'РАШИДА', latin: null, sex: 1 },
        { russian: 'РАЯ', latin: null, sex: 1 },
        { russian: 'РАЯНА', latin: null, sex: 1 },
        { russian: 'РЕВЕККА', latin: null, sex: 1 },
        { russian: 'РЕГИНА', latin: null, sex: 1 },
        { russian: 'РЕЗЕДА', latin: null, sex: 1 },
        { russian: 'РЕНА', latin: null, sex: 1 },
        { russian: 'РЕНАТА', latin: null, sex: 1 },
        { russian: 'РИВА', latin: null, sex: 1 },
        { russian: 'РИМА', latin: null, sex: 1 },
        { russian: 'РИММА', latin: null, sex: 1 },
        { russian: 'РИНА', latin: null, sex: 1 },
        { russian: 'РИТА', latin: null, sex: 1 },
        { russian: 'РОЗА', latin: null, sex: 1 },
        { russian: 'РОЗАЛИНА', latin: null, sex: 1 },
        { russian: 'РОЗАЛИЯ', latin: null, sex: 1 },
        { russian: 'РОКСАНА', latin: null, sex: 1 },
        { russian: 'РОСТИСЛАВА', latin: null, sex: 1 },
        { russian: 'РУЗАНА', latin: null, sex: 1 },
        { russian: 'РУЗАННА', latin: null, sex: 1 },
        { russian: 'РУМИЯ', latin: null, sex: 1 },
        { russian: 'РУСЛАНА', latin: null, sex: 1 },
        { russian: 'РУФИНА', latin: null, sex: 1 },
        { russian: 'РУФЬ', latin: null, sex: 1 },
        { russian: 'САБИНА', latin: null, sex: 1 },
        { russian: 'САБРИНА', latin: null, sex: 1 },
        { russian: 'САИДА', latin: null, sex: 1 },
        { russian: 'САЛИМА', latin: null, sex: 1 },
        { russian: 'САЛОМЕЯ', latin: null, sex: 1 },
        { russian: 'САМИРА', latin: null, sex: 1 },
        { russian: 'САНДРА', latin: null, sex: 1 },
        { russian: 'САНИЯ', latin: null, sex: 1 },
        { russian: 'САРА', latin: null, sex: 1 },
        { russian: 'САРРА', latin: null, sex: 1 },
        { russian: 'САТЕНИК', latin: null, sex: 1 },
        { russian: 'САФИЯ', latin: null, sex: 1 },
        { russian: 'САЦИТА', latin: null, sex: 1 },
        { russian: 'СВЕТЛАНА', latin: null, sex: 1 },
        { russian: 'СЕВДА', latin: null, sex: 1 },
        { russian: 'СЕВИЛЬ', latin: null, sex: 1 },
        { russian: 'СЕДА', latin: null, sex: 1 },
        { russian: 'СЕКЛЕТЕЯ', latin: null, sex: 1 },
        { russian: 'СЕЛИМА', latin: null, sex: 1 },
        { russian: 'СЕРАФИМА', latin: null, sex: 1 },
        { russian: 'СИЛЬВА', latin: null, sex: 1 },
        { russian: 'СИЛЬВИЯ', latin: null, sex: 1 },
        { russian: 'СИМА', latin: null, sex: 1 },
        { russian: 'СИМОНА', latin: null, sex: 1 },
        { russian: 'СИРАНУШ', latin: null, sex: 1 },
        { russian: 'СИТОРА', latin: null, sex: 1 },
        { russian: 'СНЕЖАНА', latin: null, sex: 1 },
        { russian: 'СОЛОМОНИДА', latin: null, sex: 1 },
        { russian: 'СОЛОМОНИЯ', latin: null, sex: 1 },
        { russian: 'СОНА', latin: null, sex: 1 },
        { russian: 'СОНЯ', latin: null, sex: 1 },
        { russian: 'СОФИ', latin: null, sex: 1 },
        { russian: 'СОФИЯ', latin: null, sex: 1 },
        { russian: 'СОФЬЯ', latin: null, sex: 1 },
        { russian: 'СТАНИСЛАВА', latin: null, sex: 1 },
        { russian: 'СТЕЛЛА', latin: null, sex: 1 },
        { russian: 'СТЕПАНИДА', latin: 'STEPANIDA', sex: 1 },
        { russian: 'СТЕФАНИ', latin: null, sex: 1 },
        { russian: 'СТЕФАНИДА', latin: null, sex: 1 },
        { russian: 'СТЕФАНИЯ', latin: null, sex: 1 },
        { russian: 'СУСАНА', latin: null, sex: 1 },
        { russian: 'СУСАННА', latin: 'SUSANNA', sex: 1 },
        { russian: 'СЮЗАННА', latin: null, sex: 1 },
        { russian: 'ТАИСА', latin: null, sex: 1 },
        { russian: 'ТАИСИЯ', latin: null, sex: 1 },
        { russian: 'ТАИСЬЯ', latin: null, sex: 1 },
        { russian: 'ТАМАРА', latin: null, sex: 1 },
        { russian: 'ТАМИЛА', latin: null, sex: 1 },
        { russian: 'ТАНЗИЛА', latin: null, sex: 1 },
        { russian: 'ТАНЗИЛЯ', latin: null, sex: 1 },
        { russian: 'ТАНЯ', latin: null, sex: 1 },
        { russian: 'ТАТЕВИК', latin: null, sex: 1 },
        { russian: 'ТАТЬЯНА', latin: 'TATIANA', sex: 1 },
        { russian: 'ТАХМИНА', latin: null, sex: 1 },
        { russian: 'ТЕРЕЗА', latin: null, sex: 1 },
        { russian: 'ТИНА', latin: null, sex: 1 },
        { russian: 'УЛИТА', latin: null, sex: 1 },
        { russian: 'УЛЬЯНА', latin: 'ULIANA', sex: 1 },
        { russian: 'УСТИНА', latin: null, sex: 1 },
        { russian: 'УСТИНИЯ', latin: null, sex: 1 },
        { russian: 'УСТИНЬЯ', latin: null, sex: 1 },
        { russian: 'ФАИНА', latin: null, sex: 1 },
        { russian: 'ФАНЯ', latin: null, sex: 1 },
        { russian: 'ФАРЗОНА', latin: null, sex: 1 },
        { russian: 'ФАРИДА', latin: null, sex: 1 },
        { russian: 'ФАРИЗА', latin: null, sex: 1 },
        { russian: 'ФАТИМА', latin: null, sex: 1 },
        { russian: 'ФЕВРОНИЯ', latin: null, sex: 1 },
        { russian: 'ФЕВРОНЬЯ', latin: null, sex: 1 },
        { russian: 'ФЕДОРА', latin: null, sex: 1 },
        { russian: 'ФЕДОСИЯ', latin: null, sex: 1 },
        { russian: 'ФЕДОСЬЯ', latin: 'FEDOSIA', sex: 1 },
        { russian: 'ФЕДОТИЯ', latin: null, sex: 1 },
        { russian: 'ФЕДОТЬЯ', latin: null, sex: 1 },
        { russian: 'ФЁКЛА', latin: null, sex: 1 },
        { russian: 'ФЕЛИЦА', latin: null, sex: 1 },
        { russian: 'ФЕЛИЦАТА', latin: null, sex: 1 },
        { russian: 'ФЕЛИЦИЯ', latin: null, sex: 1 },
        { russian: 'ФЕОДОРА', latin: null, sex: 1 },
        { russian: 'ФЕОДОСИЯ', latin: null, sex: 1 },
        { russian: 'ФЕОДОТИЯ', latin: null, sex: 1 },
        { russian: 'ФЕОКТИСТА', latin: null, sex: 1 },
        { russian: 'ФЕОНА', latin: null, sex: 1 },
        { russian: 'ФЕОФАНИЯ', latin: null, sex: 1 },
        { russian: 'ФЕОФИЛА', latin: null, sex: 1 },
        { russian: 'ФЕРУЗА', latin: null, sex: 1 },
        { russian: 'ФЕТИНИЯ', latin: null, sex: 1 },
        { russian: 'ФЕТИНЬЯ', latin: null, sex: 1 },
        { russian: 'ФИРУЗА', latin: null, sex: 1 },
        { russian: 'ФЛЁНА', latin: null, sex: 1 },
        { russian: 'ФЛОРА', latin: null, sex: 1 },
        { russian: 'ФЛЮРА', latin: null, sex: 1 },
        { russian: 'ФРИДА', latin: null, sex: 1 },
        { russian: 'ФРИДЕРИКА', latin: null, sex: 1 },
        { russian: 'ХАВА', latin: null, sex: 1 },
        { russian: 'ХАВРОНИЯ', latin: null, sex: 1 },
        { russian: 'ХАДИЖА', latin: null, sex: 1 },
        { russian: 'ХАДИЖАТ', latin: null, sex: 1 },
        { russian: 'ХАЛИДА', latin: null, sex: 1 },
        { russian: 'ХАЛИМА', latin: null, sex: 1 },
        { russian: 'ХАНА', latin: null, sex: 1 },
        { russian: 'ХАРИТА', latin: null, sex: 1 },
        { russian: 'ХАТУНА', latin: null, sex: 1 },
        { russian: 'ХЕДА', latin: null, sex: 1 },
        { russian: 'ХЕДИ', latin: null, sex: 1 },
        { russian: 'ХЕЛЕНА', latin: null, sex: 1 },
        { russian: 'ХЕЛЕНЕ', latin: null, sex: 1 },
        { russian: 'ХРИСТИНА', latin: 'KHRISTINA', sex: 1 },
        { russian: 'ЦЕЦИЛИЯ', latin: null, sex: 1 },
        { russian: 'ЦИЛЯ', latin: null, sex: 1 },
        { russian: 'ШАРЛОТТА', latin: null, sex: 1 },
        { russian: 'ШАХНОЗА', latin: null, sex: 1 },
        { russian: 'ЭВЕЛИН', latin: null, sex: 1 },
        { russian: 'ЭВЕЛИНА', latin: null, sex: 1 },
        { russian: 'ЭДИТ', latin: null, sex: 1 },
        { russian: 'ЭДИТА', latin: null, sex: 1 },
        { russian: 'ЭЛЕН', latin: null, sex: 1 },
        { russian: 'ЭЛЕОНОРА', latin: null, sex: 1 },
        { russian: 'ЭЛИЗА', latin: null, sex: 1 },
        { russian: 'ЭЛИЗАБЕТ', latin: null, sex: 1 },
        { russian: 'ЭЛИНА', latin: null, sex: 1 },
        { russian: 'ЭЛИТА', latin: null, sex: 1 },
        { russian: 'ЭЛЛА', latin: null, sex: 1 },
        { russian: 'ЭЛЛАДА', latin: null, sex: 1 },
        { russian: 'ЭЛЛЕН', latin: null, sex: 1 },
        { russian: 'ЭЛЛИНА', latin: null, sex: 1 },
        { russian: 'ЭЛЬВИНА', latin: null, sex: 1 },
        { russian: 'ЭЛЬВИРА', latin: null, sex: 1 },
        { russian: 'ЭЛЬЗА', latin: null, sex: 1 },
        { russian: 'ЭЛЬМИРА', latin: null, sex: 1 },
        { russian: 'ЭЛЬНАРА', latin: null, sex: 1 },
        { russian: 'ЭЛЯ', latin: null, sex: 1 },
        { russian: 'ЭМИЛИ', latin: null, sex: 1 },
        { russian: 'ЭМИЛИЯ', latin: null, sex: 1 },
        { russian: 'ЭММА', latin: null, sex: 1 },
        { russian: 'ЭРА', latin: null, sex: 1 },
        { russian: 'ЭРИКА', latin: null, sex: 1 },
        { russian: 'ЭРНА', latin: null, sex: 1 },
        { russian: 'ЭРНЕСТИНА', latin: null, sex: 1 },
        { russian: 'ЭСЕТ', latin: null, sex: 1 },
        { russian: 'ЭСМИРА', latin: null, sex: 1 },
        { russian: 'ЭСФИРЬ', latin: null, sex: 1 },
        { russian: 'ЭТЕРИ', latin: null, sex: 1 },
        { russian: 'ЮДИФЬ', latin: null, sex: 1 },
        { russian: 'ЮЛДУЗ', latin: null, sex: 1 },
        { russian: 'ЮЛИАНА', latin: null, sex: 1 },
        { russian: 'ЮЛИАНИЯ', latin: null, sex: 1 },
        { russian: 'ЮЛИАННА', latin: null, sex: 1 },
        { russian: 'ЮЛИЯ', latin: 'YULIA', sex: 1 },
        { russian: 'ЮСТИНА', latin: null, sex: 1 },
        { russian: 'ЯДВИГА', latin: null, sex: 1 },
        { russian: 'ЯНА', latin: 'YANA', sex: 1 },
        { russian: 'ЯНИНА', latin: null, sex: 1 },
        { russian: 'ЯРОСЛАВА', latin: null, sex: 1 },
        { russian: 'ЯСМИН', latin: null, sex: 1 },
        { russian: 'ЯСМИНА', latin: null, sex: 1 },
        { russian: 'ЯХА', latin: null, sex: 1 }
    ];

    public static middleNames: DictionaryPersonName[] = [
        { russian: 'АБАКУМОВИЧ', latin: null, sex: 0 },
        { russian: 'АБРАМОВИЧ', latin: null, sex: 0 },
        { russian: 'АБРОСИМОВИЧ', latin: null, sex: 0 },
        { russian: 'АВВАКУМОВИЧ', latin: null, sex: 0 },
        { russian: 'АВГУСТОВИЧ', latin: null, sex: 0 },
        { russian: 'АВДЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'АВДИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АВЕЛЕВИЧ', latin: null, sex: 0 },
        { russian: 'АВЕНИРОВИЧ', latin: null, sex: 0 },
        { russian: 'АВЕРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АВЕРКИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АВЕРЬЯНОВИЧ', latin: null, sex: 0 },
        { russian: 'АВКСЕНТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АВКСЕНТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АВРААМИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АВРААМОВИЧ', latin: null, sex: 0 },
        { russian: 'АВРААМЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АВРАМИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АВРАМОВИЧ', latin: null, sex: 0 },
        { russian: 'АВРАМЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АВРЕЛИАНОВИЧ', latin: null, sex: 0 },
        { russian: 'АВТОНОМОВИЧ', latin: null, sex: 0 },
        { russian: 'АГАПИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АГАПИТОВИЧ', latin: null, sex: 0 },
        { russian: 'АГАПОВИЧ', latin: null, sex: 0 },
        { russian: 'АГАПЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АГАФОНОВИЧ', latin: null, sex: 0 },
        { russian: 'АГГЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'АДАМОВИЧ', latin: null, sex: 0 },
        { russian: 'АДРИАНОВИЧ', latin: null, sex: 0 },
        { russian: 'АЗАРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АЗАРОВИЧ', latin: null, sex: 0 },
        { russian: 'АЗАРЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АКАКИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АКИМОВИЧ', latin: null, sex: 0 },
        { russian: 'АКИНДИНОВИЧ', latin: null, sex: 0 },
        { russian: 'АКИНФИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АКИНФОВИЧ', latin: null, sex: 0 },
        { russian: 'АКИНФЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АКСЁНОВИЧ', latin: null, sex: 0 },
        { russian: 'АКСЕНТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АКСЕНТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АЛЕКСАНДРОВИЧ', latin: null, sex: 0 },
        { russian: 'АЛЕКСЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'АЛЕКСИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АЛЬБЕРТОВИЧ', latin: null, sex: 0 },
        { russian: 'АЛЬФРЕДОВИЧ', latin: null, sex: 0 },
        { russian: 'АМВРОСИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АМВРОСЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АМОСОВИЧ', latin: null, sex: 0 },
        { russian: 'АМФИЛОХИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АМФИЛОХЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АНАНИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АНАНЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АНАСТАСИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АНАСТАСЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АНАТОЛИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АНАТОЛЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АНДРЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'АНДРИАНОВИЧ', latin: null, sex: 0 },
        { russian: 'АНДРОНИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АНДРОНИКОВИЧ', latin: null, sex: 0 },
        { russian: 'АНДРОНОВИЧ', latin: null, sex: 0 },
        { russian: 'АНДРОНЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АНИКЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'АНИКИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АНИКИТИЧ', latin: null, sex: 0 },
        { russian: 'АНИСИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АНИСИМОВИЧ', latin: null, sex: 0 },
        { russian: 'АНИСЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АНТИОХОВИЧ', latin: null, sex: 0 },
        { russian: 'АНТИПИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АНТИПИЧ', latin: null, sex: 0 },
        { russian: 'АНТИПОВИЧ', latin: null, sex: 0 },
        { russian: 'АНТИПЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АНТОНИНОВИЧ', latin: null, sex: 0 },
        { russian: 'АНТОНОВИЧ', latin: null, sex: 0 },
        { russian: 'АНТРОПИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АНТРОПОВИЧ', latin: null, sex: 0 },
        { russian: 'АНТРОПЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АНУФРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АПОЛЛИНАРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АПОЛЛИНАРЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АПОЛЛОНОВИЧ', latin: null, sex: 0 },
        { russian: 'АПОЛЛОСОВИЧ', latin: null, sex: 0 },
        { russian: 'АРДАЛИОНОВИЧ', latin: null, sex: 0 },
        { russian: 'АРДАЛЬОНОВИЧ', latin: null, sex: 0 },
        { russian: 'АРЕФИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АРЕФОВИЧ', latin: null, sex: 0 },
        { russian: 'АРЕФЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АРИСТАРХОВИЧ', latin: null, sex: 0 },
        { russian: 'АРИСТИДОВИЧ', latin: null, sex: 0 },
        { russian: 'АРКАДИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АРКАДЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АРНОЛЬДОВИЧ', latin: null, sex: 0 },
        { russian: 'АРОНОВИЧ', latin: null, sex: 0 },
        { russian: 'АРСЕНИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АРСЕНОВИЧ', latin: null, sex: 0 },
        { russian: 'АРСЕНТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АРСЕНТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АРСЕНЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АРТАМОНОВИЧ', latin: null, sex: 0 },
        { russian: 'АРТЕМИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АРТЁМОВИЧ', latin: null, sex: 0 },
        { russian: 'АРТЕМЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АРТУРОВИЧ', latin: null, sex: 0 },
        { russian: 'АРХИПОВИЧ', latin: null, sex: 0 },
        { russian: 'АРЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АСАФИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АСАФОВИЧ', latin: null, sex: 0 },
        { russian: 'АСАФЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АСКОЛЬДОВИЧ', latin: null, sex: 0 },
        { russian: 'АФАНАСИЕВИЧ', latin: null, sex: 0 },
        { russian: 'АФАНАСЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'АФИНОГЕНОВИЧ', latin: null, sex: 0 },
        { russian: 'АФРИКАНОВИЧ', latin: null, sex: 0 },
        { russian: 'БЕНЕДИКТОВИЧ', latin: null, sex: 0 },
        { russian: 'БОГДАНОВИЧ', latin: null, sex: 0 },
        { russian: 'БОЛЕСЛАВИЧ', latin: null, sex: 0 },
        { russian: 'БОЛЕСЛАВОВИЧ', latin: null, sex: 0 },
        { russian: 'БОНИФАТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'БОНИФАТОВИЧ', latin: null, sex: 0 },
        { russian: 'БОНИФАТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'БОРИСЛАВИЧ', latin: null, sex: 0 },
        { russian: 'БОРИСЛАВОВИЧ', latin: null, sex: 0 },
        { russian: 'БОРИСОВИЧ', latin: null, sex: 0 },
        { russian: 'БРОНИСЛАВИЧ', latin: null, sex: 0 },
        { russian: 'БРОНИСЛАВОВИЧ', latin: null, sex: 0 },
        { russian: 'ВАВИЛИЧ', latin: null, sex: 0 },
        { russian: 'ВАВИЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ВАДИМОВИЧ', latin: null, sex: 0 },
        { russian: 'ВАЛЕНТИНОВИЧ', latin: null, sex: 0 },
        { russian: 'ВАЛЕРИАНОВИЧ', latin: null, sex: 0 },
        { russian: 'ВАЛЕРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ВАЛЕРЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ВАЛЕРЬЯНОВИЧ', latin: null, sex: 0 },
        { russian: 'ВАРЛАМИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ВАРЛАМОВИЧ', latin: null, sex: 0 },
        { russian: 'ВАРЛАМЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ВАРНАВИЧ', latin: null, sex: 0 },
        { russian: 'ВАРСОНОФИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ВАРСОНОФОВИЧ', latin: null, sex: 0 },
        { russian: 'ВАРСОНОФЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ВАРФОЛОМЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'ВАСИЛЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ВАССИАНОВИЧ', latin: null, sex: 0 },
        { russian: 'ВЕЛИЗАРОВИЧ', latin: null, sex: 0 },
        { russian: 'ВЕЛИМИРОВИЧ', latin: null, sex: 0 },
        { russian: 'ВЕНЕДИКТОВИЧ', latin: null, sex: 0 },
        { russian: 'ВЕНИАМИНОВИЧ', latin: null, sex: 0 },
        { russian: 'ВЕНЦЕСЛАВИЧ', latin: null, sex: 0 },
        { russian: 'ВЕНЦЕСЛАВОВИЧ', latin: null, sex: 0 },
        { russian: 'ВЕНЬЯМИНОВИЧ', latin: null, sex: 0 },
        { russian: 'ВИКЕНТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ВИКЕНТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ВИКТОРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ВИКТОРОВИЧ', latin: null, sex: 0 },
        { russian: 'ВИКУЛИЧ', latin: null, sex: 0 },
        { russian: 'ВИКУЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ВИЛЕНОВИЧ', latin: null, sex: 0 },
        { russian: 'ВИЛЬГЕЛЬМОВИЧ', latin: null, sex: 0 },
        { russian: 'ВИССАРИОНОВИЧ', latin: null, sex: 0 },
        { russian: 'ВИТАЛИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ВИТАЛЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ВИТОЛЬДОВИЧ', latin: null, sex: 0 },
        { russian: 'ВЛАДИЛЕНОВИЧ', latin: null, sex: 0 },
        { russian: 'ВЛАДИМИРОВИЧ', latin: null, sex: 0 },
        { russian: 'ВЛАДИСЛАВИЧ', latin: null, sex: 0 },
        { russian: 'ВЛАДИСЛАВОВИЧ', latin: null, sex: 0 },
        { russian: 'ВЛАДЛЕНОВИЧ', latin: null, sex: 0 },
        { russian: 'ВЛАСИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ВЛАСОВИЧ', latin: null, sex: 0 },
        { russian: 'ВЛАСЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ВОНИФАТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ВОНИФАТОВИЧ', latin: null, sex: 0 },
        { russian: 'ВОНИФАТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ВСЕВОЛОДОВИЧ', latin: null, sex: 0 },
        { russian: 'ВСЕСЛАВИЧ', latin: null, sex: 0 },
        { russian: 'ВСЕСЛАВОВИЧ', latin: null, sex: 0 },
        { russian: 'ВУКОЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ВЫШЕСЛАВИЧ', latin: null, sex: 0 },
        { russian: 'ВЫШЕСЛАВОВИЧ', latin: null, sex: 0 },
        { russian: 'ВЯЧЕСЛАВИЧ', latin: null, sex: 0 },
        { russian: 'ВЯЧЕСЛАВОВИЧ', latin: null, sex: 0 },
        { russian: 'ГАВРИИЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ГАВРИЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ГАЛАКТИОНОВИЧ', latin: null, sex: 0 },
        { russian: 'ГЕДЕОНОВИЧ', latin: null, sex: 0 },
        { russian: 'ГЕЛАСИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ГЕЛАСЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ГЕЛИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ГЕННАДИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ГЕННАДЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ГЕНРИХОВИЧ', latin: null, sex: 0 },
        { russian: 'ГЕОРГИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ГЕРАСИМОВИЧ', latin: null, sex: 0 },
        { russian: 'ГЕРМАНОВИЧ', latin: null, sex: 0 },
        { russian: 'ГЕРМОГЕНОВИЧ', latin: null, sex: 0 },
        { russian: 'ГЕРОНТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ГЕРОНТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ГИАЦИНТОВИЧ', latin: null, sex: 0 },
        { russian: 'ГЛЕБОВИЧ', latin: null, sex: 0 },
        { russian: 'ГОРАЦИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ГОРГОНИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ГОРГОНЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ГОРДЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'ГРИГОРЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ГУРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ГУРЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ГУРЬЯНОВИЧ', latin: null, sex: 0 },
        { russian: 'ДАВИДОВИЧ', latin: null, sex: 0 },
        { russian: 'ДАВЫДОВИЧ', latin: null, sex: 0 },
        { russian: 'ДАЛМАТОВИЧ', latin: null, sex: 0 },
        { russian: 'ДАНИИЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ДАНИЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ДЕМЕНТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ДЕМЕНТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ДЕМИДОВИЧ', latin: null, sex: 0 },
        { russian: 'ДЕМЬЯНОВИЧ', latin: null, sex: 0 },
        { russian: 'ДЕНИСИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ДЕНИСОВИЧ', latin: null, sex: 0 },
        { russian: 'ДЕНИСЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ДИМИТРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ДИОМИДОВИЧ', latin: null, sex: 0 },
        { russian: 'ДИОНИСИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ДИОНИСЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ДМИТРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ДОБРОМЫСЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ДОБРЫНИЧ', latin: null, sex: 0 },
        { russian: 'ДОМИНИКОВИЧ', latin: null, sex: 0 },
        { russian: 'ДОНАТОВИЧ', latin: null, sex: 0 },
        { russian: 'ДОРИМЕДОНТОВИЧ', latin: null, sex: 0 },
        { russian: 'ДОРМЕДОНТОВИЧ', latin: null, sex: 0 },
        { russian: 'ДОРМИДОНТОВИЧ', latin: null, sex: 0 },
        { russian: 'ДОРОФЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'ДОСИФЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВГЕНИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВГЕНЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВГРАФИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВГРАФОВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВГРАФЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВДОКИМОВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВЛАМПИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВЛАМПЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВЛОГИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВМЕНИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВМЕНОВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВМЕНЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВСЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВСТАФИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВСТАФЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВСТАХИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВСТАХЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВСТИГНЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВСТРАТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВСТРАТОВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВСТРАТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВТИХИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВТИХЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВФИМИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕВФИМЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕГОРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕГОРОВИЧ', latin: null, sex: 0 },
        { russian: 'ЕГОРЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕЛИЗАРОВИЧ', latin: null, sex: 0 },
        { russian: 'ЕЛИСЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕЛИСТРАТОВИЧ', latin: null, sex: 0 },
        { russian: 'ЕЛПИДИФОРОВИЧ', latin: null, sex: 0 },
        { russian: 'ЕМЕЛЬЯНОВИЧ', latin: null, sex: 0 },
        { russian: 'ЕПИФАНИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕПИФАНОВИЧ', latin: null, sex: 0 },
        { russian: 'ЕПИФАНЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕРЕМЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕРМИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕРМИЛИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕРМИЛИЧ', latin: null, sex: 0 },
        { russian: 'ЕРМИЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ЕРМИЛЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕРМОЛАЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕРОФЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕФИМИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕФИМОВИЧ', latin: null, sex: 0 },
        { russian: 'ЕФИМЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕФРЕМИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЕФРЕМОВИЧ', latin: null, sex: 0 },
        { russian: 'ЕФРЕМЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЗАХАРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЗАХАРОВИЧ', latin: null, sex: 0 },
        { russian: 'ЗАХАРЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЗЕНОНОВИЧ', latin: null, sex: 0 },
        { russian: 'ЗИНОВИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЗИНОВЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЗОСИМИЧ', latin: null, sex: 0 },
        { russian: 'ЗОСИМОВИЧ', latin: null, sex: 0 },
        { russian: 'ИАКИМОВИЧ', latin: null, sex: 0 },
        { russian: 'ИАКИНФОВИЧ', latin: null, sex: 0 },
        { russian: 'ИВАНОВИЧ', latin: null, sex: 0 },
        { russian: 'ИГНАТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ИГНАТОВИЧ', latin: null, sex: 0 },
        { russian: 'ИГНАТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ИГОРЕВИЧ', latin: null, sex: 0 },
        { russian: 'ИЕРОНИМОВИЧ', latin: null, sex: 0 },
        { russian: 'ИЗМАИЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ИЗМАЙЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ИЗОСИМОВИЧ', latin: null, sex: 0 },
        { russian: 'ИЗОТОВИЧ', latin: null, sex: 0 },
        { russian: 'ИЗЯСЛАВИЧ', latin: null, sex: 0 },
        { russian: 'ИЗЯСЛАВОВИЧ', latin: null, sex: 0 },
        { russian: 'ИЛАРИОНОВИЧ', latin: null, sex: 0 },
        { russian: 'ИЛИОДОРОВИЧ', latin: null, sex: 0 },
        { russian: 'ИЛЛАРИОНОВИЧ', latin: null, sex: 0 },
        { russian: 'ИЛЬИЧ', latin: null, sex: 0 },
        { russian: 'ИННОКЕНТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ИННОКЕНТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ИОАННОВИЧ', latin: null, sex: 0 },
        { russian: 'ИОВИЧ', latin: null, sex: 0 },
        { russian: 'ИОНИЧ', latin: null, sex: 0 },
        { russian: 'ИОСАФАТОВИЧ', latin: null, sex: 0 },
        { russian: 'ИОСИФОВИЧ', latin: null, sex: 0 },
        { russian: 'ИПАТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ИПАТОВИЧ', latin: null, sex: 0 },
        { russian: 'ИПАТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ИППОЛИТОВИЧ', latin: null, sex: 0 },
        { russian: 'ИРАКЛИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ИРИНАРХОВИЧ', latin: null, sex: 0 },
        { russian: 'ИРИНЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'ИСААКИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ИСААКОВИЧ', latin: null, sex: 0 },
        { russian: 'ИСАЕВИЧ', latin: null, sex: 0 },
        { russian: 'ИСАКИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ИСАКОВИЧ', latin: null, sex: 0 },
        { russian: 'ИСИДОРОВИЧ', latin: null, sex: 0 },
        { russian: 'ИУСТИНОВИЧ', latin: null, sex: 0 },
        { russian: 'КАЗИМИРОВИЧ', latin: null, sex: 0 },
        { russian: 'КАЛЛИНИКОВИЧ', latin: null, sex: 0 },
        { russian: 'КАЛЛИСТОВИЧ', latin: null, sex: 0 },
        { russian: 'КАЛЛИСТРАТОВИЧ', latin: null, sex: 0 },
        { russian: 'КАПИТОНОВИЧ', latin: null, sex: 0 },
        { russian: 'КАРИОНОВИЧ', latin: null, sex: 0 },
        { russian: 'КАРЛОВИЧ', latin: null, sex: 0 },
        { russian: 'КАРПОВИЧ', latin: null, sex: 0 },
        { russian: 'КАСЬЯНОВИЧ', latin: null, sex: 0 },
        { russian: 'КИМОВИЧ', latin: null, sex: 0 },
        { russian: 'КИПРИАНОВИЧ', latin: null, sex: 0 },
        { russian: 'КИРИАКОВИЧ', latin: null, sex: 0 },
        { russian: 'КИРИКОВИЧ', latin: null, sex: 0 },
        { russian: 'КИРИЛЛОВИЧ', latin: null, sex: 0 },
        { russian: 'КИРОВИЧ', latin: null, sex: 0 },
        { russian: 'КИРСАНОВИЧ', latin: null, sex: 0 },
        { russian: 'КИРЬЯКОВИЧ', latin: null, sex: 0 },
        { russian: 'КЛАВДИЕВИЧ', latin: null, sex: 0 },
        { russian: 'КЛИМЕНТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'КЛИМЕНТОВИЧ', latin: null, sex: 0 },
        { russian: 'КЛИМЕНТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'КЛИМОВИЧ', latin: null, sex: 0 },
        { russian: 'КОНДРАТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'КОНДРАТОВИЧ', latin: null, sex: 0 },
        { russian: 'КОНДРАТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'КОНОНОВИЧ', latin: null, sex: 0 },
        { russian: 'КОНРАДОВИЧ', latin: null, sex: 0 },
        { russian: 'КОНСТАНТИНОВИЧ', latin: null, sex: 0 },
        { russian: 'КОРНЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'КОРНЕЛИЕВИЧ', latin: null, sex: 0 },
        { russian: 'КОРНЕЛЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'КОРНИЛИЕВИЧ', latin: null, sex: 0 },
        { russian: 'КОРНИЛОВИЧ', latin: null, sex: 0 },
        { russian: 'КОРНИЛЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'КСЕНОФОНТОВИЧ', latin: null, sex: 0 },
        { russian: 'КУЗЬМИЧ', latin: null, sex: 0 },
        { russian: 'КУПРИЯНОВИЧ', latin: null, sex: 0 },
        { russian: 'ЛАВРЕНТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЛАВРЕНТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЛАВРОВИЧ', latin: null, sex: 0 },
        { russian: 'ЛАЗАРЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЛАРИОНОВИЧ', latin: null, sex: 0 },
        { russian: 'ЛЕОНАРДОВИЧ', latin: null, sex: 0 },
        { russian: 'ЛЕОНИДОВИЧ', latin: null, sex: 0 },
        { russian: 'ЛЕОНОВИЧ', latin: null, sex: 0 },
        { russian: 'ЛЕОНТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЛЕОНТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЛЕОПОЛЬДОВИЧ', latin: null, sex: 0 },
        { russian: 'ЛОГВИНОВИЧ', latin: null, sex: 0 },
        { russian: 'ЛОГГИНОВИЧ', latin: null, sex: 0 },
        { russian: 'ЛОНГИНОВИЧ', latin: null, sex: 0 },
        { russian: 'ЛУАРСАБОВИЧ', latin: null, sex: 0 },
        { russian: 'ЛУКИАНОВИЧ', latin: null, sex: 0 },
        { russian: 'ЛУКИЧ', latin: null, sex: 0 },
        { russian: 'ЛУКЬЯНОВИЧ', latin: null, sex: 0 },
        { russian: 'ЛЬВОВИЧ', latin: null, sex: 0 },
        { russian: 'ЛЮБИМОВИЧ', latin: null, sex: 0 },
        { russian: 'ЛЮБОМИРОВИЧ', latin: null, sex: 0 },
        { russian: 'ЛЮЦИАНОВИЧ', latin: null, sex: 0 },
        { russian: 'МАВРИКИЕВИЧ', latin: null, sex: 0 },
        { russian: 'МАВРИКЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'МАВРОВИЧ', latin: null, sex: 0 },
        { russian: 'МАВРОДИЕВИЧ', latin: null, sex: 0 },
        { russian: 'МАВРОДЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'МАКАРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'МАКАРОВИЧ', latin: null, sex: 0 },
        { russian: 'МАКАРЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'МАКСИМИАНОВИЧ', latin: null, sex: 0 },
        { russian: 'МАКСИМИЛИАНОВИЧ', latin: null, sex: 0 },
        { russian: 'МАКСИМИЛЬЯНОВИЧ', latin: null, sex: 0 },
        { russian: 'МАКСИМОВИЧ', latin: null, sex: 0 },
        { russian: 'МАНУИЛОВИЧ', latin: null, sex: 0 },
        { russian: 'МАРАТОВИЧ', latin: null, sex: 0 },
        { russian: 'МАРДАРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'МАРДАРЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'МАРИАНОВИЧ', latin: null, sex: 0 },
        { russian: 'МАРИНОВИЧ', latin: null, sex: 0 },
        { russian: 'МАРКЕЛОВИЧ', latin: null, sex: 0 },
        { russian: 'МАРКИАНОВИЧ', latin: null, sex: 0 },
        { russian: 'МАРКОВИЧ', latin: null, sex: 0 },
        { russian: 'МАРЛЕНОВИЧ', latin: null, sex: 0 },
        { russian: 'МАРТИМЬЯНОВИЧ', latin: null, sex: 0 },
        { russian: 'МАРТИНИАНОВИЧ', latin: null, sex: 0 },
        { russian: 'МАРТИНОВИЧ', latin: null, sex: 0 },
        { russian: 'МАРТИРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'МАРТИРЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'МАРТЫНОВИЧ', latin: null, sex: 0 },
        { russian: 'МАРТЬЯНОВИЧ', latin: null, sex: 0 },
        { russian: 'МАТВЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'МЕЛЕНТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'МЕЛЕНТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'МЕЛЕТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'МЕЛЕТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'МЕРКУЛОВИЧ', latin: null, sex: 0 },
        { russian: 'МЕРКУРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'МЕРКУРЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'МЕФОДИЕВИЧ', latin: null, sex: 0 },
        { russian: 'МЕФОДЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'МЕЧИСЛАВИЧ', latin: null, sex: 0 },
        { russian: 'МЕЧИСЛАВОВИЧ', latin: null, sex: 0 },
        { russian: 'МИЛИЕВИЧ', latin: null, sex: 0 },
        { russian: 'МИНАЕВИЧ', latin: null, sex: 0 },
        { russian: 'МИНИЧ', latin: null, sex: 0 },
        { russian: 'МИРОНОВИЧ', latin: null, sex: 0 },
        { russian: 'МИРОСЛАВИЧ', latin: null, sex: 0 },
        { russian: 'МИРОСЛАВОВИЧ', latin: null, sex: 0 },
        { russian: 'МИСАИЛОВИЧ', latin: null, sex: 0 },
        { russian: 'МИТРОФАНИЕВИЧ', latin: null, sex: 0 },
        { russian: 'МИТРОФАНОВИЧ', latin: null, sex: 0 },
        { russian: 'МИТРОФАНЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'МИХАЙЛОВИЧ', latin: null, sex: 0 },
        { russian: 'МИХЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'МОДЕСТОВИЧ', latin: null, sex: 0 },
        { russian: 'МОИСЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'МОКЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'МОКИЕВИЧ', latin: null, sex: 0 },
        { russian: 'МСТИСЛАВИЧ', latin: null, sex: 0 },
        { russian: 'МСТИСЛАВОВИЧ', latin: null, sex: 0 },
        { russian: 'НАЗАРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'НАЗАРОВИЧ', latin: null, sex: 0 },
        { russian: 'НАЗАРЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'НАРКИСОВИЧ', latin: null, sex: 0 },
        { russian: 'НАТАНОВИЧ', latin: null, sex: 0 },
        { russian: 'НАУМОВИЧ', latin: null, sex: 0 },
        { russian: 'НЕСТЕРОВИЧ', latin: null, sex: 0 },
        { russian: 'НЕСТОРОВИЧ', latin: null, sex: 0 },
        { russian: 'НЕФЁДОВИЧ', latin: null, sex: 0 },
        { russian: 'НИКАНДРОВИЧ', latin: null, sex: 0 },
        { russian: 'НИКАНОРОВИЧ', latin: null, sex: 0 },
        { russian: 'НИКИТИЧ', latin: null, sex: 0 },
        { russian: 'НИКИФОРОВИЧ', latin: null, sex: 0 },
        { russian: 'НИКОДИМОВИЧ', latin: null, sex: 0 },
        { russian: 'НИКОЛАЕВИЧ', latin: null, sex: 0 },
        { russian: 'НИКОНОВИЧ', latin: null, sex: 0 },
        { russian: 'НИЛОВИЧ', latin: null, sex: 0 },
        { russian: 'НИФОНТОВИЧ', latin: null, sex: 0 },
        { russian: 'ОЛЕГОВИЧ', latin: null, sex: 0 },
        { russian: 'ОЛИМПИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ОНИСИМОВИЧ', latin: null, sex: 0 },
        { russian: 'ОНУФРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ОРЕСТОВИЧ', latin: null, sex: 0 },
        { russian: 'ОСИПОВИЧ', latin: null, sex: 0 },
        { russian: 'ОСКАРОВИЧ', latin: null, sex: 0 },
        { russian: 'ОСТАПОВИЧ', latin: null, sex: 0 },
        { russian: 'ПАВЛИНОВИЧ', latin: null, sex: 0 },
        { russian: 'ПАВЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ПАИСИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПАИСЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПАЛЛАДИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПАЛЛАДЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПАМФИЛИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПАМФИЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ПАМФИЛЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПАНКРАТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПАНКРАТОВИЧ', latin: null, sex: 0 },
        { russian: 'ПАНКРАТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПАНТЕЛЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПАНТЕЛЕЙМОНОВИЧ', latin: null, sex: 0 },
        { russian: 'ПАНФИЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ПАРАМОНОВИЧ', latin: null, sex: 0 },
        { russian: 'ПАРМЕНОВИЧ', latin: null, sex: 0 },
        { russian: 'ПАРМЁНОВИЧ', latin: null, sex: 0 },
        { russian: 'ПАРФЕНИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПАРФЁНОВИЧ', latin: null, sex: 0 },
        { russian: 'ПАРФЕНТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПАРФЕНТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПАРФЕНЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПАТРИКЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПАТРИКИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПАФНУТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПАФНУТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПАХОМИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПАХОМОВИЧ', latin: null, sex: 0 },
        { russian: 'ПАХОМЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПЕРФИЛИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПЕРФИЛЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПЕТРОВИЧ', latin: null, sex: 0 },
        { russian: 'ПИМЕНОВИЧ', latin: null, sex: 0 },
        { russian: 'ПИТИРИМОВИЧ', latin: null, sex: 0 },
        { russian: 'ПЛАТОНОВИЧ', latin: null, sex: 0 },
        { russian: 'ПОЛИКАРПИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПОЛИКАРПОВИЧ', latin: null, sex: 0 },
        { russian: 'ПОЛИКАРПЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПОРФИРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПОРФИРОВИЧ', latin: null, sex: 0 },
        { russian: 'ПОРФИРЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПОТАПИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПОТАПОВИЧ', latin: null, sex: 0 },
        { russian: 'ПОТАПЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПРОВИЧ', latin: null, sex: 0 },
        { russian: 'ПРОКЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ПРОКОПИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПРОКОПОВИЧ', latin: null, sex: 0 },
        { russian: 'ПРОКОПЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПРОКОФИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПРОКОФЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПРОТАСИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПРОТАСОВИЧ', latin: null, sex: 0 },
        { russian: 'ПРОТАСЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ПРОХОРОВИЧ', latin: null, sex: 0 },
        { russian: 'РАДИЕВИЧ', latin: null, sex: 0 },
        { russian: 'РАТМИРОВИЧ', latin: null, sex: 0 },
        { russian: 'РАФАИЛОВИЧ', latin: null, sex: 0 },
        { russian: 'РЕМОВИЧ', latin: null, sex: 0 },
        { russian: 'РЕНАТОВИЧ', latin: null, sex: 0 },
        { russian: 'РИНАТОВИЧ', latin: null, sex: 0 },
        { russian: 'РОБЕРТОВИЧ', latin: null, sex: 0 },
        { russian: 'РОДИОНОВИЧ', latin: null, sex: 0 },
        { russian: 'РОМАНОВИЧ', latin: null, sex: 0 },
        { russian: 'РОМУАЛЬДОВИЧ', latin: null, sex: 0 },
        { russian: 'РОСТИСЛАВИЧ', latin: null, sex: 0 },
        { russian: 'РОСТИСЛАВОВИЧ', latin: null, sex: 0 },
        { russian: 'РУБЕНОВИЧ', latin: null, sex: 0 },
        { russian: 'РУВИМОВИЧ', latin: null, sex: 0 },
        { russian: 'РУДОЛЬФОВИЧ', latin: null, sex: 0 },
        { russian: 'РУСЛАНОВИЧ', latin: null, sex: 0 },
        { russian: 'РЮРИКОВИЧ', latin: null, sex: 0 },
        { russian: 'САВВАТЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'САВВАТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'САВВАТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'САВВИЧ', latin: null, sex: 0 },
        { russian: 'САВЕЛИЕВИЧ', latin: null, sex: 0 },
        { russian: 'САВЁЛОВИЧ', latin: null, sex: 0 },
        { russian: 'САВЕЛЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'САМОЙЛОВИЧ', latin: null, sex: 0 },
        { russian: 'САМСОНИЕВИЧ', latin: null, sex: 0 },
        { russian: 'САМСОНОВИЧ', latin: null, sex: 0 },
        { russian: 'САМСОНЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'САМУИЛОВИЧ', latin: null, sex: 0 },
        { russian: 'СВИРИДОВИЧ', latin: null, sex: 0 },
        { russian: 'СВЯТОПОЛКОВИЧ', latin: null, sex: 0 },
        { russian: 'СВЯТОСЛАВИЧ', latin: null, sex: 0 },
        { russian: 'СВЯТОСЛАВОВИЧ', latin: null, sex: 0 },
        { russian: 'СЕБАСТЬЯНОВИЧ', latin: null, sex: 0 },
        { russian: 'СЕВАСТЬЯНОВИЧ', latin: null, sex: 0 },
        { russian: 'СЕВЕРИНОВИЧ', latin: null, sex: 0 },
        { russian: 'СЕВЕРЬЯНОВИЧ', latin: null, sex: 0 },
        { russian: 'СЕЛИВАНОВИЧ', latin: null, sex: 0 },
        { russian: 'СЕЛИВЁРСТОВИЧ', latin: null, sex: 0 },
        { russian: 'СЕЛИФАНОВИЧ', latin: null, sex: 0 },
        { russian: 'СЕМЁНОВИЧ', latin: null, sex: 0 },
        { russian: 'СЕРАПИОНОВИЧ', latin: null, sex: 0 },
        { russian: 'СЕРАФИМОВИЧ', latin: null, sex: 0 },
        { russian: 'СЕРГЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'СИГИЗМУНДОВИЧ', latin: null, sex: 0 },
        { russian: 'СИДОРОВИЧ', latin: null, sex: 0 },
        { russian: 'СИЛАНОВИЧ', latin: null, sex: 0 },
        { russian: 'СИЛАНТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'СИЛАНТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'СИЛИЧ', latin: null, sex: 0 },
        { russian: 'СИЛУЯНОВИЧ', latin: null, sex: 0 },
        { russian: 'СИЛЬВАНОВИЧ', latin: null, sex: 0 },
        { russian: 'СИЛЬВЕСТРОВИЧ', latin: null, sex: 0 },
        { russian: 'СИМЕОНОВИЧ', latin: null, sex: 0 },
        { russian: 'СИМОНОВИЧ', latin: null, sex: 0 },
        { russian: 'СОЗОНОВИЧ', latin: null, sex: 0 },
        { russian: 'СОЗОНТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'СОЗОНТОВИЧ', latin: null, sex: 0 },
        { russian: 'СОЗОНТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'СОКРАТОВИЧ', latin: null, sex: 0 },
        { russian: 'СОЛОМОНОВИЧ', latin: null, sex: 0 },
        { russian: 'СОСИПАТРОВИЧ', latin: null, sex: 0 },
        { russian: 'СОФОНИЕВИЧ', latin: null, sex: 0 },
        { russian: 'СОФОНОВИЧ', latin: null, sex: 0 },
        { russian: 'СОФОНЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'СОФРОНИЕВИЧ', latin: null, sex: 0 },
        { russian: 'СОФРОНОВИЧ', latin: null, sex: 0 },
        { russian: 'СОФРОНЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'СПАРТАКОВИЧ', latin: null, sex: 0 },
        { russian: 'СПИРИДОНИЕВИЧ', latin: null, sex: 0 },
        { russian: 'СПИРИДОНОВИЧ', latin: null, sex: 0 },
        { russian: 'СПИРИДОНЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'СТАНИСЛАВИЧ', latin: null, sex: 0 },
        { russian: 'СТАНИСЛАВОВИЧ', latin: null, sex: 0 },
        { russian: 'СТАХИЕВИЧ', latin: null, sex: 0 },
        { russian: 'СТЕПАНОВИЧ', latin: null, sex: 0 },
        { russian: 'СТРАТОНИКОВИЧ', latin: null, sex: 0 },
        { russian: 'СЫСОЕВИЧ', latin: null, sex: 0 },
        { russian: 'ТАРАСОВИЧ', latin: null, sex: 0 },
        { russian: 'ТЕРЕНТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ТЕРЕНТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ТЕРТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ТИМОФЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'ТИМУРОВИЧ', latin: null, sex: 0 },
        { russian: 'ТИТОВИЧ', latin: null, sex: 0 },
        { russian: 'ТИХОНОВИЧ', latin: null, sex: 0 },
        { russian: 'ТРИФОНОВИЧ', latin: null, sex: 0 },
        { russian: 'ТРОФИМОВИЧ', latin: null, sex: 0 },
        { russian: 'УАРОВИЧ', latin: null, sex: 0 },
        { russian: 'УВАРОВИЧ', latin: null, sex: 0 },
        { russian: 'УЛЬЯНОВИЧ', latin: null, sex: 0 },
        { russian: 'УСТИНОВИЧ', latin: null, sex: 0 },
        { russian: 'ФАБИАНОВИЧ', latin: null, sex: 0 },
        { russian: 'ФАДДЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'ФАДЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'ФАЛАЛЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'ФАТЬЯНОВИЧ', latin: null, sex: 0 },
        { russian: 'ФЁДОРОВИЧ', latin: null, sex: 0 },
        { russian: 'ФЕДОСЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'ФЕДОСИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ФЕДОСОВИЧ', latin: null, sex: 0 },
        { russian: 'ФЕДОСЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ФЕДОТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ФЕДОТОВИЧ', latin: null, sex: 0 },
        { russian: 'ФЕДОТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ФЕДУЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ФЕЛИКСОВИЧ', latin: null, sex: 0 },
        { russian: 'ФЕОГНОСТОВИЧ', latin: null, sex: 0 },
        { russian: 'ФЕОКТИСТОВИЧ', latin: null, sex: 0 },
        { russian: 'ФЕОФАНОВИЧ', latin: null, sex: 0 },
        { russian: 'ФЕОФИЛАКТОВИЧ', latin: null, sex: 0 },
        { russian: 'ФЕОФИЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ФЕРАПОНТОВИЧ', latin: null, sex: 0 },
        { russian: 'ФИЛАРЕТОВИЧ', latin: null, sex: 0 },
        { russian: 'ФИЛАТОВИЧ', latin: null, sex: 0 },
        { russian: 'ФИЛИМОНОВИЧ', latin: null, sex: 0 },
        { russian: 'ФИЛИПИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ФИЛИППОВИЧ', latin: null, sex: 0 },
        { russian: 'ФИЛИПЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ФИЛОФЕЕВИЧ', latin: null, sex: 0 },
        { russian: 'ФИРСОВИЧ', latin: null, sex: 0 },
        { russian: 'ФЛЕГОНТОВИЧ', latin: null, sex: 0 },
        { russian: 'ФЛОРЕНТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ФЛОРЕНТИНОВИЧ', latin: null, sex: 0 },
        { russian: 'ФЛОРЕНТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ФЛОРИАНОВИЧ', latin: null, sex: 0 },
        { russian: 'ФОКИЧ', latin: null, sex: 0 },
        { russian: 'ФОМИЧ', latin: null, sex: 0 },
        { russian: 'ФОРТУНАТОВИЧ', latin: null, sex: 0 },
        { russian: 'ФОТИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ФОТЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ФРИДРИХОВИЧ', latin: null, sex: 0 },
        { russian: 'ФРОЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ХАРИТОНИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ХАРИТОНОВИЧ', latin: null, sex: 0 },
        { russian: 'ХАРИТОНЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ХАРЛАМОВИЧ', latin: null, sex: 0 },
        { russian: 'ХАРЛАМПИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ХАРЛАМПОВИЧ', latin: null, sex: 0 },
        { russian: 'ХАРЛАМПЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ХРИСАНФОВИЧ', latin: null, sex: 0 },
        { russian: 'ХРИСТОФОРОВИЧ', latin: null, sex: 0 },
        { russian: 'ЭДУАРДОВИЧ', latin: null, sex: 0 },
        { russian: 'ЭМИЛИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЭМИЛЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЭММАНУИЛОВИЧ', latin: null, sex: 0 },
        { russian: 'ЭРАЗМОВИЧ', latin: null, sex: 0 },
        { russian: 'ЭРАСТОВИЧ', latin: null, sex: 0 },
        { russian: 'ЭРНЕСТОВИЧ', latin: null, sex: 0 },
        { russian: 'ЭРНСТОВИЧ', latin: null, sex: 0 },
        { russian: 'ЮВЕНАЛИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЮВЕНАЛЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЮЛИАНОВИЧ', latin: null, sex: 0 },
        { russian: 'ЮЛИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЮЛЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЮРЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЮСТИНОВИЧ', latin: null, sex: 0 },
        { russian: 'ЯКИМОВИЧ', latin: null, sex: 0 },
        { russian: 'ЯКОВЛЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЯКУБОВИЧ', latin: null, sex: 0 },
        { russian: 'ЯНОВИЧ', latin: null, sex: 0 },
        { russian: 'ЯНУАРИЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЯНУАРЬЕВИЧ', latin: null, sex: 0 },
        { russian: 'ЯРОСЛАВИЧ', latin: null, sex: 0 },
        { russian: 'ЯРОСЛАВОВИЧ', latin: null, sex: 0 },
        { russian: 'АБАКУМОВНА', latin: null, sex: 1 },
        { russian: 'АБРАМОВНА', latin: null, sex: 1 },
        { russian: 'АБРОСИМОВНА', latin: null, sex: 1 },
        { russian: 'АВВАКУМОВНА', latin: null, sex: 1 },
        { russian: 'АВГУСТОВНА', latin: null, sex: 1 },
        { russian: 'АВДЕЕВНА', latin: null, sex: 1 },
        { russian: 'АВДИЕВНА', latin: null, sex: 1 },
        { russian: 'АВЕЛЕВНА', latin: null, sex: 1 },
        { russian: 'АВЕНИРОВНА', latin: null, sex: 1 },
        { russian: 'АВЕРИЕВНА', latin: null, sex: 1 },
        { russian: 'АВЕРКИЕВНА', latin: null, sex: 1 },
        { russian: 'АВЕРЬЯНОВНА', latin: null, sex: 1 },
        { russian: 'АВКСЕНТИЕВНА', latin: null, sex: 1 },
        { russian: 'АВКСЕНТЬЕВНА', latin: null, sex: 1 },
        { russian: 'АВРААМИЕВНА', latin: null, sex: 1 },
        { russian: 'АВРААМОВНА', latin: null, sex: 1 },
        { russian: 'АВРААМЬЕВНА', latin: null, sex: 1 },
        { russian: 'АВРАМИЕВНА', latin: null, sex: 1 },
        { russian: 'АВРАМОВНА', latin: null, sex: 1 },
        { russian: 'АВРАМЬЕВНА', latin: null, sex: 1 },
        { russian: 'АВРЕЛИАНОВНА', latin: null, sex: 1 },
        { russian: 'АВТОНОМОВНА', latin: null, sex: 1 },
        { russian: 'АГАПИЕВНА', latin: null, sex: 1 },
        { russian: 'АГАПИТОВНА', latin: null, sex: 1 },
        { russian: 'АГАПОВНА', latin: null, sex: 1 },
        { russian: 'АГАПЬЕВНА', latin: null, sex: 1 },
        { russian: 'АГАФОНОВНА', latin: null, sex: 1 },
        { russian: 'АГГЕЕВНА', latin: null, sex: 1 },
        { russian: 'АДАМОВНА', latin: null, sex: 1 },
        { russian: 'АДРИАНОВНА', latin: null, sex: 1 },
        { russian: 'АЗАРИЕВНА', latin: null, sex: 1 },
        { russian: 'АЗАРОВНА', latin: null, sex: 1 },
        { russian: 'АЗАРЬЕВНА', latin: null, sex: 1 },
        { russian: 'АКАКИЕВНА', latin: null, sex: 1 },
        { russian: 'АКИМОВНА', latin: null, sex: 1 },
        { russian: 'АКИНДИНОВНА', latin: null, sex: 1 },
        { russian: 'АКИНФИЕВНА', latin: null, sex: 1 },
        { russian: 'АКИНФОВНА', latin: null, sex: 1 },
        { russian: 'АКИНФЬЕВНА', latin: null, sex: 1 },
        { russian: 'АКСЁНОВНА', latin: null, sex: 1 },
        { russian: 'АКСЕНТИЕВНА', latin: null, sex: 1 },
        { russian: 'АКСЕНТЬЕВНА', latin: null, sex: 1 },
        { russian: 'АЛЕКСАНДРОВНА', latin: null, sex: 1 },
        { russian: 'АЛЕКСЕЕВНА', latin: null, sex: 1 },
        { russian: 'АЛЕКСИЕВНА', latin: null, sex: 1 },
        { russian: 'АЛЬБЕРТОВНА', latin: null, sex: 1 },
        { russian: 'АЛЬФРЕДОВНА', latin: null, sex: 1 },
        { russian: 'АМВРОСИЕВНА', latin: null, sex: 1 },
        { russian: 'АМВРОСЬЕВНА', latin: null, sex: 1 },
        { russian: 'АМОСОВНА', latin: null, sex: 1 },
        { russian: 'АМФИЛОХИЕВНА', latin: null, sex: 1 },
        { russian: 'АМФИЛОХЬЕВНА', latin: null, sex: 1 },
        { russian: 'АНАНИЕВНА', latin: null, sex: 1 },
        { russian: 'АНАНЬЕВНА', latin: null, sex: 1 },
        { russian: 'АНАСТАСИЕВНА', latin: null, sex: 1 },
        { russian: 'АНАСТАСЬЕВНА', latin: null, sex: 1 },
        { russian: 'АНАТОЛИЕВНА', latin: null, sex: 1 },
        { russian: 'АНАТОЛЬЕВНА', latin: null, sex: 1 },
        { russian: 'АНДРЕЕВНА', latin: null, sex: 1 },
        { russian: 'АНДРИАНОВНА', latin: null, sex: 1 },
        { russian: 'АНДРОНИЕВНА', latin: null, sex: 1 },
        { russian: 'АНДРОНИКОВНА', latin: null, sex: 1 },
        { russian: 'АНДРОНОВНА', latin: null, sex: 1 },
        { russian: 'АНДРОНЬЕВНА', latin: null, sex: 1 },
        { russian: 'АНИКЕЕВНА', latin: null, sex: 1 },
        { russian: 'АНИКИЕВНА', latin: null, sex: 1 },
        { russian: 'АНИКИТИЧНА', latin: null, sex: 1 },
        { russian: 'АНИСИЕВНА', latin: null, sex: 1 },
        { russian: 'АНИСИМОВНА', latin: null, sex: 1 },
        { russian: 'АНИСЬЕВНА', latin: null, sex: 1 },
        { russian: 'АНТИОХОВНА', latin: null, sex: 1 },
        { russian: 'АНТИПИЕВНА', latin: null, sex: 1 },
        { russian: 'АНТИПИЧНА', latin: null, sex: 1 },
        { russian: 'АНТИПОВНА', latin: null, sex: 1 },
        { russian: 'АНТИПЬЕВНА', latin: null, sex: 1 },
        { russian: 'АНТОНИНОВНА', latin: null, sex: 1 },
        { russian: 'АНТОНОВНА', latin: null, sex: 1 },
        { russian: 'АНТРОПИЕВНА', latin: null, sex: 1 },
        { russian: 'АНТРОПОВНА', latin: null, sex: 1 },
        { russian: 'АНТРОПЬЕВНА', latin: null, sex: 1 },
        { russian: 'АНУФРИЕВНА', latin: null, sex: 1 },
        { russian: 'АПОЛЛИНАРИЕВНА', latin: null, sex: 1 },
        { russian: 'АПОЛЛИНАРЬЕВНА', latin: null, sex: 1 },
        { russian: 'АПОЛЛОНОВНА', latin: null, sex: 1 },
        { russian: 'АПОЛЛОСОВНА', latin: null, sex: 1 },
        { russian: 'АРДАЛИОНОВНА', latin: null, sex: 1 },
        { russian: 'АРДАЛЬОНОВНА', latin: null, sex: 1 },
        { russian: 'АРЕФИЕВНА', latin: null, sex: 1 },
        { russian: 'АРЕФОВНА', latin: null, sex: 1 },
        { russian: 'АРЕФЬЕВНА', latin: null, sex: 1 },
        { russian: 'АРИЕВНА', latin: null, sex: 1 },
        { russian: 'АРИСТАРХОВНА', latin: null, sex: 1 },
        { russian: 'АРИСТИДОВНА', latin: null, sex: 1 },
        { russian: 'АРКАДИЕВНА', latin: null, sex: 1 },
        { russian: 'АРКАДЬЕВНА', latin: null, sex: 1 },
        { russian: 'АРНОЛЬДОВНА', latin: null, sex: 1 },
        { russian: 'АРОНОВНА', latin: null, sex: 1 },
        { russian: 'АРСЕНИЕВНА', latin: null, sex: 1 },
        { russian: 'АРСЕНОВНА', latin: null, sex: 1 },
        { russian: 'АРСЕНТИЕВНА', latin: null, sex: 1 },
        { russian: 'АРСЕНТЬЕВНА', latin: null, sex: 1 },
        { russian: 'АРСЕНЬЕВНА', latin: null, sex: 1 },
        { russian: 'АРТАМОНОВНА', latin: null, sex: 1 },
        { russian: 'АРТЕМИЕВНА', latin: null, sex: 1 },
        { russian: 'АРТЁМОВНА', latin: null, sex: 1 },
        { russian: 'АРТЕМЬЕВНА', latin: null, sex: 1 },
        { russian: 'АРТУРОВНА', latin: null, sex: 1 },
        { russian: 'АРХИПОВНА', latin: null, sex: 1 },
        { russian: 'АРЬЕВНА', latin: null, sex: 1 },
        { russian: 'АСАФИЕВНА', latin: null, sex: 1 },
        { russian: 'АСАФОВНА', latin: null, sex: 1 },
        { russian: 'АСАФЬЕВНА', latin: null, sex: 1 },
        { russian: 'АСКОЛЬДОВНА', latin: null, sex: 1 },
        { russian: 'АФАНАСИЕВНА', latin: null, sex: 1 },
        { russian: 'АФАНАСЬЕВНА', latin: null, sex: 1 },
        { russian: 'АФИНОГЕНОВНА', latin: null, sex: 1 },
        { russian: 'АФРИКАНОВНА', latin: null, sex: 1 },
        { russian: 'БЕНЕДИКТОВНА', latin: null, sex: 1 },
        { russian: 'БОГДАНОВНА', latin: null, sex: 1 },
        { russian: 'БОЛЕСЛАВНА', latin: null, sex: 1 },
        { russian: 'БОЛЕСЛАВОВНА', latin: null, sex: 1 },
        { russian: 'БОНИФАТИЕВНА', latin: null, sex: 1 },
        { russian: 'БОНИФАТОВНА', latin: null, sex: 1 },
        { russian: 'БОНИФАТЬЕВНА', latin: null, sex: 1 },
        { russian: 'БОРИСЛАВНА', latin: null, sex: 1 },
        { russian: 'БОРИСЛАВОВНА', latin: null, sex: 1 },
        { russian: 'БОРИСОВНА', latin: null, sex: 1 },
        { russian: 'БРОНИСЛАВНА', latin: null, sex: 1 },
        { russian: 'БРОНИСЛАВОВНА', latin: null, sex: 1 },
        { russian: 'ВАВИЛИЧНА', latin: null, sex: 1 },
        { russian: 'ВАВИЛОВНА', latin: null, sex: 1 },
        { russian: 'ВАДИМОВНА', latin: null, sex: 1 },
        { russian: 'ВАЛЕНТИНОВНА', latin: null, sex: 1 },
        { russian: 'ВАЛЕРИАНОВНА', latin: null, sex: 1 },
        { russian: 'ВАЛЕРИЕВНА', latin: null, sex: 1 },
        { russian: 'ВАЛЕРЬЕВНА', latin: null, sex: 1 },
        { russian: 'ВАЛЕРЬЯНОВНА', latin: null, sex: 1 },
        { russian: 'ВАРЛАМИЕВНА', latin: null, sex: 1 },
        { russian: 'ВАРЛАМОВНА', latin: null, sex: 1 },
        { russian: 'ВАРЛАМЬЕВНА', latin: null, sex: 1 },
        { russian: 'ВАРНАВИЧНА', latin: null, sex: 1 },
        { russian: 'ВАРСОНОФИЕВНА', latin: null, sex: 1 },
        { russian: 'ВАРСОНОФОВНА', latin: null, sex: 1 },
        { russian: 'ВАРСОНОФЬЕВНА', latin: null, sex: 1 },
        { russian: 'ВАРФОЛОМЕЕВНА', latin: null, sex: 1 },
        { russian: 'ВАСИЛЬЕВНА', latin: null, sex: 1 },
        { russian: 'ВАССИАНОВНА', latin: null, sex: 1 },
        { russian: 'ВЕЛИЗАРОВНА', latin: null, sex: 1 },
        { russian: 'ВЕЛИМИРОВНА', latin: null, sex: 1 },
        { russian: 'ВЕНЕДИКТОВНА', latin: null, sex: 1 },
        { russian: 'ВЕНИАМИНОВНА', latin: null, sex: 1 },
        { russian: 'ВЕНЦЕСЛАВНА', latin: null, sex: 1 },
        { russian: 'ВЕНЦЕСЛАВОВНА', latin: null, sex: 1 },
        { russian: 'ВЕНЬЯМИНОВНА', latin: null, sex: 1 },
        { russian: 'ВИКЕНТИЕВНА', latin: null, sex: 1 },
        { russian: 'ВИКЕНТЬЕВНА', latin: null, sex: 1 },
        { russian: 'ВИКТОРИЕВНА', latin: null, sex: 1 },
        { russian: 'ВИКТОРОВНА', latin: null, sex: 1 },
        { russian: 'ВИКУЛИЧНА', latin: null, sex: 1 },
        { russian: 'ВИКУЛОВНА', latin: null, sex: 1 },
        { russian: 'ВИЛЕНОВНА', latin: null, sex: 1 },
        { russian: 'ВИЛЬГЕЛЬМОВНА', latin: null, sex: 1 },
        { russian: 'ВИССАРИОНОВНА', latin: null, sex: 1 },
        { russian: 'ВИТАЛИЕВНА', latin: null, sex: 1 },
        { russian: 'ВИТАЛЬЕВНА', latin: null, sex: 1 },
        { russian: 'ВИТОЛЬДОВНА', latin: null, sex: 1 },
        { russian: 'ВЛАДИЛЕНОВНА', latin: null, sex: 1 },
        { russian: 'ВЛАДИМИРОВНА', latin: null, sex: 1 },
        { russian: 'ВЛАДИСЛАВНА', latin: null, sex: 1 },
        { russian: 'ВЛАДИСЛАВОВНА', latin: null, sex: 1 },
        { russian: 'ВЛАДЛЕНОВНА', latin: null, sex: 1 },
        { russian: 'ВЛАСИЕВНА', latin: null, sex: 1 },
        { russian: 'ВЛАСОВНА', latin: null, sex: 1 },
        { russian: 'ВЛАСЬЕВНА', latin: null, sex: 1 },
        { russian: 'ВОНИФАТИЕВНА', latin: null, sex: 1 },
        { russian: 'ВОНИФАТОВНА', latin: null, sex: 1 },
        { russian: 'ВОНИФАТЬЕВНА', latin: null, sex: 1 },
        { russian: 'ВСЕВОЛОДОВНА', latin: null, sex: 1 },
        { russian: 'ВСЕСЛАВНА', latin: null, sex: 1 },
        { russian: 'ВСЕСЛАВОВНА', latin: null, sex: 1 },
        { russian: 'ВУКОЛОВНА', latin: null, sex: 1 },
        { russian: 'ВЫШЕСЛАВНА', latin: null, sex: 1 },
        { russian: 'ВЫШЕСЛАВОВНА', latin: null, sex: 1 },
        { russian: 'ВЯЧЕСЛАВНА', latin: null, sex: 1 },
        { russian: 'ВЯЧЕСЛАВОВНА', latin: null, sex: 1 },
        { russian: 'ГАВРИИЛОВНА', latin: null, sex: 1 },
        { russian: 'ГАВРИЛОВНА', latin: null, sex: 1 },
        { russian: 'ГАЛАКТИОНОВНА', latin: null, sex: 1 },
        { russian: 'ГЕДЕОНОВНА', latin: null, sex: 1 },
        { russian: 'ГЕЛАСИЕВНА', latin: null, sex: 1 },
        { russian: 'ГЕЛАСЬЕВНА', latin: null, sex: 1 },
        { russian: 'ГЕЛИЕВНА', latin: null, sex: 1 },
        { russian: 'ГЕННАДИЕВНА', latin: null, sex: 1 },
        { russian: 'ГЕННАДЬЕВНА', latin: null, sex: 1 },
        { russian: 'ГЕНРИХОВНА', latin: null, sex: 1 },
        { russian: 'ГЕОРГИЕВНА', latin: null, sex: 1 },
        { russian: 'ГЕРАСИМОВНА', latin: null, sex: 1 },
        { russian: 'ГЕРМАНОВНА', latin: null, sex: 1 },
        { russian: 'ГЕРМОГЕНОВНА', latin: null, sex: 1 },
        { russian: 'ГЕРОНТИЕВНА', latin: null, sex: 1 },
        { russian: 'ГЕРОНТЬЕВНА', latin: null, sex: 1 },
        { russian: 'ГИАЦИНТОВНА', latin: null, sex: 1 },
        { russian: 'ГЛЕБОВНА', latin: null, sex: 1 },
        { russian: 'ГОРАЦИЕВНА', latin: null, sex: 1 },
        { russian: 'ГОРГОНИЕВНА', latin: null, sex: 1 },
        { russian: 'ГОРГОНЬЕВНА', latin: null, sex: 1 },
        { russian: 'ГОРДЕЕВНА', latin: null, sex: 1 },
        { russian: 'ГРИГОРЬЕВНА', latin: null, sex: 1 },
        { russian: 'ГУРИЕВНА', latin: null, sex: 1 },
        { russian: 'ГУРЬЕВНА', latin: null, sex: 1 },
        { russian: 'ГУРЬЯНОВНА', latin: null, sex: 1 },
        { russian: 'ДАВИДОВНА', latin: null, sex: 1 },
        { russian: 'ДАВЫДОВНА', latin: null, sex: 1 },
        { russian: 'ДАЛМАТОВНА', latin: null, sex: 1 },
        { russian: 'ДАНИИЛОВНА', latin: null, sex: 1 },
        { russian: 'ДАНИЛОВНА', latin: null, sex: 1 },
        { russian: 'ДЕМЕНТИЕВНА', latin: null, sex: 1 },
        { russian: 'ДЕМЕНТЬЕВНА', latin: null, sex: 1 },
        { russian: 'ДЕМИДОВНА', latin: null, sex: 1 },
        { russian: 'ДЕМЬЯНОВНА', latin: null, sex: 1 },
        { russian: 'ДЕНИСИЕВНА', latin: null, sex: 1 },
        { russian: 'ДЕНИСОВНА', latin: null, sex: 1 },
        { russian: 'ДЕНИСЬЕВНА', latin: null, sex: 1 },
        { russian: 'ДИМИТРИЕВНА', latin: null, sex: 1 },
        { russian: 'ДИОМИДОВНА', latin: null, sex: 1 },
        { russian: 'ДИОНИСИЕВНА', latin: null, sex: 1 },
        { russian: 'ДИОНИСЬЕВНА', latin: null, sex: 1 },
        { russian: 'ДМИТРИЕВНА', latin: null, sex: 1 },
        { russian: 'ДОБРОМЫСЛОВНА', latin: null, sex: 1 },
        { russian: 'ДОБРЫНИЧНА', latin: null, sex: 1 },
        { russian: 'ДОМИНИКОВНА', latin: null, sex: 1 },
        { russian: 'ДОНАТОВНА', latin: null, sex: 1 },
        { russian: 'ДОРИМЕДОНТОВНА', latin: null, sex: 1 },
        { russian: 'ДОРМЕДОНТОВНА', latin: null, sex: 1 },
        { russian: 'ДОРМИДОНТОВНА', latin: null, sex: 1 },
        { russian: 'ДОРОФЕЕВНА', latin: null, sex: 1 },
        { russian: 'ДОСИФЕЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВГЕНИЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВГЕНЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВГРАФИЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВГРАФОВНА', latin: null, sex: 1 },
        { russian: 'ЕВГРАФЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВДОКИМОВНА', latin: null, sex: 1 },
        { russian: 'ЕВЛАМПИЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВЛАМПЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВЛОГИЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВМЕНИЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВМЕНОВНА', latin: null, sex: 1 },
        { russian: 'ЕВМЕНЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВСЕЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВСТАФИЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВСТАФЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВСТАХИЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВСТАХЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВСТИГНЕЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВСТРАТИЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВСТРАТОВНА', latin: null, sex: 1 },
        { russian: 'ЕВСТРАТЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВТИХИЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВТИХЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВФИМИЕВНА', latin: null, sex: 1 },
        { russian: 'ЕВФИМЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЕГОРИЕВНА', latin: null, sex: 1 },
        { russian: 'ЕГОРОВНА', latin: null, sex: 1 },
        { russian: 'ЕГОРЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЕЛИЗАРОВНА', latin: null, sex: 1 },
        { russian: 'ЕЛИСЕЕВНА', latin: null, sex: 1 },
        { russian: 'ЕЛИСТРАТОВНА', latin: null, sex: 1 },
        { russian: 'ЕЛПИДИФОРОВНА', latin: null, sex: 1 },
        { russian: 'ЕМЕЛЬЯНОВНА', latin: null, sex: 1 },
        { russian: 'ЕПИФАНИЕВНА', latin: null, sex: 1 },
        { russian: 'ЕПИФАНОВНА', latin: null, sex: 1 },
        { russian: 'ЕПИФАНЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЕРЕМЕЕВНА', latin: null, sex: 1 },
        { russian: 'ЕРМИЕВНА', latin: null, sex: 1 },
        { russian: 'ЕРМИЛИЕВНА', latin: null, sex: 1 },
        { russian: 'ЕРМИЛИЧНА', latin: null, sex: 1 },
        { russian: 'ЕРМИЛОВНА', latin: null, sex: 1 },
        { russian: 'ЕРМИЛЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЕРМОЛАЕВНА', latin: null, sex: 1 },
        { russian: 'ЕРОФЕЕВНА', latin: null, sex: 1 },
        { russian: 'ЕФИМИЕВНА', latin: null, sex: 1 },
        { russian: 'ЕФИМОВНА', latin: null, sex: 1 },
        { russian: 'ЕФИМЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЕФРЕМИЕВНА', latin: null, sex: 1 },
        { russian: 'ЕФРЕМОВНА', latin: null, sex: 1 },
        { russian: 'ЕФРЕМЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЗАХАРИЕВНА', latin: null, sex: 1 },
        { russian: 'ЗАХАРОВНА', latin: null, sex: 1 },
        { russian: 'ЗАХАРЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЗЕНОНОВНА', latin: null, sex: 1 },
        { russian: 'ЗИНОВИЕВНА', latin: null, sex: 1 },
        { russian: 'ЗИНОВЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЗОСИМИЧНА', latin: null, sex: 1 },
        { russian: 'ЗОСИМОВНА', latin: null, sex: 1 },
        { russian: 'ИАКИМОВНА', latin: null, sex: 1 },
        { russian: 'ИАКИНФОВНА', latin: null, sex: 1 },
        { russian: 'ИВАНОВНА', latin: null, sex: 1 },
        { russian: 'ИГНАТИЕВНА', latin: null, sex: 1 },
        { russian: 'ИГНАТОВНА', latin: null, sex: 1 },
        { russian: 'ИГНАТЬЕВНА', latin: null, sex: 1 },
        { russian: 'ИГОРЕВНА', latin: null, sex: 1 },
        { russian: 'ИЕРОНИМОВНА', latin: null, sex: 1 },
        { russian: 'ИЗМАИЛОВНА', latin: null, sex: 1 },
        { russian: 'ИЗМАЙЛОВНА', latin: null, sex: 1 },
        { russian: 'ИЗОСИМОВНА', latin: null, sex: 1 },
        { russian: 'ИЗОТОВНА', latin: null, sex: 1 },
        { russian: 'ИЗЯСЛАВНА', latin: null, sex: 1 },
        { russian: 'ИЗЯСЛАВОВНА', latin: null, sex: 1 },
        { russian: 'ИЛАРИОНОВНА', latin: null, sex: 1 },
        { russian: 'ИЛИОДОРОВНА', latin: null, sex: 1 },
        { russian: 'ИЛЛАРИОНОВНА', latin: null, sex: 1 },
        { russian: 'ИЛЬИНИЧНА', latin: null, sex: 1 },
        { russian: 'ИННОКЕНТИЕВНА', latin: null, sex: 1 },
        { russian: 'ИННОКЕНТЬЕВНА', latin: null, sex: 1 },
        { russian: 'ИОАННОВНА', latin: null, sex: 1 },
        { russian: 'ИОВНА', latin: null, sex: 1 },
        { russian: 'ИОНИЧНА', latin: null, sex: 1 },
        { russian: 'ИОСАФАТОВНА', latin: null, sex: 1 },
        { russian: 'ИОСИФОВНА', latin: null, sex: 1 },
        { russian: 'ИПАТИЕВНА', latin: null, sex: 1 },
        { russian: 'ИПАТОВНА', latin: null, sex: 1 },
        { russian: 'ИПАТЬЕВНА', latin: null, sex: 1 },
        { russian: 'ИППОЛИТОВНА', latin: null, sex: 1 },
        { russian: 'ИРАКЛИЕВНА', latin: null, sex: 1 },
        { russian: 'ИРИНАРХОВНА', latin: null, sex: 1 },
        { russian: 'ИРИНЕЕВНА', latin: null, sex: 1 },
        { russian: 'ИСААКИЕВНА', latin: null, sex: 1 },
        { russian: 'ИСААКОВНА', latin: null, sex: 1 },
        { russian: 'ИСАЕВНА', latin: null, sex: 1 },
        { russian: 'ИСАКИЕВНА', latin: null, sex: 1 },
        { russian: 'ИСАКОВНА', latin: null, sex: 1 },
        { russian: 'ИСИДОРОВНА', latin: null, sex: 1 },
        { russian: 'ИУСТИНОВНА', latin: null, sex: 1 },
        { russian: 'КАЗИМИРОВНА', latin: null, sex: 1 },
        { russian: 'КАЛЛИНИКОВНА', latin: null, sex: 1 },
        { russian: 'КАЛЛИСТОВНА', latin: null, sex: 1 },
        { russian: 'КАЛЛИСТРАТОВНА', latin: null, sex: 1 },
        { russian: 'КАПИТОНОВНА', latin: null, sex: 1 },
        { russian: 'КАРИОНОВНА', latin: null, sex: 1 },
        { russian: 'КАРЛОВНА', latin: null, sex: 1 },
        { russian: 'КАРПОВНА', latin: null, sex: 1 },
        { russian: 'КАСЬЯНОВНА', latin: null, sex: 1 },
        { russian: 'КИМОВНА', latin: null, sex: 1 },
        { russian: 'КИПРИАНОВНА', latin: null, sex: 1 },
        { russian: 'КИРИАКОВНА', latin: null, sex: 1 },
        { russian: 'КИРИКОВНА', latin: null, sex: 1 },
        { russian: 'КИРИЛЛОВНА', latin: null, sex: 1 },
        { russian: 'КИРОВНА', latin: null, sex: 1 },
        { russian: 'КИРСАНОВНА', latin: null, sex: 1 },
        { russian: 'КИРЬЯКОВНА', latin: null, sex: 1 },
        { russian: 'КЛАВДИЕВНА', latin: null, sex: 1 },
        { russian: 'КЛИМЕНТИЕВНА', latin: null, sex: 1 },
        { russian: 'КЛИМЕНТОВНА', latin: null, sex: 1 },
        { russian: 'КЛИМЕНТЬЕВНА', latin: null, sex: 1 },
        { russian: 'КЛИМОВНА', latin: null, sex: 1 },
        { russian: 'КОНДРАТИЕВНА', latin: null, sex: 1 },
        { russian: 'КОНДРАТОВНА', latin: null, sex: 1 },
        { russian: 'КОНДРАТЬЕВНА', latin: null, sex: 1 },
        { russian: 'КОНОНОВНА', latin: null, sex: 1 },
        { russian: 'КОНРАДОВНА', latin: null, sex: 1 },
        { russian: 'КОНСТАНТИНОВНА', latin: null, sex: 1 },
        { russian: 'КОРНЕЕВНА', latin: null, sex: 1 },
        { russian: 'КОРНЕЛИЕВНА', latin: null, sex: 1 },
        { russian: 'КОРНЕЛЬЕВНА', latin: null, sex: 1 },
        { russian: 'КОРНИЛИЕВНА', latin: null, sex: 1 },
        { russian: 'КОРНИЛОВНА', latin: null, sex: 1 },
        { russian: 'КОРНИЛЬЕВНА', latin: null, sex: 1 },
        { russian: 'КСЕНОФОНТОВНА', latin: null, sex: 1 },
        { russian: 'КУЗЬМИНИЧНА', latin: null, sex: 1 },
        { russian: 'КУПРИЯНОВНА', latin: null, sex: 1 },
        { russian: 'ЛАВРЕНТИЕВНА', latin: null, sex: 1 },
        { russian: 'ЛАВРЕНТЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЛАВРОВНА', latin: null, sex: 1 },
        { russian: 'ЛАЗАРЕВНА', latin: null, sex: 1 },
        { russian: 'ЛАРИОНОВНА', latin: null, sex: 1 },
        { russian: 'ЛЕОНАРДОВНА', latin: null, sex: 1 },
        { russian: 'ЛЕОНИДОВНА', latin: null, sex: 1 },
        { russian: 'ЛЕОНОВНА', latin: null, sex: 1 },
        { russian: 'ЛЕОНТИЕВНА', latin: null, sex: 1 },
        { russian: 'ЛЕОНТЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЛЕОПОЛЬДОВНА', latin: null, sex: 1 },
        { russian: 'ЛОГВИНОВНА', latin: null, sex: 1 },
        { russian: 'ЛОГГИНОВНА', latin: null, sex: 1 },
        { russian: 'ЛОНГИНОВНА', latin: null, sex: 1 },
        { russian: 'ЛУАРСАБОВНА', latin: null, sex: 1 },
        { russian: 'ЛУКИАНОВНА', latin: null, sex: 1 },
        { russian: 'ЛУКИНИЧНА', latin: null, sex: 1 },
        { russian: 'ЛУКЬЯНОВНА', latin: null, sex: 1 },
        { russian: 'ЛЬВОВНА', latin: null, sex: 1 },
        { russian: 'ЛЮБИМОВНА', latin: null, sex: 1 },
        { russian: 'ЛЮБОМИРОВНА', latin: null, sex: 1 },
        { russian: 'ЛЮЦИАНОВНА', latin: null, sex: 1 },
        { russian: 'МАВРИКИЕВНА', latin: null, sex: 1 },
        { russian: 'МАВРИКЬЕВНА', latin: null, sex: 1 },
        { russian: 'МАВРОВНА', latin: null, sex: 1 },
        { russian: 'МАВРОДИЕВНА', latin: null, sex: 1 },
        { russian: 'МАВРОДЬЕВНА', latin: null, sex: 1 },
        { russian: 'МАКАРИЕВНА', latin: null, sex: 1 },
        { russian: 'МАКАРОВНА', latin: null, sex: 1 },
        { russian: 'МАКАРЬЕВНА', latin: null, sex: 1 },
        { russian: 'МАКСИМИАНОВНА', latin: null, sex: 1 },
        { russian: 'МАКСИМИЛИАНОВНА', latin: null, sex: 1 },
        { russian: 'МАКСИМИЛЬЯНОВНА', latin: null, sex: 1 },
        { russian: 'МАКСИМОВНА', latin: null, sex: 1 },
        { russian: 'МАНУИЛОВНА', latin: null, sex: 1 },
        { russian: 'МАРАТОВНА', latin: null, sex: 1 },
        { russian: 'МАРДАРИЕВНА', latin: null, sex: 1 },
        { russian: 'МАРДАРЬЕВНА', latin: null, sex: 1 },
        { russian: 'МАРИАНОВНА', latin: null, sex: 1 },
        { russian: 'МАРИНОВНА', latin: null, sex: 1 },
        { russian: 'МАРКЕЛОВНА', latin: null, sex: 1 },
        { russian: 'МАРКИАНОВНА', latin: null, sex: 1 },
        { russian: 'МАРКОВНА', latin: null, sex: 1 },
        { russian: 'МАРЛЕНОВНА', latin: null, sex: 1 },
        { russian: 'МАРТИМЬЯНОВНА', latin: null, sex: 1 },
        { russian: 'МАРТИНИАНОВНА', latin: null, sex: 1 },
        { russian: 'МАРТИНОВНА', latin: null, sex: 1 },
        { russian: 'МАРТИРИЕВНА', latin: null, sex: 1 },
        { russian: 'МАРТИРЬЕВНА', latin: null, sex: 1 },
        { russian: 'МАРТЫНОВНА', latin: null, sex: 1 },
        { russian: 'МАРТЬЯНОВНА', latin: null, sex: 1 },
        { russian: 'МАТВЕЕВНА', latin: null, sex: 1 },
        { russian: 'МЕЛЕНТИЕВНА', latin: null, sex: 1 },
        { russian: 'МЕЛЕНТЬЕВНА', latin: null, sex: 1 },
        { russian: 'МЕЛЕТИЕВНА', latin: null, sex: 1 },
        { russian: 'МЕЛЕТЬЕВНА', latin: null, sex: 1 },
        { russian: 'МЕРКУЛОВНА', latin: null, sex: 1 },
        { russian: 'МЕРКУРИЕВНА', latin: null, sex: 1 },
        { russian: 'МЕРКУРЬЕВНА', latin: null, sex: 1 },
        { russian: 'МЕФОДИЕВНА', latin: null, sex: 1 },
        { russian: 'МЕФОДЬЕВНА', latin: null, sex: 1 },
        { russian: 'МЕЧИСЛАВНА', latin: null, sex: 1 },
        { russian: 'МЕЧИСЛАВОВНА', latin: null, sex: 1 },
        { russian: 'МИЛИЕВНА', latin: null, sex: 1 },
        { russian: 'МИНАЕВНА', latin: null, sex: 1 },
        { russian: 'МИНИЧНА', latin: null, sex: 1 },
        { russian: 'МИРОНОВНА', latin: null, sex: 1 },
        { russian: 'МИРОСЛАВНА', latin: null, sex: 1 },
        { russian: 'МИРОСЛАВОВНА', latin: null, sex: 1 },
        { russian: 'МИСАИЛОВНА', latin: null, sex: 1 },
        { russian: 'МИТРОФАНИЕВНА', latin: null, sex: 1 },
        { russian: 'МИТРОФАНОВНА', latin: null, sex: 1 },
        { russian: 'МИТРОФАНЬЕВНА', latin: null, sex: 1 },
        { russian: 'МИХАЙЛОВНА', latin: null, sex: 1 },
        { russian: 'МИХЕЕВНА', latin: null, sex: 1 },
        { russian: 'МОДЕСТОВНА', latin: null, sex: 1 },
        { russian: 'МОИСЕЕВНА', latin: null, sex: 1 },
        { russian: 'МОКЕЕВНА', latin: null, sex: 1 },
        { russian: 'МОКИЕВНА', latin: null, sex: 1 },
        { russian: 'МСТИСЛАВНА', latin: null, sex: 1 },
        { russian: 'МСТИСЛАВОВНА', latin: null, sex: 1 },
        { russian: 'НАЗАРИЕВНА', latin: null, sex: 1 },
        { russian: 'НАЗАРОВНА', latin: null, sex: 1 },
        { russian: 'НАЗАРЬЕВНА', latin: null, sex: 1 },
        { russian: 'НАРКИСОВНА', latin: null, sex: 1 },
        { russian: 'НАТАНОВНА', latin: null, sex: 1 },
        { russian: 'НАУМОВНА', latin: null, sex: 1 },
        { russian: 'НЕСТЕРОВНА', latin: null, sex: 1 },
        { russian: 'НЕСТОРОВНА', latin: null, sex: 1 },
        { russian: 'НЕФЁДОВНА', latin: null, sex: 1 },
        { russian: 'НИКАНДРОВНА', latin: null, sex: 1 },
        { russian: 'НИКАНОРОВНА', latin: null, sex: 1 },
        { russian: 'НИКИТИЧНА', latin: null, sex: 1 },
        { russian: 'НИКИФОРОВНА', latin: null, sex: 1 },
        { russian: 'НИКОДИМОВНА', latin: null, sex: 1 },
        { russian: 'НИКОЛАЕВНА', latin: null, sex: 1 },
        { russian: 'НИКОНОВНА', latin: null, sex: 1 },
        { russian: 'НИЛОВНА', latin: null, sex: 1 },
        { russian: 'НИФОНТОВНА', latin: null, sex: 1 },
        { russian: 'ОЛЕГОВНА', latin: null, sex: 1 },
        { russian: 'ОЛИМПИЕВНА', latin: null, sex: 1 },
        { russian: 'ОНИСИМОВНА', latin: null, sex: 1 },
        { russian: 'ОНУФРИЕВНА', latin: null, sex: 1 },
        { russian: 'ОРЕСТОВНА', latin: null, sex: 1 },
        { russian: 'ОСИПОВНА', latin: null, sex: 1 },
        { russian: 'ОСКАРОВНА', latin: null, sex: 1 },
        { russian: 'ОСТАПОВНА', latin: null, sex: 1 },
        { russian: 'ПАВЛИНОВНА', latin: null, sex: 1 },
        { russian: 'ПАВЛОВНА', latin: null, sex: 1 },
        { russian: 'ПАИСИЕВНА', latin: null, sex: 1 },
        { russian: 'ПАИСЬЕВНА', latin: null, sex: 1 },
        { russian: 'ПАЛЛАДИЕВНА', latin: null, sex: 1 },
        { russian: 'ПАЛЛАДЬЕВНА', latin: null, sex: 1 },
        { russian: 'ПАМФИЛИЕВНА', latin: null, sex: 1 },
        { russian: 'ПАМФИЛОВНА', latin: null, sex: 1 },
        { russian: 'ПАМФИЛЬЕВНА', latin: null, sex: 1 },
        { russian: 'ПАНКРАТИЕВНА', latin: null, sex: 1 },
        { russian: 'ПАНКРАТОВНА', latin: null, sex: 1 },
        { russian: 'ПАНКРАТЬЕВНА', latin: null, sex: 1 },
        { russian: 'ПАНТЕЛЕЕВНА', latin: null, sex: 1 },
        { russian: 'ПАНТЕЛЕЙМОНОВНА', latin: null, sex: 1 },
        { russian: 'ПАНФИЛОВНА', latin: null, sex: 1 },
        { russian: 'ПАРАМОНОВНА', latin: null, sex: 1 },
        { russian: 'ПАРМЕНОВНА', latin: null, sex: 1 },
        { russian: 'ПАРМЁНОВНА', latin: null, sex: 1 },
        { russian: 'ПАРФЕНИЕВНА', latin: null, sex: 1 },
        { russian: 'ПАРФЁНОВНА', latin: null, sex: 1 },
        { russian: 'ПАРФЕНТИЕВНА', latin: null, sex: 1 },
        { russian: 'ПАРФЕНТЬЕВНА', latin: null, sex: 1 },
        { russian: 'ПАРФЕНЬЕВНА', latin: null, sex: 1 },
        { russian: 'ПАТРИКЕЕВНА', latin: null, sex: 1 },
        { russian: 'ПАТРИКИЕВНА', latin: null, sex: 1 },
        { russian: 'ПАФНУТИЕВНА', latin: null, sex: 1 },
        { russian: 'ПАФНУТЬЕВНА', latin: null, sex: 1 },
        { russian: 'ПАХОМИЕВНА', latin: null, sex: 1 },
        { russian: 'ПАХОМОВНА', latin: null, sex: 1 },
        { russian: 'ПАХОМЬЕВНА', latin: null, sex: 1 },
        { russian: 'ПЕРФИЛИЕВНА', latin: null, sex: 1 },
        { russian: 'ПЕРФИЛЬЕВНА', latin: null, sex: 1 },
        { russian: 'ПЕТРОВНА', latin: null, sex: 1 },
        { russian: 'ПИМЕНОВНА', latin: null, sex: 1 },
        { russian: 'ПИТИРИМОВНА', latin: null, sex: 1 },
        { russian: 'ПЛАТОНОВНА', latin: null, sex: 1 },
        { russian: 'ПОЛИКАРПИЕВНА', latin: null, sex: 1 },
        { russian: 'ПОЛИКАРПОВНА', latin: null, sex: 1 },
        { russian: 'ПОЛИКАРПЬЕВНА', latin: null, sex: 1 },
        { russian: 'ПОРФИРИЕВНА', latin: null, sex: 1 },
        { russian: 'ПОРФИРОВНА', latin: null, sex: 1 },
        { russian: 'ПОРФИРЬЕВНА', latin: null, sex: 1 },
        { russian: 'ПОТАПИЕВНА', latin: null, sex: 1 },
        { russian: 'ПОТАПОВНА', latin: null, sex: 1 },
        { russian: 'ПОТАПЬЕВНА', latin: null, sex: 1 },
        { russian: 'ПРОВНА', latin: null, sex: 1 },
        { russian: 'ПРОКЛОВНА', latin: null, sex: 1 },
        { russian: 'ПРОКОПИЕВНА', latin: null, sex: 1 },
        { russian: 'ПРОКОПОВНА', latin: null, sex: 1 },
        { russian: 'ПРОКОПЬЕВНА', latin: null, sex: 1 },
        { russian: 'ПРОКОФИЕВНА', latin: null, sex: 1 },
        { russian: 'ПРОКОФЬЕВНА', latin: null, sex: 1 },
        { russian: 'ПРОТАСИЕВНА', latin: null, sex: 1 },
        { russian: 'ПРОТАСОВНА', latin: null, sex: 1 },
        { russian: 'ПРОТАСЬЕВНА', latin: null, sex: 1 },
        { russian: 'ПРОХОРОВНА', latin: null, sex: 1 },
        { russian: 'РАДИЕВНА', latin: null, sex: 1 },
        { russian: 'РАТМИРОВНА', latin: null, sex: 1 },
        { russian: 'РАФАИЛОВНА', latin: null, sex: 1 },
        { russian: 'РЕМОВНА', latin: null, sex: 1 },
        { russian: 'РЕНАТОВНА', latin: null, sex: 1 },
        { russian: 'РИНАТОВНА', latin: null, sex: 1 },
        { russian: 'РОБЕРТОВНА', latin: null, sex: 1 },
        { russian: 'РОДИОНОВНА', latin: null, sex: 1 },
        { russian: 'РОМАНОВНА', latin: null, sex: 1 },
        { russian: 'РОСТИСЛАВНА', latin: null, sex: 1 },
        { russian: 'РОСТИСЛАВОВНА', latin: null, sex: 1 },
        { russian: 'РУБЕНОВНА', latin: null, sex: 1 },
        { russian: 'РУВИМОВНА', latin: null, sex: 1 },
        { russian: 'РУДОЛЬФОВНА', latin: null, sex: 1 },
        { russian: 'РУСЛАНОВНА', latin: null, sex: 1 },
        { russian: 'РЮРИКОВНА', latin: null, sex: 1 },
        { russian: 'САВВАТЕЕВНА', latin: null, sex: 1 },
        { russian: 'САВВАТИЕВНА', latin: null, sex: 1 },
        { russian: 'САВВАТЬЕВНА', latin: null, sex: 1 },
        { russian: 'САВВИЧНА', latin: null, sex: 1 },
        { russian: 'САВЕЛИЕВНА', latin: null, sex: 1 },
        { russian: 'САВЁЛОВНА', latin: null, sex: 1 },
        { russian: 'САВЕЛЬЕВНА', latin: null, sex: 1 },
        { russian: 'САМОЙЛОВНА', latin: null, sex: 1 },
        { russian: 'САМСОНИЕВНА', latin: null, sex: 1 },
        { russian: 'САМСОНОВНА', latin: null, sex: 1 },
        { russian: 'САМСОНЬЕВНА', latin: null, sex: 1 },
        { russian: 'САМУИЛОВНА', latin: null, sex: 1 },
        { russian: 'СВИРИДОВНА', latin: null, sex: 1 },
        { russian: 'СВЯТОПОЛКОВНА', latin: null, sex: 1 },
        { russian: 'СВЯТОСЛАВНА', latin: null, sex: 1 },
        { russian: 'СВЯТОСЛАВОВНА', latin: null, sex: 1 },
        { russian: 'СЕБАСТЬЯНОВНА', latin: null, sex: 1 },
        { russian: 'СЕВАСТЬЯНОВНА', latin: null, sex: 1 },
        { russian: 'СЕВЕРИНОВНА', latin: null, sex: 1 },
        { russian: 'СЕВЕРЬЯНОВНА', latin: null, sex: 1 },
        { russian: 'СЕЛИВАНОВНА', latin: null, sex: 1 },
        { russian: 'СЕЛИВЁРСТОВНА', latin: null, sex: 1 },
        { russian: 'СЕЛИФАНОВНА', latin: null, sex: 1 },
        { russian: 'СЕМЁНОВНА', latin: null, sex: 1 },
        { russian: 'СЕРАПИОНОВНА', latin: null, sex: 1 },
        { russian: 'СЕРАФИМОВНА', latin: null, sex: 1 },
        { russian: 'СЕРГЕЕВНА', latin: null, sex: 1 },
        { russian: 'СИГИЗМУНДОВНА', latin: null, sex: 1 },
        { russian: 'СИДОРОВНА', latin: null, sex: 1 },
        { russian: 'СИЛАНОВНА', latin: null, sex: 1 },
        { russian: 'СИЛАНТИЕВНА', latin: null, sex: 1 },
        { russian: 'СИЛАНТЬЕВНА', latin: null, sex: 1 },
        { russian: 'СИЛОВНА', latin: null, sex: 1 },
        { russian: 'СИЛУЯНОВНА', latin: null, sex: 1 },
        { russian: 'СИЛЬВАНОВНА', latin: null, sex: 1 },
        { russian: 'СИЛЬВЕСТРОВНА', latin: null, sex: 1 },
        { russian: 'СИМЕОНОВНА', latin: null, sex: 1 },
        { russian: 'СИМОНОВНА', latin: null, sex: 1 },
        { russian: 'СОЗОНОВНА', latin: null, sex: 1 },
        { russian: 'СОЗОНТИЕВНА', latin: null, sex: 1 },
        { russian: 'СОЗОНТОВНА', latin: null, sex: 1 },
        { russian: 'СОЗОНТЬЕВНА', latin: null, sex: 1 },
        { russian: 'СОКРАТОВНА', latin: null, sex: 1 },
        { russian: 'СОЛОМОНОВНА', latin: null, sex: 1 },
        { russian: 'СОСИПАТРОВНА', latin: null, sex: 1 },
        { russian: 'СОФОНИЕВНА', latin: null, sex: 1 },
        { russian: 'СОФОНОВНА', latin: null, sex: 1 },
        { russian: 'СОФОНЬЕВНА', latin: null, sex: 1 },
        { russian: 'СОФРОНИЕВНА', latin: null, sex: 1 },
        { russian: 'СОФРОНОВНА', latin: null, sex: 1 },
        { russian: 'СОФРОНЬЕВНА', latin: null, sex: 1 },
        { russian: 'СПАРТАКОВНА', latin: null, sex: 1 },
        { russian: 'СПИРИДОНИЕВНА', latin: null, sex: 1 },
        { russian: 'СПИРИДОНОВНА', latin: null, sex: 1 },
        { russian: 'СПИРИДОНЬЕВНА', latin: null, sex: 1 },
        { russian: 'СТАНИСЛАВНА', latin: null, sex: 1 },
        { russian: 'СТАНИСЛАВОВНА', latin: null, sex: 1 },
        { russian: 'СТАХИЕВНА', latin: null, sex: 1 },
        { russian: 'СТЕПАНОВНА', latin: null, sex: 1 },
        { russian: 'СТРАТОНИКОВНА', latin: null, sex: 1 },
        { russian: 'СЫСОЕВНА', latin: null, sex: 1 },
        { russian: 'ТАРАСОВНА', latin: null, sex: 1 },
        { russian: 'ТЕРЕНТИЕВНА', latin: null, sex: 1 },
        { russian: 'ТЕРЕНТЬЕВНА', latin: null, sex: 1 },
        { russian: 'ТЕРТИЕВНА', latin: null, sex: 1 },
        { russian: 'ТИМОФЕЕВНА', latin: null, sex: 1 },
        { russian: 'ТИМУРОВНА', latin: null, sex: 1 },
        { russian: 'ТИТОВНА', latin: null, sex: 1 },
        { russian: 'ТИХОНОВНА', latin: null, sex: 1 },
        { russian: 'ТРИФОНОВНА', latin: null, sex: 1 },
        { russian: 'ТРОФИМОВНА', latin: null, sex: 1 },
        { russian: 'УАРОВНА', latin: null, sex: 1 },
        { russian: 'УВАРОВНА', latin: null, sex: 1 },
        { russian: 'УЛЬЯНОВНА', latin: null, sex: 1 },
        { russian: 'УСТИНОВНА', latin: null, sex: 1 },
        { russian: 'ФАБИАНОВНА', latin: null, sex: 1 },
        { russian: 'ФАДДЕЕВНА', latin: null, sex: 1 },
        { russian: 'ФАДЕЕВНА', latin: null, sex: 1 },
        { russian: 'ФАЛАЛЕЕВНА', latin: null, sex: 1 },
        { russian: 'ФАТЬЯНОВНА', latin: null, sex: 1 },
        { russian: 'ФЁДОРОВНА', latin: null, sex: 1 },
        { russian: 'ФЕДОСЕЕВНА', latin: null, sex: 1 },
        { russian: 'ФЕДОСИЕВНА', latin: null, sex: 1 },
        { russian: 'ФЕДОСОВНА', latin: null, sex: 1 },
        { russian: 'ФЕДОСЬЕВНА', latin: null, sex: 1 },
        { russian: 'ФЕДОТИЕВНА', latin: null, sex: 1 },
        { russian: 'ФЕДОТОВНА', latin: null, sex: 1 },
        { russian: 'ФЕДОТЬЕВНА', latin: null, sex: 1 },
        { russian: 'ФЕДУЛОВНА', latin: null, sex: 1 },
        { russian: 'ФЕЛИКСОВНА', latin: null, sex: 1 },
        { russian: 'ФЕОГНОСТОВНА', latin: null, sex: 1 },
        { russian: 'ФЕОКТИСТОВНА', latin: null, sex: 1 },
        { russian: 'ФЕОФАНОВНА', latin: null, sex: 1 },
        { russian: 'ФЕОФИЛАКТОВНА', latin: null, sex: 1 },
        { russian: 'ФЕОФИЛОВНА', latin: null, sex: 1 },
        { russian: 'ФЕРАПОНТОВНА', latin: null, sex: 1 },
        { russian: 'ФИЛАРЕТОВНА', latin: null, sex: 1 },
        { russian: 'ФИЛАТОВНА', latin: null, sex: 1 },
        { russian: 'ФИЛИМОНОВНА', latin: null, sex: 1 },
        { russian: 'ФИЛИПИЕВНА', latin: null, sex: 1 },
        { russian: 'ФИЛИППОВНА', latin: null, sex: 1 },
        { russian: 'ФИЛИПЬЕВНА', latin: null, sex: 1 },
        { russian: 'ФИЛОФЕЕВНА', latin: null, sex: 1 },
        { russian: 'ФИРСОВНА', latin: null, sex: 1 },
        { russian: 'ФЛЕГОНТОВНА', latin: null, sex: 1 },
        { russian: 'ФЛОРЕНТИЕВНА', latin: null, sex: 1 },
        { russian: 'ФЛОРЕНТИНОВНА', latin: null, sex: 1 },
        { russian: 'ФЛОРЕНТЬЕВНА', latin: null, sex: 1 },
        { russian: 'ФЛОРИАНОВНА', latin: null, sex: 1 },
        { russian: 'ФОКИЧНА', latin: null, sex: 1 },
        { russian: 'ФОМИНИЧНА', latin: null, sex: 1 },
        { russian: 'ФОРТУНАТОВНА', latin: null, sex: 1 },
        { russian: 'ФОТИЕВНА', latin: null, sex: 1 },
        { russian: 'ФОТЬЕВНА', latin: null, sex: 1 },
        { russian: 'ФРИДРИХОВНА', latin: null, sex: 1 },
        { russian: 'ФРОЛОВНА', latin: null, sex: 1 },
        { russian: 'ХАРИТОНИЕВНА', latin: null, sex: 1 },
        { russian: 'ХАРИТОНОВНА', latin: null, sex: 1 },
        { russian: 'ХАРИТОНЬЕВНА', latin: null, sex: 1 },
        { russian: 'ХАРЛАМОВНА', latin: null, sex: 1 },
        { russian: 'ХАРЛАМПИЕВНА', latin: null, sex: 1 },
        { russian: 'ХАРЛАМПОВНА', latin: null, sex: 1 },
        { russian: 'ХАРЛАМПЬЕВНА', latin: null, sex: 1 },
        { russian: 'ХРИСАНФОВНА', latin: null, sex: 1 },
        { russian: 'ХРИСТОФОРОВНА', latin: null, sex: 1 },
        { russian: 'ЭДУАРДОВНА', latin: null, sex: 1 },
        { russian: 'ЭМИЛИЕВНА', latin: null, sex: 1 },
        { russian: 'ЭМИЛЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЭММАНУИЛОВНА', latin: null, sex: 1 },
        { russian: 'ЭРАЗМОВНА', latin: null, sex: 1 },
        { russian: 'ЭРАСТОВНА', latin: null, sex: 1 },
        { russian: 'ЭРНЕСТОВНА', latin: null, sex: 1 },
        { russian: 'ЭРНСТОВНА', latin: null, sex: 1 },
        { russian: 'ЮВЕНАЛИЕВНА', latin: null, sex: 1 },
        { russian: 'ЮВЕНАЛЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЮЛИАНОВНА', latin: null, sex: 1 },
        { russian: 'ЮЛИЕВНА', latin: null, sex: 1 },
        { russian: 'ЮЛЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЮРЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЮСТИНОВНА', latin: null, sex: 1 },
        { russian: 'ЯКИМОВНА', latin: null, sex: 1 },
        { russian: 'ЯКОВЛЕВНА', latin: null, sex: 1 },
        { russian: 'ЯКУБОВНА', latin: null, sex: 1 },
        { russian: 'ЯНОВНА', latin: null, sex: 1 },
        { russian: 'ЯНУАРИЕВНА', latin: null, sex: 1 },
        { russian: 'ЯНУАРЬЕВНА', latin: null, sex: 1 },
        { russian: 'ЯРОСЛАВНА', latin: null, sex: 1 },
        { russian: 'ЯРОСЛАВОВНА', latin: null, sex: 1 },
    ];
}
